msgid ""
msgstr ""
"POT-Creation-Date: 2024-06-27 10:13-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: fr\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. js-lingui-id: ++rVAm
msgid "Social Media"
msgstr "Réseaux sociaux"

#. js-lingui-id: +0B+ue
msgid "Projects"
msgstr "Projets"

#. js-lingui-id: +0n5e0
msgid "Entry date: "
msgstr "Date d'entrée: "

#. js-lingui-id: +0qfCN
msgid "Previous Employer"
msgstr "Employeur précédent"

#. js-lingui-id: +1z7P1
msgid "We understand you were interested in this property. While it's no longer available, we have many other exceptional properties that might be perfect for you."
msgstr "Nous comprenons que vous étiez intéressé par cette propriété. Bien que celle-ci ne soit plus disponible, nous avons de nombreuses autres propriétés exceptionnelles qui pourraient être parfaites pour vous."

#. js-lingui-id: +2CdJq
msgid "Request additional co-signers"
msgstr "Demander des co-signataires supplémentaires"

#. js-lingui-id: +2Venh
msgid "Credit Check Request"
msgstr "Demande de vérification de crédit"

#. js-lingui-id: +2ponR
msgid "Landlord Information"
msgstr "Informations sur le propriétaire"

#. js-lingui-id: +7Oup8
msgid "Resend Invite"
msgstr "Renvoyer l'invitation"

#. js-lingui-id: +8Nek/
msgid "Monthly"
msgstr "Mensuel"

#. js-lingui-id: +D5Ct6
msgid "Previous Rental Property Address"
msgstr "Adresse de la propriété de location précédente"

#. js-lingui-id: +E+RKY
msgid "We strongly recommend to a SSN to our secured form to improve the chances to obtain a credit report. This information is not saved and is only used to verify your identity when running the credit check."
msgstr "Nous recommandons vivement de fournir un numéro de sécurité sociale à notre formulaire sécurisé pour améliorer les chances d'obtenir un rapport de crédit. Cette information n'est pas enregistrée et est uniquement utilisée pour vérifier votre identité lors de l'exécution de la vérification de crédit."

#. js-lingui-id: +FjWgX
msgid "Thu"
msgstr "Jeu"

#. js-lingui-id: +GmWz3
msgid "A friend who will be a co-applicant"
msgstr "Un ami qui sera un co-applicant"

#. js-lingui-id: +HT37C
msgid "Apply for a Property"
msgstr "Faire une demande de propriété"

#. js-lingui-id: +I4pWD
msgid "Company/Employer Name"
msgstr "Nom de l'entreprise/employeur"

#. js-lingui-id: +IrOzl
msgid "Legal Disclaimer"
msgstr "Avis juridique"

#. js-lingui-id: +JJZXx
msgid "This title will be used in external promotions"
msgstr "Ce titre sera utilisé dans les promotions externes"

#. js-lingui-id: +LhgAJ
msgid "Background Check Not Run"
msgstr "Vérification des antécédents non effectuée"

#. js-lingui-id: +MNb3v
msgid "Previous rental payment records"
msgstr "Enregistrements de paiements locatifs précédents"

#. js-lingui-id: +NCBA+
msgid "Specialized Lenders"
msgstr "Prêteurs spécialisés"

#. js-lingui-id: +Nj6xm
msgid "A user associated with this e-mail was found in the application. Verify the email provided and try again."
msgstr "Un utilisateur associé à cet e-mail a été trouvé dans l'application. Vérifiez l'e-mail fourni et réessayez."

#. js-lingui-id: +OHQ0U
msgid "The property manager provided the following reason:"
msgstr "Le gestionnaire de propriété a fourni la raison suivante :"

#. js-lingui-id: +OJ3GQ
msgid "Housing Costs"
msgstr "Coûts du logement"

#. js-lingui-id: +P/gFR
msgid "Takes less than 5 minutes"
msgstr "Prend moins de 5 minutes"

#. js-lingui-id: +PsgaI
msgid "The preferred language is required"
msgstr "La langue préférée est obligatoire"

#. js-lingui-id: +SSxNi
msgid "Start typing your address..."
msgstr "Commencez à taper votre adresse..."

#. js-lingui-id: +VporH
msgid "Reject Application"
msgstr "Rejeter la candidature"

#. js-lingui-id: +YnJ0j
msgid "Listing updated successfully"
msgstr "Liste mise à jour avec succès"

#. js-lingui-id: +bay9a
msgid "This submission was on hold"
msgstr "Cette soumission était en attente"

#. js-lingui-id: +eFgSm
msgid "Application in Progress"
msgstr "Candidature en cours"

#. js-lingui-id: +f3Wkz
msgid "This applicant did not provide any references to check. Please contact them to provide references."
msgstr "Ce candidat n'a fourni aucune référence à vérifier. Veuillez les contacter pour fournir des références."

#. js-lingui-id: +hw7+q
msgid "Add a Visit Agent"
msgstr "Ajouter un agent de visite"

#. js-lingui-id: +kf9vT
msgid "Debt Categories"
msgstr "Catégories de dettes"

#. js-lingui-id: +kjk+9
msgid "Age 18+"
msgstr "Âge 18+"

#. js-lingui-id: +kzc5I
msgid "New from last time:"
msgstr "Nouveau depuis la dernière fois :"

#. js-lingui-id: +nPx/9
msgid "near"
msgstr "près"

#. js-lingui-id: +naPgK
msgid "Your personal information is protected and only shared with the landlord"
msgstr "Vos informations personnelles sont protégées et ne sont partagées qu'avec le propriétaire"

#. js-lingui-id: +oQhet
msgid "Import Preview"
msgstr "Aperçu de l'importation"

#. js-lingui-id: +oj2Lm
msgid "Provide the tenant's information to get started"
msgstr "Fournissez les informations du locataire pour commencer"

#. js-lingui-id: +vTvJs
msgid "Rental Application"
msgstr "Candidature de location"

#. js-lingui-id: +x3bPj
msgid "Unnamed Building"
msgstr "Bâtiment sans nom"

#. js-lingui-id: +x7aMr
msgid "Max sqft"
msgstr "Max pieds carrés"

#. js-lingui-id: +yBm0S
msgid "Total Buildings"
msgstr "Total des bâtiments"

#. js-lingui-id: +z9xdk
msgid "Promote"
msgstr "Promouvoir"

#. js-lingui-id: +zy2Nq
msgid "Type"
msgstr "Type"

#. js-lingui-id: /0C4ok
msgid "Your application did not meet our required credit score for this property."
msgstr "Votre demande ne correspond pas à notre score de crédit requis pour cette propriété."

#. js-lingui-id: /1/ej2
msgid "Completed on {insuranceDate}"
msgstr "Complété le {insuranceDate}"

#. js-lingui-id: /1r4bR
msgid "Current Tenant"
msgstr "Locataire actuel"

#. js-lingui-id: /3IBTP
msgid "Rejected Reasons"
msgstr "Raison du rejet"

#. js-lingui-id: /4TFrF
msgid "Full Name"
msgstr "Nom complet"

#. js-lingui-id: /73IfE
msgid "Search applicants, submissions and more..."
msgstr "Rechercher des candidats, des soumissions et plus..."

#. js-lingui-id: /CoN1P
msgid "Max size"
msgstr "Taille maximale"

#. js-lingui-id: /H3Pek
msgid "Current applicants"
msgstr "Candidats actuels"

#. js-lingui-id: /IX/7x
msgid "Other"
msgstr "Autre"

#. js-lingui-id: /JrclD
msgid "{tooltipText}: Good"
msgstr "{tooltipText}: Bon"

#. js-lingui-id: /K2CvV
msgid "Template"
msgstr "Modèle"

#. js-lingui-id: /LCAwL
msgid "In progress"
msgstr "En cours"

#. js-lingui-id: /MXLJb
msgid "Lease"
msgstr "Bail"

#. js-lingui-id: /RCmK9
msgid "Car Loan"
msgstr "Prêt auto"

#. js-lingui-id: /Rirn3
msgid "Run additional check"
msgstr "Effectuer une vérification supplémentaire"

#. js-lingui-id: /YOcwB
msgid "Gain comprehensive insights into background history and public records to make informed decisions with confidence."
msgstr "Obtenez des informations complètes sur les antécédents et les dossiers publics pour prendre des décisions éclairées en toute confiance."

#. js-lingui-id: /aod7d
msgid "Asset Amount"
msgstr "Montant des actifs"

#. js-lingui-id: /hL6/r
msgid "User deleted successfully."
msgstr "L'utilisateur a été supprimé avec succès."

#. js-lingui-id: /j9zPO
msgid "Date of birth is required"
msgstr "La date de naissance est requise"

#. js-lingui-id: /mfICu
msgid "Fees"
msgstr "Frais"

#. js-lingui-id: /pkNvF
msgid "Amenities"
msgstr "Commodités"

#. js-lingui-id: /tNxAh
msgid "Confirm Your Selection"
msgstr "Confirmer votre sélection"

#. js-lingui-id: /uM7L8
msgid "Not Included"
msgstr "Non inclus"

#. js-lingui-id: /wzAIt
msgid "The user receiving personal information about a prospective tenant acknowledges and agrees that Eversa shall not, under any circumstances, be held liable for any direct or indirect damages resulting from the transmission, interpretation, or use of inaccurate, incomplete, or incorrect information. This applies whether such information was initially provided by the prospective tenant, submitted by the user, or supplied by third parties, including credit reporting agencies or other external partners."
msgstr "L'utilisateur recevant des informations personnelles sur un locataire potentiel reconnaît et accepte que Eversa ne soit pas responsable de toute perte ou dommage direct ou indirect résultant de la transmission, de l'interprétation ou de l'utilisation d'informations inexactes, incomplètes ou incorrectes. Cela s'applique quelle que soit la source de ces informations (initialement fournies par le locataire potentiel, soumises par l'utilisateur ou fournies par des tiers, y compris des agences de crédit ou des partenaires externes)."

#. js-lingui-id: 07/Ujr
msgid "Partial Applications"
msgstr "Candidatures partielles"

#. js-lingui-id: 07DgB4
msgid "Search Applicants"
msgstr "Rechercher des candidats"

#. js-lingui-id: 07kxvV
msgid "Delivery Setup"
msgstr "Configuration de la livraison"

#. js-lingui-id: 0I0Hac
msgid "Important Notice"
msgstr "Avis important"

#. js-lingui-id: 0J/aTA
msgid "I understand that this accommodation does not allow smoking within the premises"
msgstr "Je comprends que cet hébergement n'autorise pas le tabagisme à l'intérieur des locaux"

#. js-lingui-id: 0KDB7S
msgid "Select Entry Date"
msgstr "Sélectionner la date d'entrée"

#. js-lingui-id: 0M0CU4
msgid "This is a high salary. Please confirm it's correct."
msgstr "Ce salaire est élevé. Veuillez le confirmer."

#. js-lingui-id: 0R1H0M
msgid "Why do you charge application fees?"
msgstr "Pourquoi facturez-vous des frais de candidature?"

#. js-lingui-id: 0VABa/
msgid "Current Rent"
msgstr "Loyer actuel"

#. js-lingui-id: 0WeP54
msgid "Add a co-applicant"
msgstr "Ajouter un co-applicant"

#. js-lingui-id: 0a/zKn
msgid "Application Status: Under Reconsideration"
msgstr "Statut de la candidature : En cours de reconsidération"

#. js-lingui-id: 0cOhlH
msgid "Upload Units"
msgstr "Téléverser des unités"

#. js-lingui-id: 0f7U0k
msgid "Wed"
msgstr "Mer"

#. js-lingui-id: 0fzruQ
msgid "Email Preferences"
msgstr "Préférences de courriel"

#. js-lingui-id: 0oPWCt
msgid "{street}, {city}, Unit# {unitIdx}"
msgstr "{street}, {city}, Unit# {unitIdx}"

#. js-lingui-id: 0oXwkF
msgid "I have received permission from the applicant to run a credit check."
msgstr "J'ai reçu l'autorisation du candidat pour effectuer une vérification de crédit."

#. js-lingui-id: 0oYdMY
msgid "Consent Verification"
msgstr "Vérification de consentement"

#. js-lingui-id: 0p2lf/
msgid "Excellent"
msgstr "Excellent"

#. js-lingui-id: 0tWyKI
msgid "Capture important financial information to help you make informed decisions."
msgstr "Capturez des informations financières importantes pour vous aider à prendre des décisions éclairées."

#. js-lingui-id: 0vxZXz
msgid "Guarantor Documents"
msgstr "Documents de garantie"

#. js-lingui-id: 0xD8Of
msgid "The page you're looking for doesn't exist or has been moved."
msgstr "La page que vous cherchez n'existe plus ou a été déplacée."

#. js-lingui-id: 0yPSCj
msgid "High Risk"
msgstr "Risque élevé"

#. js-lingui-id: 0zR8pa
msgid "Listings Management View Options"
msgstr "Options de vue de gestion des annonces"

#. js-lingui-id: 1+4SpX
msgid "Send Email Invitation"
msgstr "Envoyer une invitation par courriel"

#. js-lingui-id: 1+DWdk
msgid "Listing created"
msgstr "Annonce créée"

#. js-lingui-id: 15DaP1
msgid "View lease details"
msgstr "Voir les détails du bail"

#. js-lingui-id: 169++X
msgid "No. Credits Checks"
msgstr "No. de vérifications de crédit"

#. js-lingui-id: 1718Q+
msgid "Issues"
msgstr "Problèmes"

#. js-lingui-id: 19xfly
msgid "Manage all units across buildings in this project"
msgstr "Gérer toutes les unités à travers les bâtiments de ce projet"

#. js-lingui-id: 1B+Zhk
msgid "We are currently processing the report. Come back later."
msgstr "Nous traitons actuellement le rapport. Revenez plus tard."

#. js-lingui-id: 1B5tzk
msgid "Unlimited users"
msgstr "Utilisateurs illimités"

#. js-lingui-id: 1DBGsz
msgid "Notes"
msgstr "Notes"

#. js-lingui-id: 1DRSRK
msgid "You must take action on this submission"
msgstr "Vous devez prendre une action sur cette soumission"

#. js-lingui-id: 1Dbl+5
msgid "Income verification"
msgstr "Vérification du revenu"

#. js-lingui-id: 1I1xeb
msgid "I understand that this accommodation does not accept pets and confirm that I have no pets and no adopted ones during my lease"
msgstr "Je comprends que cet hébergement n'autorise pas les animaux de compagnie et confirme que je n'ai pas d'animaux de compagnie et aucun adoptés durant mon bail"

#. js-lingui-id: 1I8JQd
msgid "Final review and decision by the landlord"
msgstr "Examen final et décision par le propriétaire"

#. js-lingui-id: 1JMWG3
msgid "Legal Status"
msgstr "Statut légal"

#. js-lingui-id: 1Jif/R
msgid "New application"
msgstr "Nouvelle demande"

#. js-lingui-id: 1PqICB
msgid "Only XLSX files are accepted"
msgstr "Seuls les fichiers XLSX sont acceptés"

#. js-lingui-id: 1TNIig
msgid "Open"
msgstr "Compte Ouvert"

#. js-lingui-id: 1UzENP
msgid "No"
msgstr "Non"

#. js-lingui-id: 1V5RP8
msgid "Go to my application"
msgstr "Voir mon application"

#. js-lingui-id: 1Y7n4e
msgid "Assign yourself"
msgstr "Assignez-vous"

#. js-lingui-id: 1ZaQUH
msgid "Last name"
msgstr "Nom de famille"

#. js-lingui-id: 1aEY/3
msgid "Your candidate submissions"
msgstr "Vos candidatures"

#. js-lingui-id: 1bTCU8
msgid "Application & Analysis Fee"
msgstr "Frais de candidature et d'analyse"

#. js-lingui-id: 1c0ou9
msgid "image(s) uploaded"
msgstr "image(s) téléversée(s)"

#. js-lingui-id: 1dkv5X
msgid "Current Status"
msgstr "Statut actuel"

#. js-lingui-id: 1gdNSY
msgid "Needs Attention"
msgstr "Nécessite une attention"

#. js-lingui-id: 1geQCt
msgid "Floor Plan"
msgstr "Plan d'étage"

#. js-lingui-id: 1iBTV8
msgid "Incompleted"
msgstr "Incomplété"

#. js-lingui-id: 1imxKE
msgid "Choose how you'd like to manage the applicants in this submission"
msgstr "Choisissez comment vous souhaitez gérer les candidats dans cette soumission"

#. js-lingui-id: 1mt+ts
msgid "Apartment/Unit #"
msgstr "Appartement/Unité #"

#. js-lingui-id: 1t/NnN
msgid "Reject"
msgstr "Rejeter"

#. js-lingui-id: 1yFAiI
msgid "Insurance"
msgstr "Assurance"

#. js-lingui-id: 2+PwyN
msgid "Credit Utilization Threshold"
msgstr "Seuil de crédit utilisé"

#. js-lingui-id: 2//P6D
msgid "Waiting for results"
msgstr "En attente des résultats"

#. js-lingui-id: 2/iT/I
msgid "Additional Financial Documentation"
msgstr "Documents financiers supplémentaires"

#. js-lingui-id: 21Cw3b
msgid "Apply In Person"
msgstr "Postuler en personne"

#. js-lingui-id: 22F2Jm
msgid "The information obtained will be used solely for the purpose of your rental application and will not be shared with third parties without your consent, except as required by law."
msgstr "Les informations obtenues seront utilisées exclusivement à des fins de votre candidature de location et ne seront pas partagées avec des tiers sans votre consentement, sauf en cas de nécessité légale."

#. js-lingui-id: 23pyLB
msgid "Create New Tenant"
msgstr "Créer un nouveau locataire"

#. js-lingui-id: 26dtmt
msgid "Show all tasks"
msgstr "Afficher toutes les tâches"

#. js-lingui-id: 27YFs9
msgid "Debt Overview"
msgstr "Aperçu des dettes"

#. js-lingui-id: 2BBAbc
msgid "List"
msgstr "Liste"

#. js-lingui-id: 2LM5Sp
msgid "Quebec bankruptcy records"
msgstr "Enregistrements de faillite du Québec"

#. js-lingui-id: 2Uup2p
msgid "I understand that there is <strong>{limit}</strong> parking space included in the unit."
msgstr "Je comprends qu'il y a <strong>{limit}</strong> places de stationnement incluses dans l'unité."

#. js-lingui-id: 2WPrlc
msgid "You confirm that the information provided is accurate and up to date. Any false or misleading information may affect the outcome of your application."
msgstr "Vous confirmez que les informations fournies sont exactes et à jour. Toute information fausse ou trompeuse peut affecter le résultat de votre candidature."

#. js-lingui-id: 2ZgzTU
msgid "Enter the email of the tenant that you want to invite"
msgstr "Entrez l'email du locataire que vous souhaitez inviter"

#. js-lingui-id: 2fokfN
msgid "Please provide one of the following documents:"
msgstr "Veuillez fournir l'un des documents suivants:"

#. js-lingui-id: 2kAD9a
msgid "Important consequences:"
msgstr "Conséquences importantes :"

#. js-lingui-id: 2njB29
msgid "Enter your current monthly rent"
msgstr "Entrez votre loyer mensuel actuel"

#. js-lingui-id: 2q/Q7x
msgid "Visibility"
msgstr "Visibilité"

#. js-lingui-id: 2tPLae
msgid "Please verify the applicant's information and confirm consent."
msgstr "Veuillez vérifier les informations du candidat et confirmer le consentement."

#. js-lingui-id: 2tb9I3
msgid "Documents uploaded"
msgstr "Documents téléchargés"

#. js-lingui-id: 306na7
msgid "Add another applicant"
msgstr "Ajouter un autre candidat"

#. js-lingui-id: 32DXjW
msgid "Industry standard is 30% or less for optimal credit health and financial stability"
msgstr "Norme industrielle : 30% ou moins pour un crédit optimal et une stabilité financière"

#. js-lingui-id: 33bdMY
msgid "Invite tenant directly"
msgstr "Inviter le locataire directement"

#. js-lingui-id: 37YEFk
msgid "Years at current job is required unless you are retired"
msgstr "Le nombre d'années à l'emploi actuel est requis sauf si vous êtes retraité"

#. js-lingui-id: 37chR6
msgid "Show all listings"
msgstr "Afficher toutes les annonces"

#. js-lingui-id: 37yDkn
msgid "Enable submission assignement to expand platform capabilities by increasing available features. This adds the ability to assign submissions to users, enhancing management flexibility and collaboration."
msgstr "Activer l'assignation des soumissions pour étendre les capacités de la plateforme en augmentant les fonctionnalités disponibles. Cela ajoute la possibilité d'assigner des soumissions aux utilisateurs, améliorant ainsi la flexibilité de gestion et la collaboration."

#. js-lingui-id: 38J2b8
msgid "Credit Report Prices"
msgstr "Prix des rapports de crédit"

#. js-lingui-id: 3C9jEv
msgid "Recent documentation showing your current income"
msgstr "Documents récents montrant votre revenu actuel"

#. js-lingui-id: 3CuNjX
msgid "Payment Success"
msgstr "Paiement réussi"

#. js-lingui-id: 3DCojC
msgid "{tenantName} rental: {type} with {bedrooms} bedrooms in {city}, {address}"
msgstr "Location {tenantName}: {type} {bedrooms} chambres à {city}, {address}"

#. js-lingui-id: 3IKOYC
msgid "Add a reason for discarding this submission"
msgstr "Ajouter une raison pour rejeter cette soumission"

#. js-lingui-id: 3JPSB1
msgid "Endorser/Guarantor"
msgstr "Co-signataire/Garant"

#. js-lingui-id: 3JPTpK
msgid "Manage your tasks efficiently and prioritize your day"
msgstr "Gérez vos tâches efficacement et hiérarchisez votre journée"

#. js-lingui-id: 3QuwJC
msgid "No units found with current filters. Try adjusting your filters or add units."
msgstr "Aucune unité trouvée avec les filtres actuels. Essayez d'ajuster vos filtres ou d'ajouter des unités."

#. js-lingui-id: 3TcQ9I
msgid "Send to submissions"
msgstr "Envoyer vers soumissions"

#. js-lingui-id: 3UBCCI
msgid "Enter English title"
msgstr "Entrez le titre en anglais"

#. js-lingui-id: 3Xu0UZ
msgid "{differenceInDays} days ago"
msgstr "Il y a {differenceInDays} jours"

#. js-lingui-id: 3aUB6I
msgid "Re-open this lead"
msgstr "Rouvrir ce prospect"

#. js-lingui-id: 3b4kt0
msgid "bathrooms"
msgstr "salle de bain"

#. js-lingui-id: 3bbqLM
msgid "Attention Required"
msgstr "Attention requise"

#. js-lingui-id: 3bvkPk
msgid "No assignee"
msgstr "Aucun responsable"

#. js-lingui-id: 3dO6rb
msgid "Passport"
msgstr "Passeport"

#. js-lingui-id: 3dpU/b
msgid "Send to leads"
msgstr "Envoyer aux prospects"

#. js-lingui-id: 3j3MnF
msgid "Enter your Facebook Pixel ID (e.g., XXXXXXXXXXXXXXXXXX)"
msgstr "Entrez l'ID de votre pixel Facebook (e.g., XXXXXXXXXXXXXXXXXX)"

#. js-lingui-id: 3jydzm
msgid "Secure payment with no hidden fees or recurring charges"
msgstr "Paiement sécurisé sans frais cachés ou frais récurrents"

#. js-lingui-id: 3kmOfT
msgid "Mortgage"
msgstr "Prêt hypothécaire"

#. js-lingui-id: 3lqHZn
msgid "Analyzing AI Salary"
msgstr "Analyse du salaire par IA"

#. js-lingui-id: 3nRszo
msgid "Partial"
msgstr "Partiel"

#. js-lingui-id: 3oJT1Y
msgid "Meets Minimum Score"
msgstr "Répond au score minimum"

#. js-lingui-id: 3qk2V6
msgid "Total balances"
msgstr "Total des soldes"

#. js-lingui-id: 3rsvtZ
msgid "You can access the tenant's view of their application to complete missing information or correct issues on their behalf."
msgstr "Vous pouvez accéder à la vue du locataire de leur candidature pour compléter les informations manquantes ou corriger les problèmes en leur nom."

#. js-lingui-id: 3s7lyE
msgid "We're not quite ready for this yet!"
msgstr "Nous ne sommes pas encore tout à fait prêts pour cela !"

#. js-lingui-id: 3tIWwO
msgid "Set the baseline credit grade for tenant approval"
msgstr "Définir le niveau de crédit de base pour l'approbation du locataire"

#. js-lingui-id: 3u2W35
msgid "Applicant successfully moved to submissions"
msgstr "Candidat déplacé avec succès vers les soumissions"

#. js-lingui-id: 3wLMe2
msgid "Our property management team is here to assist you. Please don't hesitate to reach out with any questions or concerns."
msgstr "Notre équipe de gestion de propriété est là pour vous aider. N'hésitez pas à nous contacter avec toute question ou préoccupation."

#. js-lingui-id: 3wV73y
msgid "City"
msgstr "Ville"

#. js-lingui-id: 3wXqxH
msgid "The tenant has an email address"
msgstr "Le locataire a une adresse email"

#. js-lingui-id: 3xAOQ2
msgid "Review carefully before proceeding"
msgstr "Revoir attentivement avant de continuer"

#. js-lingui-id: 3xWw8X
msgid "Credit"
msgstr "Crédit"

#. js-lingui-id: 3y+V4p
msgid "Organization Address"
msgstr "Adresse de l'organisation"

#. js-lingui-id: 3zHWEJ
msgid "Currently Renting"
msgstr "Loueur en cours"

#. js-lingui-id: 4+xCbE
msgid "Waiting for manager to prepare lease"
msgstr "En attente de la préparation du bail par le gestionnaire"

#. js-lingui-id: 4/sIJj
msgid "WARNING: Impersonating {tenantSlug}"
msgstr "ATTENTION: Vous êtes en train d'impersonner {tenantSlug}"

#. js-lingui-id: 403lg+
msgid "Specify which references tenants need to provide with their application"
msgstr "Spécifiez les références que les locataires doivent fournir avec leur candidature"

#. js-lingui-id: 41BQ3k
msgid "Contact Email"
msgstr "Email de contact"

#. js-lingui-id: 42iHn5
msgid "Insufficient Data for Analysis"
msgstr "Données insuffisantes pour l'analyse"

#. js-lingui-id: 42v1c0
msgid "The report will be updated and ready shortly."
msgstr "Le rapport sera mis à jour et prêt sous peu."

#. js-lingui-id: 4Cp2Bu
msgid "Additional Notes"
msgstr "Notes supplémentaires"

#. js-lingui-id: 4EN1Ko
msgid "Specify which documents tenants need to provide with their application"
msgstr "Spécifiez les documents que les locataires doivent fournir avec leur candidature"

#. js-lingui-id: 4EZrJN
msgid "Rules"
msgstr "Règlement"

#. js-lingui-id: 4HBFYh
msgid "Map"
msgstr "Carte"

#. js-lingui-id: 4IxwaI
msgid "verified tenants"
msgstr "locataires vérifiés"

#. js-lingui-id: 4JcNPM
msgid "No Answer"
msgstr "Pas de réponse"

#. js-lingui-id: 4LA8GW
msgid "Don't have these exact documents? You can upload alternative documents that prove your {documentName} and our team will evaluate them."
msgstr "Vous n'avez pas ces documents exactement ? Vous pouvez téléverser des documents alternatifs qui prouvent votre {documentName} et notre équipe les évaluera."

#. js-lingui-id: 4OK01F
msgid "Submission has been successfully un-snoozed. It will now show up in the list to process."
msgstr "La soumission a été modifiée avec succès. Elle apparaîtra maintenant dans la liste à traiter."

#. js-lingui-id: 4Pfbfv
msgid "Debt Utilization Trends"
msgstr "Tendances d'utilisation des dettes"

#. js-lingui-id: 4QrWVd
msgid "per month"
msgstr "par mois"

#. js-lingui-id: 4R0Wz7
msgid "Furthermore, the user agrees to fully indemnify Eversa against any amounts it may be required to pay for damages, legal fees, or other costs arising from any action or omission attributable to the user related to the use of personal information later found to be inaccurate, false, or misleading."
msgstr "De plus, l'utilisateur s'engage à indemniser Eversa contre tout montant qu'il pourrait être tenu de payer pour des dommages, des frais juridiques ou d'autres coûts résultant de toute action ou omission de l'utilisateur liée à l'utilisation d'informations personnelles ultérieurement trouvées inexactes, fausses ou trompeuses."

#. js-lingui-id: 4TSeNJ
msgid "The application has been declined in its current state. However, if a co-signer is provided, the landlord will reconsider the case and may issue a positive response."
msgstr "La demande a été refusée en l'état. Cependant, si un cosignataire est fourni, le propriétaire réexaminera le dossier et pourrait donner une réponse positive."

#. js-lingui-id: 4VOGk0
msgid "Converted to regular listing"
msgstr "Converti en liste régulière"

#. js-lingui-id: 4Vxo6V
msgid "No Submissions Found!"
msgstr "Aucune soumission trouvée !"

#. js-lingui-id: 4XSc4l
msgid "Weekly"
msgstr "Hebdomadaire"

#. js-lingui-id: 4b3kQf
msgid "Please provide suitable description"
msgstr "Veuillez fournir une description appropriée"

#. js-lingui-id: 4bRMuv
msgid "Enter an address"
msgstr "Entrez une adresse"

#. js-lingui-id: 4c4TGc
msgid "Application fees cover the costs associated with processing and verifying your rental application, including background checks, credit reports, and employment verification to ensure a thorough and professional screening process."
msgstr "Les frais de candidature couvrent les coûts associés au traitement et à la vérification de votre demande de location, y compris les vérifications des antécédents, les rapports de crédit et la vérification de l'emploi pour garantir un processus de sélection approfondi et professionnel."

#. js-lingui-id: 4cqVkH
msgid "No leads found"
msgstr "Aucun prospect trouvé"

#. js-lingui-id: 4dzoL9
msgid "Hide the 'Chosen' category in the submission workflow."
msgstr "Masquer la catégorie 'Choisi' dans le flux de soumission."

#. js-lingui-id: 4gUV3t
msgid "Billing is properly configured"
msgstr "La facturation est correctement configurée"

#. js-lingui-id: 4k24cF
msgid "Duplicate Unit"
msgstr "Dupliquer l'unité"

#. js-lingui-id: 4lUh8p
msgid "Promotional Title"
msgstr "Titre promotionnel"

#. js-lingui-id: 4oZgYS
msgid "Date Paid"
msgstr "Date de paiement"

#. js-lingui-id: 4pIc+0
msgid "Available on {formatedAvailability}"
msgstr "Disponible le {formatedAvailability}"

#. js-lingui-id: 4pwejF
msgid "First name is required"
msgstr "Le prénom est requis"

#. js-lingui-id: 4qsPeV
msgid "Front and back of valid license"
msgstr "Devant et derrière de la licence valide"

#. js-lingui-id: 4sXlwl
msgid "Application Fee Agreement"
msgstr "Accord sur les frais de candidature"

#. js-lingui-id: 4sYaNl
msgid "Monthly Rent"
msgstr "Loyer mensuel"

#. js-lingui-id: 4vA3oS
msgid "Manage project"
msgstr "Gérer le projet"

#. js-lingui-id: 4wTON8
msgid "Need help? We're here to assist you."
msgstr "Besoin d'aide ? Nous sommes là pour vous aider."

#. js-lingui-id: 4ypJfF
msgid "Upload your required proof of income and ID documentation"
msgstr "Téléverser votre preuve de revenus et vos documents d'identité requis"

#. js-lingui-id: 4yvLkg
msgid "Notification sent when a rental agent is assigned to a rental application submission"
msgstr "Notification envoyée lorsqu'un agent de location est affecté à une soumission de candidature de location"

#. js-lingui-id: 51FUZc
msgid "Maximum Credit Utilization"
msgstr "Utilisation maximale du crédit"

#. js-lingui-id: 54/ySy
msgid "Enter Youtube URL"
msgstr "Entrez l'URL de Youtube"

#. js-lingui-id: 553MXo
msgid "Employment and landlord reference verification"
msgstr "Vérification de l'emploi et de la référence locative"

#. js-lingui-id: 58X1WA
msgid "All Units"
msgstr "Toutes les unités"

#. js-lingui-id: 59HXHe
msgid "Major Banks"
msgstr "Grandes banques"

#. js-lingui-id: 5HFsIV
msgid "Enable Projects"
msgstr "Activer les projets"

#. js-lingui-id: 5Qvo0g
msgid "Unit Change Threshold ($)"
msgstr "Seuil de changement d'unité ($)"

#. js-lingui-id: 5TsUYH
msgid "Submission has been successfully rejected"
msgstr "La soumission a été rejetée avec succès"

#. js-lingui-id: 5VAzM9
msgid "Learn more about"
msgstr "En savoir plus sur"

#. js-lingui-id: 5cxuuq
msgid "The field is invalid"
msgstr "Le champ est invalide"

#. js-lingui-id: 5dydNg
msgid "Additional notes"
msgstr "Notes supplémentaires"

#. js-lingui-id: 5eLj4k
msgid "Application not started"
msgstr "Candidature non commencée"

#. js-lingui-id: 5iM1gD
msgid "Quebec court records and legal history verification"
msgstr "Vérification des enregistrements de cours de la province du Québec et de l'histoire légale"

#. js-lingui-id: 5iNewk
msgid "Global watchlist records indicate prior criminal involvement."
msgstr "Les enregistrements de la liste de surveillance mondiale indiquent une implication criminelle antérieure."

#. js-lingui-id: 5iVHpx
msgid "Processing for lease signing"
msgstr "En signature de bail"

#. js-lingui-id: 5lbavF
msgid "Search listings"
msgstr "Recherche d'annonces"

#. js-lingui-id: 5nij+b
msgid "Additional Review Required"
msgstr "Examen supplémentaire requis"

#. js-lingui-id: 5oEFR0
msgid "Add any relevant information about this applicant..."
msgstr "Ajoutez toute information pertinente sur ce candidat..."

#. js-lingui-id: 5pvqmj
msgid "Criminal Records"
msgstr "Enregistrements criminels"

#. js-lingui-id: 5qU5Gh
msgid "Annual revenue"
msgstr "Revenus annuels"

#. js-lingui-id: 5v4qYi
msgid "Preferred language"
msgstr "Langue préférée"

#. js-lingui-id: 5xxrhm
msgid "Add a note"
msgstr "Ajouter une note"

#. js-lingui-id: 5y3O+A
msgid "Deactivate"
msgstr "Désactiver"

#. js-lingui-id: 5ykxbP
msgid "API Documentation"
msgstr "Documentation de l'API"

#. js-lingui-id: 6+Z07a
msgid "Rent: "
msgstr "Loyer: "

#. js-lingui-id: 6/TeyT
msgid "{tenantName} {type} for rent in {city}: {bedrooms} bedrooms, {address}"
msgstr "{type} {tenantName} à louer à {city}: {bedrooms} chambres, {address}"

#. js-lingui-id: 6/dCYd
msgid "Overview"
msgstr "Aperçu"

#. js-lingui-id: 621rYf
msgid "Payment"
msgstr "Paiement"

#. js-lingui-id: 623gDt
msgid "Failed to delete user."
msgstr "Impossible de supprimer l'utilisateur."

#. js-lingui-id: 642qru
msgid "ROLE"
msgstr "Rôle"

#. js-lingui-id: 6B6oQj
msgid "Application on hold - Action required"
msgstr "Candidature en attente - Action requise"

#. js-lingui-id: 6D9V6K
msgid "Delivery status illustration"
msgstr "Illustration du statut de livraison"

#. js-lingui-id: 6GPUe/
msgid "Select a new listing and unit"
msgstr "Sélectionnez une nouvelle annonce et une unité"

#. js-lingui-id: 6KnyG0
msgid "Enter email"
msgstr "Entrez un email"

#. js-lingui-id: 6NvSPB
msgid "Identity Documents"
msgstr "Documents d'identité"

#. js-lingui-id: 6Q5Pc9
msgid "Inventory View"
msgstr "Vue d'inventaire"

#. js-lingui-id: 6RHkyC
msgid "{v} bathrooms"
msgstr "{v} salles de bain"

#. js-lingui-id: 6RmHKN
msgid "Primary Color"
msgstr "Couleur principale"

#. js-lingui-id: 6SUhyj
msgid "Biweekly"
msgstr "Aux deux semaines"

#. js-lingui-id: 6UXwfl
msgid "Send an invitation email to the tenant. They can complete the application at their convenience."
msgstr "Envoyez un courriel d'invitation au locataire. Il pourra compléter la demande à sa convenance."

#. js-lingui-id: 6XBwub
msgid "Delete Unit"
msgstr "Supprimer l'unité"

#. js-lingui-id: 6Xdu/D
msgid "Current Balance"
msgstr "Solde actuel"

#. js-lingui-id: 6YtxFj
msgid "Name"
msgstr "Nom"

#. js-lingui-id: 6cHqQI
msgid "Enable the listing website functionality to allow property listings and management. This restores all listing features, providing users with tools to create and manage rental applications seamlessly."
msgstr "Activez la fonctionnalité du site web de listage pour permettre la gestion des annonces immobilières. Cela restaure toutes les fonctionnalités de listage, offrant aux utilisateurs des outils pour créer et gérer les demandes de location de manière transparente."

#. js-lingui-id: 6dZCPF
msgid "Select events to trigger this webhook"
msgstr "Sélectionnez les événements pour déclencher ce webhook"

#. js-lingui-id: 6exX+8
msgid "Regenerate"
msgstr "Régénérer"

#. js-lingui-id: 6f1jSa
msgid "Failed to process action"
msgstr "Échec du traitement de l'action"

#. js-lingui-id: 6foA8n
msgid "Are you sure?"
msgstr "Êtes-vous sûr?"

#. js-lingui-id: 6iLZrh
msgid "Assigned Date"
msgstr "Date d'affectation"

#. js-lingui-id: 6jefe3
msgid "months"
msgstr "mois"

#. js-lingui-id: 6jfS51
msgid "Welcome"
msgstr "Bienvenu"

#. js-lingui-id: 6kPk3+
msgid "Personal Information"
msgstr "Informations personnelles"

#. js-lingui-id: 6lGV3K
msgid "Show less"
msgstr "Afficher moins"

#. js-lingui-id: 6n/LTh
msgid "Your Rental Application"
msgstr "Votre demande de location"

#. js-lingui-id: 6oZDWL
msgid "Enter company address"
msgstr "Entrez l'adresse de l'entreprise"

#. js-lingui-id: 6ogpwN
msgid "Market intelligence features are currently being developed and will be available in the next update."
msgstr "Les fonctionnalités d'intelligence de marché sont en cours de développement et seront disponibles dans la prochaine mise à jour."

#. js-lingui-id: 6oyQjb
msgid "Youtube"
msgstr "Youtube"

#. js-lingui-id: 6q4g1d
msgid "You must type \"I understand the risk\" to proceed"
msgstr "Vous devez saisir « Je comprends le risque » pour continuer"

#. js-lingui-id: 6wEL+N
msgid "Sign below to confirm"
msgstr "Signer ci-dessous pour confirmer"

#. js-lingui-id: 7+btY9
msgid "A delivery agent has not been assigned to this delivery."
msgstr "Aucun agent de livraison n'a été affecté à cette livraison."

#. js-lingui-id: 7+i6oV
msgid "Snooze"
msgstr "Mettre en veille"

#. js-lingui-id: 70Cb+2
msgid "All rights reserved."
msgstr "Tous droits réservés."

#. js-lingui-id: 70yAY8
msgid "Access Application as Tenant"
msgstr "Accéder à la candidature en tant que locataire"

#. js-lingui-id: 71Xwww
msgid "Invalid request"
msgstr "Requête invalide"

#. js-lingui-id: 72c5Qo
msgid "Total"
msgstr "Total"

#. js-lingui-id: 77pX2A
msgid "Please reach out to our friendly support team and we'll be happy to help you with your request."
msgstr "Veuillez contacter notre sympathique équipe d'assistance et nous serons heureux de vous aider avec votre demande."

#. js-lingui-id: 793noG
msgid "Please provide one of the following income documents:"
msgstr "Veuillez fournir l'un des documents suivants:"

#. js-lingui-id: 7AS0iK
msgid "Our system is certified by Cybersecure Canada, meeting rigorous security standards to protect your personal information. We employ industry-leading encryption and security practices to safeguard your data."
msgstr "Notre système est certifié par Cybersecure Canada, respectant des normes de sécurité rigoureuses pour protéger vos informations personnelles. Nous utilisons des pratiques de cryptage et de sécurité de pointe pour protéger vos données."

#. js-lingui-id: 7Ao9Wl
msgid "{tooltipText}: Warning"
msgstr "{tooltipText}: Avertissement"

#. js-lingui-id: 7BAOFm
msgid "Not assigned"
msgstr "Non assigné"

#. js-lingui-id: 7Bj3x9
msgid "Failed"
msgstr "Échec"

#. js-lingui-id: 7C6L6q
msgid "Hold this submission"
msgstr "Mettre en veille cette candidature"

#. js-lingui-id: 7CTnHd
msgid "Manage and invite Team Members."
msgstr "Gérer et inviter des membres de l'équipe."

#. js-lingui-id: 7DHQo6
msgid "Average per Check"
msgstr "Moyenne par vérification"

#. js-lingui-id: 7EnT52
msgid "Tax Documents"
msgstr "Documents d'impôts"

#. js-lingui-id: 7H42q4
msgid "Available now"
msgstr "Disponible maintenant"

#. js-lingui-id: 7HD+DV
msgid "Property manager login"
msgstr "Connexion du gestionnaire immobilier"

#. js-lingui-id: 7J+c8c
msgid "Can't find the address?"
msgstr "Impossible de trouver l'adresse ?"

#. js-lingui-id: 7L01XJ
msgid "Actions"
msgstr "Actions"

#. js-lingui-id: 7MuXko
msgid "Personal"
msgstr "Identification"

#. js-lingui-id: 7NqkkO
msgid "Notification sent to the applicant to remind them to complete their application"
msgstr "Notification envoyée au demandeur pour le rappeler de compléter sa candidature"

#. js-lingui-id: 7PzzBU
msgid "User"
msgstr "Utilisateur"

#. js-lingui-id: 7TElxB
#. placeholder {0}: submission.tenants.length
msgid "{0, plural, one {Person applying for this property} other {People applying for this property}}"
msgstr "{0, plural, one {Personne postulant pour cette propriété} other {Personnes postulant pour cette propriété}}"

#. js-lingui-id: 7VpPHA
msgid "Confirm"
msgstr "Confirmer"

#. js-lingui-id: 7Wi/hL
msgid "Release to confirm"
msgstr "Relâchez pour confirmer"

#. js-lingui-id: 7YWZId
msgid "Application in progress"
msgstr "Candidature en cours"

#. js-lingui-id: 7a51q5
msgid "Need help? Contact the property manager:"
msgstr "Besoin d'aide ? Contactez le propriétaire :"

#. js-lingui-id: 7aDnUb
msgid "Developer"
msgstr "Développeur"

#. js-lingui-id: 7eMo+U
msgid "Go Home"
msgstr "Retour à l'accueil"

#. js-lingui-id: 7i8j3G
msgid "Company"
msgstr "Entreprise"

#. js-lingui-id: 7iNO9W
msgid "Uploaded successfully"
msgstr "Téléversé avec succès"

#. js-lingui-id: 7iwThZ
msgid "View and manage your upcoming property deliveries"
msgstr "Voir et gérer vos prochaines livraisons de biens"

#. js-lingui-id: 7jpQWC
msgid "Hurry up, 4+ people have already applied !"
msgstr "Dépêchez-vous, plus de 4 personnes ont déjà postulé !"

#. js-lingui-id: 7p5kLi
msgid "Dashboard"
msgstr "Tableau de bord"

#. js-lingui-id: 7pPYrg
msgid "Requires Action"
msgstr "Action requises"

#. js-lingui-id: 7quAj0
msgid "With Utilities"
msgstr "Avec les services"

#. js-lingui-id: 7rOyDW
msgid "CR"
msgstr "CR"

#. js-lingui-id: 7sKAkn
msgid "Put on hold"
msgstr "Mettre en veille"

#. js-lingui-id: 7tU19g
msgid "Application Inactive"
msgstr "Candidature inactive"

#. js-lingui-id: 7uHWR+
msgid "Date of Birth"
msgstr "Date de naissance"

#. js-lingui-id: 7w2+8j
msgid "Sex offender records identified."
msgstr "Dossiers de délinquants sexuels identifiés."

#. js-lingui-id: 800f5o
msgid "You authorize Eversa and its partners to obtain and review your credit report from a recognized credit bureau."
msgstr "Vous autorisez Eversa et ses partenaires à obtenir et examiner votre rapport de crédit d'un bureau de crédit reconnu."

#. js-lingui-id: 87cqmN
msgid "Confirm Unit Change"
msgstr "Confirmer le changement d'unité"

#. js-lingui-id: 87nAg7
msgid "Active Submissions"
msgstr "Candidatures actives"

#. js-lingui-id: 8B+pY5
msgid "Property"
msgstr "Propriété"

#. js-lingui-id: 8Bz31i
msgid "Are you sure you want to deactivate this user?"
msgstr "Êtes-vous sûr de vouloir désactiver cet utilisateur?"

#. js-lingui-id: 8F5PiU
msgid "Next, choose what to do with the remaining applications"
msgstr "Ensuite, choisissez ce que faire avec les candidatures restantes"

#. js-lingui-id: 8H0Id6
msgid "Enter website URL"
msgstr "Entrez l'URL du site web"

#. js-lingui-id: 8HjX3H
msgid "Verify credit score"
msgstr "Vérifier le score de crédit"

#. js-lingui-id: 8JXBzV
msgid "Financial health assessment"
msgstr "Évaluation de la santé financière"

#. js-lingui-id: 8KGn7T
msgid "Government Photo ID"
msgstr "Identité Gouvermentale avec photo"

#. js-lingui-id: 8KbpTf
msgid "No Reference"
msgstr "Aucune référence"

#. js-lingui-id: 8PORut
msgid "Visit Conclusive"
msgstr "Visite Concluante"

#. js-lingui-id: 8Paa3N
msgid "By accepting and proceeding, you expressly consent to the credit check under the terms outlined above."
msgstr "En acceptant et en procédant, vous consentez expressément à la vérification de crédit sous les termes décrits ci-dessus."

#. js-lingui-id: 8Tg/JR
msgid "Custom"
msgstr "Personnalisé"

#. js-lingui-id: 8U7Kq/
msgid "Promotion"
msgstr "Promotion"

#. js-lingui-id: 8YTPsu
msgid "Listing Type"
msgstr "Type d'annonce"

#. js-lingui-id: 8ccNPJ
msgid "Short-term Loans"
msgstr "Prêts à court terme"

#. js-lingui-id: 8csHcN
msgid "Your application requires additional documentation. Please proceed to the section below to upload the requested documents."
msgstr "Votre candidature nécessite des documents supplémentaires. Veuillez procéder à la section ci-dessous pour téléverser les documents demandés."

#. js-lingui-id: 8df67a
msgid "Use of Information:"
msgstr "Utilisation des informations:"

#. js-lingui-id: 8ea8Yx
msgid "By submitting your credit check request, you acknowledge and agree to the following:"
msgstr "En soumettant votre demande de vérification de crédit, vous reconnaissez et acceptez les termes suivants:"

#. js-lingui-id: 8f+BAx
msgid "Owns current property"
msgstr "Possède une propriété actuelle"

#. js-lingui-id: 8faOjQ
msgid "Create New"
msgstr "Créer nouveau"

#. js-lingui-id: 8hvxGX
msgid "Call"
msgstr "Appel"

#. js-lingui-id: 8i1KwT
msgid "Additional"
msgstr "Additionel"

#. js-lingui-id: 8lDp42
msgid "Building has been unarchived."
msgstr "Le bâtiment a été désarchivé."

#. js-lingui-id: 8nkZDI
msgid "Background check price must be greater than or equal to 0"
msgstr "Le prix de la vérification de fonds doit être supérieur ou égal à 0"

#. js-lingui-id: 8sTahH
msgid "Date Settled"
msgstr "Date de règlement"

#. js-lingui-id: 9/1YKL
msgid "Enter last name"
msgstr "Entrer votre nom de famille"

#. js-lingui-id: 9/q/+g
msgid "No criminal records found in the last 10 years."
msgstr "Aucun casier judiciaire trouvé au cours des 10 dernières années."

#. js-lingui-id: 92O9Tp
msgid "Stretched"
msgstr "Surendetté"

#. js-lingui-id: 9317Ly
msgid "Copy & share link"
msgstr "Copier et partager le lien"

#. js-lingui-id: 9392kR
msgid "Authorization:"
msgstr "Autorisation:"

#. js-lingui-id: 95E4wJ
msgid "Last 24 months of payment activity"
msgstr "Derniers 24 mois d'activité de paiement"

#. js-lingui-id: 95U74+
msgid "This property is no longer available"
msgstr "Cette propriété n'est plus disponible"

#. js-lingui-id: 97V8+4
msgid "No deliveries scheduled for this date."
msgstr "Aucune livraison prévue à cette date."

#. js-lingui-id: 97e/Vk
msgid "Credit Check Reports"
msgstr "Rapports de vérification de crédit"

#. js-lingui-id: 99W5Gw
msgid "Submission has been successfully marked as visit conclusive"
msgstr "La soumission a été marquée avec succès comme visite concluante"

#. js-lingui-id: 99aYHN
msgid "Require tenants to provide landlord references"
msgstr "Exiger que les locataires fournissent des références de propriétaires"

#. js-lingui-id: 9AGWn9
msgid "income"
msgstr "revenus"

#. js-lingui-id: 9AYRvD
msgid "Enter your date of birth"
msgstr "Entrez votre date de naissance"

#. js-lingui-id: 9Eq34y
msgid "Reference Check Not Run"
msgstr "Vérification des références non effectuée"

#. js-lingui-id: 9GaiPo
msgid "e.g., Self-employed, student, retired, etc."
msgstr "e.g., Auto-entrepreneur, étudiant, retraité, etc."

#. js-lingui-id: 9K4YRv
msgid "Ideal candidate, strong financial health"
msgstr "Candidat idéal, santé financière forte"

#. js-lingui-id: 9LZMmC
msgid "Please provide your date of birth to proceed with the credit check"
msgstr "Veuillez fournir votre date de naissance pour procéder à la vérification de crédit"

#. js-lingui-id: 9PTaMz
msgid "Available From"
msgstr "Disponible à partir de"

#. js-lingui-id: 9QIaqi
msgid "Add a payment method to accept applicants and use all features"
msgstr "Ajouter une méthode de paiement pour accepter des candidats et utiliser toutes les fonctionnalités"

#. js-lingui-id: 9Qs99X
msgid "Email:"
msgstr "Courriel:"

#. js-lingui-id: 9W3KV/
msgid "Setup Payment"
msgstr "Configurer"

#. js-lingui-id: 9WVFoB
msgid "Snooze this application if you are missing additional details"
msgstr "Mettre en veille cette candidature si vous manquez de détails supplémentaires"

#. js-lingui-id: 9ZPH8F
msgid "Strong Candidate"
msgstr "Candidat fort"

#. js-lingui-id: 9aloPG
msgid "References"
msgstr "Références"

#. js-lingui-id: 9bOOxk
msgid "The image with the \"Featured\" badge will be your main image"
msgstr "L'image avec le badge \"Vedette\" sera votre image principale"

#. js-lingui-id: 9cezby
msgid "Please explain why you don't have a landlord reference"
msgstr "Veuillez expliquer pourquoi vous n'avez pas de référence de propriétaire"

#. js-lingui-id: 9cxCHd
msgid "Hi {firstName},<0/><1>Your Application Needs Attention</1>"
msgstr "Bonjour {firstName},<0/><1>Votre candidature nécessite une attention</1>"

#. js-lingui-id: 9e930q
msgid "e.g., First time renting, previous landlord is no longer available, etc."
msgstr "e.g., Première fois louer, propriétaire précédent non disponible, etc."

#. js-lingui-id: 9eF5oV
msgid "Welcome back"
msgstr "Bienvenue"

#. js-lingui-id: 9fkkek
msgid "Minimum required income as multiple of rent"
msgstr "Revenu minimum requis en multiple du loyer"

#. js-lingui-id: 9gCieb
msgid "Confirm user identity"
msgstr "Confirmer l'identité de l'utilisateur"

#. js-lingui-id: 9iqnDb
msgid "{promotionPrice}$ / Monthly"
msgstr "{promotionPrice}$ par mois"

#. js-lingui-id: 9msbaN
msgid "Edit listing"
msgstr "Modifier l'annonce"

#. js-lingui-id: 9qhp8Z
msgid "Credit Report Consent"
msgstr "Consentement pour le rapport de crédit"

#. js-lingui-id: 9qpf5y
msgid "Unfinished Submissions"
msgstr "Candidatures inachevées"

#. js-lingui-id: 9sFPiZ
msgid "Having someone co-sign or guarantee your lease could provide additional security."
msgstr "Avoir quelqu'un pour co-signer ou garantir votre bail peut fournir une sécurité supplémentaire."

#. js-lingui-id: 9wTb7y
msgid "SIN must be 9 digits"
msgstr "Le numéro de sécurité sociale doit comporter 9 chiffres"

#. js-lingui-id: A0Ba3X
msgid "Delivery Calendar"
msgstr "Calendrier des livraisons"

#. js-lingui-id: A0C9La
msgid "Email us"
msgstr "Envoyez-nous un email"

#. js-lingui-id: A0eVKL
msgid "Enable tenants to add co-applicants to their application"
msgstr "Permettre aux locataires d'ajouter des co-locataires à leur candidature"

#. js-lingui-id: A1taO8
msgid "Search"
msgstr "Recherche"

#. js-lingui-id: A2FDZa
msgid "You are currently viewing the dashboard as {selectedAgentFName} {selectedAgentLName}"
msgstr "Vous êtes actuellement sur le tableau de bord en tant que {selectedAgentFName} {selectedAgentLName}"

#. js-lingui-id: A5Rcld
msgid "Transit Score®"
msgstr "Score de mobilité"

#. js-lingui-id: A6rJrW
msgid "Manage your settings."
msgstr "Gérer vos paramètres."

#. js-lingui-id: A8xwgi
msgid "Lease Information"
msgstr "Informations sur le bail"

#. js-lingui-id: AIYkvD
msgid "Maximum allowed credit utilization percentage"
msgstr "Pourcentage maximum d'utilisation du crédit autorisé"

#. js-lingui-id: AIupfI
msgid "To start your application, please enter your email address and verify it"
msgstr "Pour commencer votre demande, veuillez entrer votre adresse email et la vérifier"

#. js-lingui-id: AKF94d
msgid "Business documents, contracts, or income statements if self-employed"
msgstr "Documents commerciaux, contrats ou relevés de revenus si vous êtes auto-entrepreneur"

#. js-lingui-id: AKx4pt
msgid "You are applying with email updates. Do not exit until the process is completed."
msgstr "Vous postulez avec des mises à jour par courriel. Ne quittez pas la page avant la fin du processus."

#. js-lingui-id: AModYF
msgid "New Applicant"
msgstr "Nouveau candidat"

#. js-lingui-id: ANkWB0
msgid "No listings found"
msgstr "Aucune annonce trouvée"

#. js-lingui-id: AO5QEO
msgid "Previous Landlord"
msgstr "Ancien propriétaire"

#. js-lingui-id: APvW6L
msgid "Utilization"
msgstr "Utilisation"

#. js-lingui-id: AQRrKw
msgid "Promotion removed from unit"
msgstr "Promotion retirée de l'unité"

#. js-lingui-id: AQoIUq
msgid "Verification Checks"
msgstr "Vérifications"

#. js-lingui-id: AQoSYJ
msgid "Account Details"
msgstr "Détail du compte"

#. js-lingui-id: AXQ2Ts
msgid "Enter the english description"
msgstr "Entrez la description en anglais"

#. js-lingui-id: AaGTbP
msgid "Move to favorite listing?"
msgstr "Déplacer vers les annonces favorites?"

#. js-lingui-id: Aar52/
msgid "Annual Salary"
msgstr "Salaire annuel"

#. js-lingui-id: AdMvsx
msgid "listed"
msgstr "listé"

#. js-lingui-id: Ae7pe8
msgid "Not received"
msgstr "Non reçu"

#. js-lingui-id: AeTZZf
msgid "Tenants pay for their application"
msgstr "Les locataires payent pour leur candidature"

#. js-lingui-id: AjkJ0d
msgid "I acknowledge and agree that any fees paid to <0>Eversa</0> are non-refundable and will be used to process and analyze my profile."
msgstr "Je reconnais et accepte que tous les frais payés à <0>Eversa</0> ne sont pas remboursables et seront utilisés pour traiter et analyser mon profil."

#. js-lingui-id: AlGvz8
msgid "Check back later for updates."
msgstr "Revenez plus tard pour les mises à jour."

#. js-lingui-id: AlniDR
msgid "Based on inquiries from different types of lenders"
msgstr "Basé sur des demandes de renseignements provenant de différents types de prêteurs"

#. js-lingui-id: Any6KN
msgid "Enter amount in dollars (e.g. 300)"
msgstr "Entrez le montant en dollars (ex: 300)"

#. js-lingui-id: Ap948/
msgid "Listed"
msgstr "Répertorié"

#. js-lingui-id: ApsD9J
msgid "Add New"
msgstr "Ajouter Nouveau"

#. js-lingui-id: Aso3xS
msgid "Commercial rentals"
msgstr "Unités commerciales"

#. js-lingui-id: AugMgz
msgid "Void cheque"
msgstr "Chèque annulé"

#. js-lingui-id: B8sGeq
msgid "Global watchlist screening"
msgstr "Vérification de la liste mondiale"

#. js-lingui-id: B9usNx
msgid "The submission status will be sent back to the start of the process."
msgstr "Le statut de la soumission sera renvoyé au début du processus."

#. js-lingui-id: BAOatb
msgid "Credit check request for {applicantFirstName} {applicantLastName} sent!"
msgstr "Demande de vérification de crédit envoyée à {applicantFirstName} {applicantLastName} !"

#. js-lingui-id: BBUDfW
msgid "Urgent"
msgstr "Urgent"

#. js-lingui-id: BCgdx+
msgid "Deactivate User"
msgstr "Désactiver l'utilisateur"

#. js-lingui-id: BGU1P9
msgid "Ads Conversion ID"
msgstr "ID de conversion des annonces"

#. js-lingui-id: BJ943b
msgid "Mortgage Alert"
msgstr "Alerte hypothèque"

#. js-lingui-id: BL2UDm
msgid "Run a credit check to get valuable insights into financial history and make better informed decisions."
msgstr "Effectuez une vérification de crédit pour obtenir des informations précieuses sur l'historique financier et prendre des décisions plus éclairées."

#. js-lingui-id: BP1ZpV
msgid "Payment successful - Tenant is paying"
msgstr "Paiement réussi - Le locataire paye"

#. js-lingui-id: BSZHw4
msgid "Debt Ratio"
msgstr "Ratio d'endettement"

#. js-lingui-id: BWW2FN
msgid "All set! No deliveries are scheduled for this day."
msgstr "Tout est prêt ! Aucune livraison n'est prévue pour cette journée."

#. js-lingui-id: BXEcos
msgid "Emails"
msgstr "E-mails"

#. js-lingui-id: BZz12Q
msgid "Print"
msgstr "Imprimer"

#. js-lingui-id: BaaXjJ
msgid "Type of condition"
msgstr "Type de condition"

#. js-lingui-id: Bc8WYp
msgid "Personal Loans"
msgstr "Prêts personnels"

#. js-lingui-id: Bep3Ll
msgid "The payment has been processed successfully."
msgstr "Votre paiement est reçus."

#. js-lingui-id: BrMQb6
msgid "Quebec small claims court records"
msgstr "Enregistrements de la cour de petite réclamation du Québec"

#. js-lingui-id: Bw5X+M
msgid "Search by name or email"
msgstr "Rechercher par nom ou courriel"

#. js-lingui-id: BwJKBw
msgid "of"
msgstr "de"

#. js-lingui-id: Bzfr5Q
msgid "Recent Pay Stubs"
msgstr "Justificatifs de paie récents"

#. js-lingui-id: C0C0dS
msgid "Send Invitation"
msgstr "Envoyer une invitation"

#. js-lingui-id: C2XrlJ
msgid "Court Orders"
msgstr "Ordonnances judiciaires"

#. js-lingui-id: C3nD/1
msgid "Enter your email"
msgstr "Entrez votre email"

#. js-lingui-id: C3yOz3
msgid "Last updated"
msgstr "Dernière mise à jour"

#. js-lingui-id: CCXa60
msgid "No documents uploaded"
msgstr "Aucun document téléverser"

#. js-lingui-id: CCyFtH
msgid "Continue to complete the application."
msgstr "Continuer ma soumission"

#. js-lingui-id: CFUuM9
msgid "complete deliveries"
msgstr "completer les livraisons"

#. js-lingui-id: CHaBWG
msgid "Notification updated"
msgstr "Notification mise à jour"

#. js-lingui-id: CHeXuc
msgid "Units / ({listingCount} listings)"
msgstr "Unités / ({listingCount} annonces)"

#. js-lingui-id: CJd3kI
msgid "This information will be used to contact you"
msgstr "Ces informations seront utilisées pour vous contacter"

#. js-lingui-id: CKyk7Q
msgid "Go back"
msgstr "Retourner"

#. js-lingui-id: CQypwd
msgid "Edit Promotion"
msgstr "Modifier la Promotion"

#. js-lingui-id: CVNSSG
msgid "Your application<0/> has been removed"
msgstr "Votre candidature<0/> a été supprimée"

#. js-lingui-id: CW11B+
msgid "Minimum"
msgstr "Minimum"

#. js-lingui-id: CW12bM
msgid "Unfinished"
msgstr "Inachevé"

#. js-lingui-id: CbwuN5
msgid "AI Verified"
msgstr "Vérifié par IA"

#. js-lingui-id: CdVrCa
msgid "Your current role has no action to take here"
msgstr "Votre rôle actuel n'a pas d'action à effectuer ici"

#. js-lingui-id: CgPSDs
msgid "Need help? Email our support team at {emailLink} for assistance."
msgstr "Besoin d'aide ? Envoyez un email à notre équipe de support à {emailLink} pour obtenir de l'aide."

#. js-lingui-id: CgpEzf
msgid "You've successfully removed the visit agent from this submission"
msgstr "Vous avez retiré avec succès l'agent de visite de cette soumission"

#. js-lingui-id: ChVlsi
msgid "Proof of Funds"
msgstr "Justificatif de fonds"

#. js-lingui-id: CikZHq
msgid "Unfortunately, at this moment your application has been removed. You can always try again later or contact the property manager if your situation changes."
msgstr "Malheureusement, votre candidature a été retirée pour le moment. Vous pouvez toujours réessayer plus tard ou contacter le gestionnaire immobilier si votre situation change."

#. js-lingui-id: Cl4Mxm
msgid "Search for applicants, submissions and more..."
msgstr "Rechercher des candidats, soumissions et plus..."

#. js-lingui-id: ClKRQy
msgid "Salary is required"
msgstr "Un salaire est requis."

#. js-lingui-id: CnYzHV
msgid "An unexpected error occurred during import"
msgstr "Une erreur inattendue est survenue lors de l'importation"

#. js-lingui-id: CqEAWK
msgid "Send credit check request"
msgstr "Envoyer une demande de vérification de crédit"

#. js-lingui-id: CrghM6
msgid "Parking Available"
msgstr "Stationnement disponible"

#. js-lingui-id: CsUQ0O
msgid "Add Manually"
msgstr "Ajouter manuellement"

#. js-lingui-id: CsekCi
msgid "Normal"
msgstr "Normal"

#. js-lingui-id: CtihIc
msgid "e.g. John Smith - Property Manager"
msgstr "e.g. John Smith - Gestionnaire de propriété"

#. js-lingui-id: CxH5/W
msgid "Building not found"
msgstr "Bâtiment introuvable"

#. js-lingui-id: CzaXHi
msgid "View Timeline"
msgstr "Afficher les événements"

#. js-lingui-id: D1A/Xd
msgid "Quick search command"
msgstr "Commande de recherche rapide"

#. js-lingui-id: D21vC4
msgid "By checking this box, I acknowledge that I have read, understood and agree to be bound by the <0>Terms of Service</0> and <1>Privacy Policy</1>. I understand that these terms constitute a legally binding agreement between myself and <2>Eversa</2>."
msgstr "En cochant cette case, je reconnais avoir lu, compris et accepté d'être lié par les <0>Conditions d'utilisation</0> et la <1>Politique de confidentialité</1>. Je comprends que ces conditions constituent un accord juridiquement contraignant entre moi-même et <2>Eversa</2>."

#. js-lingui-id: D3LSdO
msgid "Final Decision"
msgstr "Décision finale"

#. js-lingui-id: D3iCkb
msgid "Start Date"
msgstr "Date de début"

#. js-lingui-id: D3qEVV
msgid "Eversa is a Canadian company, your data is stored securely with us in Canada."
msgstr "Eversa est une entreprise canadienne, vos données sont stockées de manière sécurisée chez nous au Canada."

#. js-lingui-id: D7fqU3
msgid "The tenant does not have an email address"
msgstr "Le locataire n'a pas d'adresse email"

#. js-lingui-id: D87pha
msgid "Closed"
msgstr "Fermé"

#. js-lingui-id: D89zck
msgid "Sun"
msgstr "Dim"

#. js-lingui-id: DAwCl5
msgid "DTI Ratio:"
msgstr "Ratio DTI:"

#. js-lingui-id: DEv2VI
msgid "Add your references"
msgstr "Ajouter vos références"

#. js-lingui-id: DG4xYU
msgid "Complete the application now with the tenant present. Perfect for in-person meetings."
msgstr "Complétez la demande maintenant en présence du locataire. Idéal pour les rencontres en personne."

#. js-lingui-id: DGHZEW
msgid "Change interface language"
msgstr "Changer la langue de l'interface"

#. js-lingui-id: DHHybq
msgid "Last event"
msgstr "Dernier événement"

#. js-lingui-id: DHhJ7s
msgid "Previous"
msgstr "Précédent"

#. js-lingui-id: DK7nfO
msgid "Failed to process file"
msgstr "Échec du traitement du fichier"

#. js-lingui-id: DL2sg0
msgid "Listings"
msgstr "Annonces"

#. js-lingui-id: DOoOKe
msgid "Finances, Debts and Trends"
msgstr "Finances, dettes et tendances"

#. js-lingui-id: DQJljB
msgid "Conservative"
msgstr "Conservateur"

#. js-lingui-id: DV+Xbw
msgid "Preferred Language"
msgstr "Langue préférée"

#. js-lingui-id: DXbmUR
msgid "Download the data of this submission (.csv)"
msgstr "Exporter les données de cette soumission (.csv)"

#. js-lingui-id: DYlwPh
msgid "Contact Person"
msgstr "Personne à contacter"

#. js-lingui-id: Dd/uIU
msgid "4+ deliveries"
msgstr "4+ livraisons"

#. js-lingui-id: DdK2nW
msgid "Confirmation"
msgstr "Confirmation"

#. js-lingui-id: De3Ie0
msgid "Move submission"
msgstr "Déplacer la soumission"

#. js-lingui-id: DivT5Y
msgid "Restore listing"
msgstr "Restaurer l'annonce"

#. js-lingui-id: Dj0nYr
msgid "years old"
msgstr "ans"

#. js-lingui-id: DjJQTF
msgid "Click to browse or drag and drop your XLSX file here"
msgstr "Cliquez pour parcourir ou glisser-déposer votre fichier XLSX ici"

#. js-lingui-id: Dlfv6C
msgid "Simple payment process"
msgstr "Processus de paiement simple"

#. js-lingui-id: Dn4OyV
msgid "Invited"
msgstr "Invité"

#. js-lingui-id: DnXcDK
msgid "Secondary Color"
msgstr "Couleur secondaire"

#. js-lingui-id: DoJzLz
msgid "Collections"
msgstr "Collections"

#. js-lingui-id: Ds3qWZ
msgid "No Images Found"
msgstr "Aucune image trouvée"

#. js-lingui-id: Du6bPw
msgid "Address"
msgstr "Adresse"

#. js-lingui-id: DwuoH0
msgid "Facebook"
msgstr "Facebook"

#. js-lingui-id: E+kmgy
msgid "Your personal information"
msgstr "Vos informations personnelles"

#. js-lingui-id: E/QGRL
msgid "Disabled"
msgstr "Désactivé"

#. js-lingui-id: E/muDO
msgid "Documents"
msgstr "Documents"

#. js-lingui-id: E2QQUV
msgid "Total Units"
msgstr "Nombre total d'unités"

#. js-lingui-id: EAeu1Z
msgid "Send Invite"
msgstr "Envoyer une invitation"

#. js-lingui-id: ECHQNh
msgid "Need help with your application? We're here to assist you."
msgstr "Besoin d'aide pour votre candidature? Nous sommes là pour vous aider."

#. js-lingui-id: EG1klK
msgid "This report contains confidential information and is intended for authorized use only. Unauthorized reproduction or distribution is strictly prohibited."
msgstr "Ce rapport contient des informations confidentielles et est destiné à une utilisation autorisée uniquement. Toute reproduction ou distribution non autorisée est strictement interdite."

#. js-lingui-id: EJoQGk
msgid "Configure a reply-to address that will be added to all system emails"
msgstr "Configurer une adresse de réponse qui sera ajoutée à tous les emails système"

#. js-lingui-id: EKSQjb
msgid "The leading platform for secure rental applications"
msgstr "La plateforme leader pour les candidatures de location sécurisées"

#. js-lingui-id: EMiXCv
msgid "Enter number of years"
msgstr "Entrez le nombre d'années"

#. js-lingui-id: EN4IBj
msgid "Promotion added to unit"
msgstr "Promotion ajoutée à l'unité"

#. js-lingui-id: ENJDQl
msgid "View Full Documentation"
msgstr "Voir la documentation complète"

#. js-lingui-id: EOaL1y
msgid "Visit conclusive"
msgstr "Visite conclusive"

#. js-lingui-id: EUQxfg
msgid "Fetching user information..."
msgstr "Récupération des informations de l'utilisateur..."

#. js-lingui-id: EX1qi4
msgid "Upload Listings XLSX"
msgstr "Téléverser une liste d'annonces XLSX"

#. js-lingui-id: EXtiXe
msgid "Valid passport photo page"
msgstr "Photo de passeport valide"

#. js-lingui-id: EYK5tO
msgid "Project Name"
msgstr "Nom du projet"

#. js-lingui-id: EbFCme
msgid "No documents have been uploaded yet"
msgstr "Aucun document n'a été téléversé"

#. js-lingui-id: EbMPZJ
msgid "Unassigned"
msgstr "Non attribué"

#. js-lingui-id: EbuTi3
msgid "Alias"
msgstr "Alias"

#. js-lingui-id: EeZ0kf
msgid "Doe"
msgstr "Doe"

#. js-lingui-id: Ef7StM
msgid "Unknown"
msgstr "Inconnu"

#. js-lingui-id: Efav/Z
msgid "Manage application settings"
msgstr "Gérer les paramètres de l'application"

#. js-lingui-id: Eiidzq
msgid "Recent pay stub within 30 days"
msgstr "Justificatif de paie daté de moins de 30 jours"

#. js-lingui-id: Ekxv+g
msgid "This invitation link is no longer valid. Try signing in again."
msgstr "Ce lien d'invitation n'est plus valide. Essayez de vous connecter à nouveau."

#. js-lingui-id: ElGPqI
msgid "Rental"
msgstr "Location"

#. js-lingui-id: Em99RO
msgid "Waiting for agent to process"
msgstr "En attente du traitement par l'agent"

#. js-lingui-id: En7KCe
msgid "Hold to confirm"
msgstr "Maintenez pour confirmer"

#. js-lingui-id: Et7HPM
msgid "Continue Application"
msgstr "Continuer la candidature"

#. js-lingui-id: Ev7gHH
msgid "Public safety concerns recorded due to criminal activity."
msgstr "Problèmes de sécurité publique enregistrés en raison d'activités criminelles."

#. js-lingui-id: ExXy+X
msgid "Select Status"
msgstr "Sélectionner le statut"

#. js-lingui-id: F/iVsn
msgid "Your billing plan information"
msgstr "Vos informations de plan de facturation"

#. js-lingui-id: F2SymW
msgid "{price}$ / Monthly"
msgstr "{price}$ par mois"

#. js-lingui-id: F6PJ/y
msgid "Upcoming Deliveries"
msgstr "Livraisons à venir"

#. js-lingui-id: F6p/C4
msgid "Phone:"
msgstr "Téléphone:"

#. js-lingui-id: F6pfE9
msgid "Active"
msgstr "Actif"

#. js-lingui-id: F7G/TS
msgid "Frequently Asked Questions"
msgstr "Questions fréquemment posées"

#. js-lingui-id: F7dRcr
msgid "Fair"
msgstr "Passable"

#. js-lingui-id: FGByEW
msgid "Matches found on the OFAC sanctions list."
msgstr "Correspondances trouvées sur la liste des sanctions de l'OFAC."

#. js-lingui-id: FHriZ8
msgid "Previous tenant information updated"
msgstr "Informations du locataire précédent mises à jour"

#. js-lingui-id: FKAZwN
msgid "Manage settings for co-applicants and guarantors on the application"
msgstr "Gérer les paramètres pour les co-locataires et les garanteurs sur la candidature"

#. js-lingui-id: FMGl6q
msgid "<0>{price}$</0> per month"
msgstr "<0>{price}$</0> par mois"

#. js-lingui-id: FN82/x
msgid "Analysis based on GTI (Global Tenant Index) standards"
msgstr "Analyse basée sur les normes GTI (Global Tenant Index)"

#. js-lingui-id: FNlEzE
msgid "Continue my application"
msgstr "Continuer ma demande"

#. js-lingui-id: FNsxkO
msgid "Disposition"
msgstr "Disposition"

#. js-lingui-id: FPX4Rd
msgid "No references found"
msgstr "Aucune référence trouvée"

#. js-lingui-id: FWxdTT
msgid "Cleared"
msgstr "Vérifié"

#. js-lingui-id: FapWIq
msgid "Core Features"
msgstr "Fonctionnalités principales"

#. js-lingui-id: FbTWN1
msgid "Check back later."
msgstr "Vérifiez plus tard."

#. js-lingui-id: FbpJXz
msgid "Enter building name (optional)"
msgstr "Entrez le nom du bâtiment (facultatif)"

#. js-lingui-id: Fdp03t
msgid "on"
msgstr "le"

#. js-lingui-id: Fj50FP
msgid "Daily Recap"
msgstr "Récapitulatif quotidien"

#. js-lingui-id: FjaBem
msgid "The email is invalid"
msgstr "L'email est invalide"

#. js-lingui-id: FjrT4G
msgid "Choose Application Type"
msgstr "Choisir le type de demande"

#. js-lingui-id: Fk5NbU
msgid "On hold"
msgstr "En attente"

#. js-lingui-id: FkMol5
msgid "Featured"
msgstr "Mis en avant"

#. js-lingui-id: FlqkF1
msgid "Square footage"
msgstr "Superficie"

#. js-lingui-id: FswBjM
msgid "Submission Address"
msgstr "Addresse de la soumission"

#. js-lingui-id: FxFJ4e
msgid "Failed to import data"
msgstr "Échec de l'importation des données"

#. js-lingui-id: FxTn4x
msgid "{tenantName}: Rent this {type} with {bedrooms} bedrooms in {city}, {address}"
msgstr "{tenantName}: Louez ce {type} de {bedrooms} chambres à {city}, {address}"

#. js-lingui-id: Fy4HWw
msgid "PDF, JPG or PNG (Max 25MB)"
msgstr "PDF, JPG ou PNG (Max 25MB)"

#. js-lingui-id: FyavOr
msgid "What if I need to update my application information?"
msgstr "Que se passe-t-il si je dois mettre à jour les informations de ma candidature?"

#. js-lingui-id: G+h9DO
msgid "PROMO"
msgstr "PROMO"

#. js-lingui-id: G1VOz1
msgid "Employment Verification"
msgstr "Vérification de l'emploi"

#. js-lingui-id: G1WpOL
msgid "NAME"
msgstr "NOM"

#. js-lingui-id: G58cd9
msgid "Please upload the following documents to continue your application:"
msgstr "Veuillez téléverser les documents suivants pour continuer votre candidature:"

#. js-lingui-id: G6V8x2
msgid "Cancel Change"
msgstr "Annuler le changement"

#. js-lingui-id: G6dKO3
msgid "You applied on"
msgstr "Vous avez postulé le"

#. js-lingui-id: G6ehma
msgid "Notification sent to the applicant when you reject their application"
msgstr "Notification envoyée au demandeur lorsque vous rejetez leur candidature"

#. js-lingui-id: G7Ee56
msgid "Edit Credit Report Prices"
msgstr "Modifier les prix des rapports de crédit"

#. js-lingui-id: G8VwSE
msgid "Discard Submission"
msgstr "Rejeter la soumission"

#. js-lingui-id: G8krfe
msgid "Webhook Integration"
msgstr "Intégration de webhook"

#. js-lingui-id: GCPgtC
msgid "Current debt + housing costs as % of monthly income"
msgstr "Dettes + coûts de logement en % du revenu mensuel"

#. js-lingui-id: GCcKak
msgid "incomplete deliveries"
msgstr "livraisons incomplètes"

#. js-lingui-id: GDvlUT
msgid "Role"
msgstr "Role"

#. js-lingui-id: GHms8Q
msgid "Submissions snoozed"
msgstr "Soumissions mises en attente"

#. js-lingui-id: GKA1kw
msgid "Building Address"
msgstr "Adresse du bâtiment"

#. js-lingui-id: GM6r8L
msgid "Enter a promotional title"
msgstr "Entrez un titre promotionnel"

#. js-lingui-id: GP3VtI
msgid "Refund tenants their application fee"
msgstr "Rembourser les locataires leur frais de candidature"

#. js-lingui-id: GT1jUe
msgid "Note: While these options may help, approval is not guaranteed. Please discuss with the property manager."
msgstr "Note : Même si ces options peuvent aider, l'approbation n'est pas garantie. Veuillez discuter avec le propriétaire."

#. js-lingui-id: GVcaW6
msgid "Organization Details"
msgstr "Détails de l'organisation"

#. js-lingui-id: GXS4J1
msgid "Full Application Available"
msgstr "Formulaire complet disponible"

#. js-lingui-id: GjCAJg
msgid "Enter the 6-digit verification code that was sent to your email."
msgstr "Entrez le code de vérification à 6 chiffres qui a été envoyé à votre email."

#. js-lingui-id: GoxULk
msgid "Recent Bank Statements (last 3 months)"
msgstr "Relevés bancaires (derniers 3 mois)"

#. js-lingui-id: GpB8YV
msgid "Enterprise"
msgstr "Entreprise"

#. js-lingui-id: GqNjfs
msgid "Group snoozed submissions under their own category instead of having them inline with other submissions. This provides a cleaner organization of submissions based on their status."
msgstr "Groupez les soumissions en attente dans leur propre catégorie au lieu de les avoir en ligne avec les autres soumissions. Cela permet une organisation plus claire des soumissions en fonction de leur statut."

#. js-lingui-id: GtJbUa
msgid "Background"
msgstr "Contexte"

#. js-lingui-id: Gwzyfn
msgid "Select a listing"
msgstr "Sélectionner une annonce"

#. js-lingui-id: GxkJXS
msgid "Uploading..."
msgstr "Téléversement..."

#. js-lingui-id: H2AIsE
msgid "Try searching for something else."
msgstr "Essayez de rechercher autre chose."

#. js-lingui-id: H2EU8I
msgid "Add another address"
msgstr "Ajouter une autre adresse"

#. js-lingui-id: H4tgrw
msgid "Below Minimum Score"
msgstr "En dessous du score minimum"

#. js-lingui-id: H5HR1b
msgid "No credit inquiries found for the last 24 months"
msgstr "Aucune demande de crédit trouvée au cours des 24 derniers mois"

#. js-lingui-id: H5S5NO
msgid "Confirm & Reset Status"
msgstr "Confirmer et réinitialiser le statut"

#. js-lingui-id: HF6C2L
msgid "Phone Number"
msgstr "Numéro de téléphone"

#. js-lingui-id: HJ7K9X
msgid "Agent Assigned"
msgstr "Agent affecté"

#. js-lingui-id: HJEnON
msgid "Account opened since"
msgstr "Compte ouvert depuis"

#. js-lingui-id: HJebc2
msgid "Applicant name information is missing."
msgstr "Les informations du nom du candidat sont manquantes."

#. js-lingui-id: HQ1U8X
msgid "Verify the background history and related public records of the applicant"
msgstr "Vérifiez les antécédents et les dossiers publics associés du demandeur"

#. js-lingui-id: HZSI85
msgid "Minimum Credit Grade"
msgstr "Note de crédit minimale"

#. js-lingui-id: Hctf5Q
msgid "👋 Hello {firstName},<0/><1>Let's get your application processed!</1>"
msgstr "👋 Bonjour {firstName},<0/><1>On va traiter votre candidature !</1>"

#. js-lingui-id: HdNp/P
#. placeholder {0}: checks.length
msgid "{completedChecks, plural, zero {No checks ran} other {# / {0} checks ran}}"
msgstr "{completedChecks, plural, zero {Aucune vérification effectuée} other {# / {0} vérifications effectuées}}"

#. js-lingui-id: HeN7zs
msgid "Rent Only"
msgstr "Loyer uniquement"

#. js-lingui-id: HhVDr2
msgid "Listing"
msgstr "Annonce"

#. js-lingui-id: Hj9uqD
msgid "Rent Affordability"
msgstr "Accessibilité au loyer"

#. js-lingui-id: Hlwffm
msgid "Submission rejected successfully"
msgstr "Candidature rejetée avec succès"

#. js-lingui-id: Hnmg3x
msgid "Tenant Rating"
msgstr "Évaluation du locataire"

#. js-lingui-id: HoAdho
msgid "Edit Unit"
msgstr "Modifier l'unité"

#. js-lingui-id: HoKJXX
msgid "Request a free credit score check from your applicants within seconds"
msgstr "Demander une vérification de crédit gratuit à vos candidats en quelques secondes"

#. js-lingui-id: HsoeaR
msgid "Submission Process"
msgstr "Processus de soumission"

#. js-lingui-id: HvI0Mo
msgid "Loading units..."
msgstr "Chargement des unités..."

#. js-lingui-id: Hvgw7t
msgid "Multi-tenant buildings"
msgstr "Bâtiments à plusieurs locataires"

#. js-lingui-id: I0hU01
msgid "Search Projects"
msgstr "Rechercher les projets"

#. js-lingui-id: I2ODJi
msgid "Français"
msgstr "French"

#. js-lingui-id: I2T846
msgid "Credit Assessment"
msgstr "Évaluation de crédit"

#. js-lingui-id: I4auxj
msgid "Please provide the most recent address where you have lived for the last 6 months."
msgstr "Veuillez fournir l'adresse la plus récente où vous avez vécu au cours des 6 derniers mois."

#. js-lingui-id: I7CWPu
msgid "Absolutely! Eversa is a completely free platform. There are no hidden modules or features restricted behind a subscription. Enjoy full access to all our powerful tools for vacancy management without any additional costs."
msgstr "Absolument ! Eversa est une plateforme entièrement gratuite. Il n'y a pas de modules cachés ou de fonctionnalités restreintes derrière une inscription. Profitez d'un accès complet à tous nos outils puissants pour la gestion des vacances sans aucier coûts supplémentaires."

#. js-lingui-id: ICMeFK
msgid "Accuracy of Data:"
msgstr "Précision des données:"

#. js-lingui-id: ID6Zr+
msgid "Specify how many months of rent can be prepaid, in order to have the application reconsidered. This can be optional or required."
msgstr "Indiquez combien de mois de loyer peuvent être prépayés, afin de faire reconsidérer la candidature. Cela peut être facultatif ou obligatoire."

#. js-lingui-id: IDac6P
msgid "Edit Building"
msgstr "Modifier le bâtiment"

#. js-lingui-id: IEKWq5
msgid "Associated Product:"
msgstr "Produit associé:"

#. js-lingui-id: IEQzgN
msgid "{tenantName} rental: Spacious {type}, {bedrooms} bedrooms, {city}"
msgstr "Location {tenantName}: {type} spacieux, {bedrooms} chambres, {city}"

#. js-lingui-id: IITbPp
msgid "Lead"
msgstr "Prospect"

#. js-lingui-id: IM2CeX
msgid "Your application was incomplete or missing required information."
msgstr "Votre candidature était incomplète ou manquait des informations requises."

#. js-lingui-id: IMNkoY
msgid "Website URL is required"
msgstr "L'URL du site web est requise"

#. js-lingui-id: IUwGEM
msgid "Save Changes"
msgstr "Enregistrer les modifications"

#. js-lingui-id: IY/gko
msgid "From <0>{price}$</0> per month"
msgstr "De <0>{price}$</0> par mois"

#. js-lingui-id: IZBuxM
msgid "{tenantName} rental: {type} with {bedrooms} bedrooms, {address}, {city}"
msgstr "Location {tenantName}: {type} {bedrooms} chambres, {address}, {city}"

#. js-lingui-id: IaIcEJ
msgid "Verified AI Salary"
msgstr "Salaire vérifié par IA"

#. js-lingui-id: Iewazh
msgid "Waiting on the candidate application"
msgstr "En attente de la candidature du candidat"

#. js-lingui-id: IhK/fx
msgid "Landlord events & messages"
msgstr "Événements et messages du propriétaire"

#. js-lingui-id: Ii5qZa
msgid "Enter the applicant's basic details"
msgstr "Entrez les informations de base du candidat"

#. js-lingui-id: IlgkMC
msgid "Oops! We Hit a Small Bump"
msgstr "Oups ! Nous avons rencontré un petit obstacle"

#. js-lingui-id: In6IBd
msgid "Building Name"
msgstr "Nom du bâtiment"

#. js-lingui-id: IpLBXM
msgid "Rental Agent"
msgstr "Agent de location"

#. js-lingui-id: IrVrmR
msgid "Main applicant cannot be deleted"
msgstr "Le candidat principal ne peut pas être supprimé"

#. js-lingui-id: IvINDM
msgid "Where do you live now?"
msgstr "Où habitez-vous maintenant ?"

#. js-lingui-id: IwnKXj
msgid "Discard this submission"
msgstr "Rejeter cette soumission"

#. js-lingui-id: J/Upwb
msgid "days"
msgstr "jours"

#. js-lingui-id: J1B1dP
msgid "Modify"
msgstr "Modifier"

#. js-lingui-id: J2dS+A
msgid "No need to reapply or pay again during this period"
msgstr "Pas besoin de soumettre à nouveau ou de payer à nouveau pendant cette période"

#. js-lingui-id: J3YyL7
msgid "Write a clear message explaining what the tenant needs to do"
msgstr "Écrivez un message clair expliquant ce que le locataire doit faire"

#. js-lingui-id: J5n776
msgid "Browse Listings"
msgstr "Rechercher des annonces"

#. js-lingui-id: J8sZ7D
msgid "Action Required"
msgstr "Action requise"

#. js-lingui-id: JCb3JP
msgid "submissions"
msgstr "soumissions"

#. js-lingui-id: JEBt3r
msgid "Add Co-Applicant"
msgstr "Ajouter un co-applicant"

#. js-lingui-id: JF/w5z
msgid "What are you looking for?"
msgstr "Que cherchez-vous ?"

#. js-lingui-id: JHmKfG
msgid "Total {totalUnits} units"
msgstr "Total {totalUnits} unités"

#. js-lingui-id: JIP6qc
msgid "Currently renting"
msgstr "Actuellement en location"

#. js-lingui-id: JJCjZM
msgid "Information about the application"
msgstr "Informations sur la candidature"

#. js-lingui-id: JJzwOq
msgid "Failed to create user"
msgstr "Échec de la création de l'utilisateur"

#. js-lingui-id: JNCzPW
msgid "Country"
msgstr "Pays"

#. js-lingui-id: JS/504
msgid "Number of months"
msgstr "Nombre de mois"

#. js-lingui-id: JUce1S
msgid "Assignees"
msgstr "Responsable"

#. js-lingui-id: Jc7aDb
msgid "Credit report prices updated successfully"
msgstr "Prix des rapports de crédit mis à jour avec succès"

#. js-lingui-id: JdiJHl
msgid "Building:"
msgstr "Bâtiment:"

#. js-lingui-id: JdkdDD
msgid "Action Required: Application Needs Additional Support"
msgstr "Action requise : Candidature nécessitant une assistance supplémentaire"

#. js-lingui-id: JdnU4B
msgid "Our team has been automatically notified and is investigating the issue."
msgstr "Notre équipe a été automatiquement notifiée et est en train d'enquêter sur le problème."

#. js-lingui-id: Je4WIx
msgid "24-48 business hours"
msgstr "24-48 heures ouvrables"

#. js-lingui-id: JesBBS
msgid "Joint"
msgstr "Conjoint"

#. js-lingui-id: JgSSDZ
msgid "Please provide address history for the last 6 months"
msgstr "Veuillez fournir votre historique d'adresses des 6 derniers mois."

#. js-lingui-id: Jh2n6b
msgid "Applicant"
msgstr "Candidat"

#. js-lingui-id: JhtZAK
msgid "Payment Failed"
msgstr "Paiement échoué"

#. js-lingui-id: JiFNm/
msgid "Individual at risk"
msgstr "Particulier à risque"

#. js-lingui-id: Jj0hAF
msgid "Verify income stability and payment history"
msgstr "Vérifier la stabilité du revenu et l'historique des paiements"

#. js-lingui-id: JkToak
msgid "Max Prices"
msgstr "Prix max"

#. js-lingui-id: JmGR0x
msgid "Digital Banks"
msgstr "Banques numériques"

#. js-lingui-id: JnZYox
msgid "Submission steps updated"
msgstr "Étapes de la candidature mises à jour"

#. js-lingui-id: JnpUum
msgid "120 days"
msgstr "120 jours"

#. js-lingui-id: JpohL9
msgid "Tax"
msgstr "Taxe"

#. js-lingui-id: JtMAqE
msgid "Application steps"
msgstr "Étapes de la candidature"

#. js-lingui-id: JviCz3
msgid "studio"
msgstr "studio"

#. js-lingui-id: K+XQwI
msgid "With Utilities: "
msgstr "Avec les services: "

#. js-lingui-id: K/9IDx
msgid "Application Progress"
msgstr "Progression de la candidature"

#. js-lingui-id: K/H+7R
msgid "Background Check"
msgstr "Vérification des antécédents"

#. js-lingui-id: K0KvwX
msgid "Enter the code that your roommate shared with you <0/>to apply with him on the same application folder"
msgstr "Entrez le code que votre colocataire a partagé avec vous <0/> pour postuler avec lui sur le même dossier de candidature"

#. js-lingui-id: K0s8ir
msgid "Select your unit"
msgstr "Sélectionnez votre unité"

#. js-lingui-id: K3YBpU
msgid "Recommended For"
msgstr "Recommandé pour"

#. js-lingui-id: K3ZYUz
msgid "Co-Applicant"
msgstr "Co-Applicant"

#. js-lingui-id: K3k80a
msgid "Industry standard is 3.0x (tenant's income should be at least 3 times the rent)"
msgstr "Norme industrielle : 3.0x (le revenu du locataire doit être au moins 3 fois supérieur au loyer)"

#. js-lingui-id: K3ktVp
msgid "Exclusive insights powered by Eversa's proprietary analytics, comparing against the last 100 verified tenants within a 15km radius of {location}."
msgstr "Informations exclusives fournies par les analyses exclusives d'Eversa, en comparaison avec les 100 derniers locataires vérifiés dans un rayon de 15 km de {location}."

#. js-lingui-id: K6Lyfl
msgid "This person is unscored by equifax. Review the report."
msgstr "Cette personne n'a pas de pointage Equifax. Examinez le rapport."

#. js-lingui-id: K7E9cE
msgid "Allow reapplication with conditions"
msgstr "Permettre au locataire de soumettre à nouveau avec des conditions"

#. js-lingui-id: K7P0jz
msgid "Last Updated"
msgstr "Dernière mise à jour"

#. js-lingui-id: K7lqZC
msgid "Needs Review"
msgstr "À examiner"

#. js-lingui-id: K7tIrx
msgid "Category"
msgstr "Catégorie"

#. js-lingui-id: KAUVJk
msgid "Incomplete Application Reminder"
msgstr "Rappel de candidature incomplète"

#. js-lingui-id: KBDepC
msgid "Browse and manage your candidate submissions"
msgstr "Rechercher et gérer vos candidatures"

#. js-lingui-id: KBEIU2
msgid "Criminal Record"
msgstr "Enregistrement criminel"

#. js-lingui-id: KCmnMN
msgid "Address not showing up in search?"
msgstr "Adresse ne pas apparaître dans la recherche ?"

#. js-lingui-id: KF17MC
msgid "Additional description"
msgstr "Description supplémentaire"

#. js-lingui-id: KFXip/
msgid "John"
msgstr "John"

#. js-lingui-id: KKPeSn
msgid "Ideal financial profile with comfortable budget allocation"
msgstr "Profil financier idéal avec une allocation de budget confortable"

#. js-lingui-id: KM6m8p
msgid "Team"
msgstr "Équipe"

#. js-lingui-id: KOCETe
msgid "ID Verification"
msgstr "Vérification d'identité"

#. js-lingui-id: KOG1wV
msgid "{resendCooldown, plural, other {Resend (#s)} zero {Resend}}"
msgstr "{resendCooldown, plural, other {Renvoyer (#s)} zero {Renvoyer}}"

#. js-lingui-id: KPx1UV
msgid "Not found"
msgstr "Non trouvé"

#. js-lingui-id: KQjYWM
msgid "Minimum required income as multiple of total debt"
msgstr "Revenu minimum requis en multiple de la dette totale"

#. js-lingui-id: KVD/9J
msgid "Comfortable budget (30% of available income)"
msgstr "Budget confortable (30% du revenu disponible)"

#. js-lingui-id: KYmd1x
msgid "Not run"
msgstr "Non exécuté"

#. js-lingui-id: KYpn10
msgid "None found"
msgstr "Aucune"

#. js-lingui-id: KcAcW0
msgid "Missing Data"
msgstr "Données manquantes"

#. js-lingui-id: KeyePW
msgid "Risks"
msgstr "Risques"

#. js-lingui-id: KgEfI7
msgid "No delivery"
msgstr "Aucune livraison"

#. js-lingui-id: Ki1yxx
msgid "My Application"
msgstr "Ma candidature"

#. js-lingui-id: KkftOv
msgid "Search units..."
msgstr "Rechercher des unités..."

#. js-lingui-id: Knza6y
msgid "For {tenantsFullName}"
msgstr "Pour {tenantsFullName}"

#. js-lingui-id: KpqBx6
msgid "Payment Method Required"
msgstr "Méthode de paiement requise"

#. js-lingui-id: KtDx3N
msgid "Stale submissions"
msgstr "Soumissions stagnantes"

#. js-lingui-id: KtZGMj
msgid "Moderate (43-48%)"
msgstr "Modéré (43-48%)"

#. js-lingui-id: KxmprN
msgid "Prepaid by organization"
msgstr "Prépayé par l'organisation"

#. js-lingui-id: L63FSw
msgid "Only CSV files are accepted"
msgstr "Seuls les fichiers CSV sont acceptés"

#. js-lingui-id: L6jHxy
msgid "Note: This is not a standard legal reason for rejection. Please ensure you have a valid justification and document it clearly below."
msgstr "Note : Cette raison n'est pas standard et légale. Assurez-vous que vous avez une justification valide et documentez-la clairement ci-dessous."

#. js-lingui-id: LAqQS2
msgid "Unfortunately, at this moment your application has been rejected. You can always try again later or contact the property manager if your situation changes."
msgstr "Malheureusement, à ce moment, votre candidature a été rejetée. Vous pouvez toujours réessayer plus tard ou contacter le propriétaire si votre situation change."

#. js-lingui-id: LF/DpI
msgid "units"
msgstr "unités"

#. js-lingui-id: LGbIQa
msgid "Legal Record Check"
msgstr "Vérification des antécédents judiciaires"

#. js-lingui-id: LHt0ym
msgid "There is no other parking available for this unit"
msgstr "Il n'y a pas d'autre stationnement disponible pour cette unité"

#. js-lingui-id: LI8uGi
msgid "Not yet started"
msgstr "Pas encore commencé"

#. js-lingui-id: LIkwbx
msgid "Impact on Your Credit Score:"
msgstr "Impact sur votre score de crédit:"

#. js-lingui-id: LLAa/9
msgid "Optional"
msgstr "Optionel"

#. js-lingui-id: LLMG9b
msgid "Landlord references"
msgstr "Références de propriétaires"

#. js-lingui-id: LMRMbD
msgid "Please select a reason for rejection"
msgstr "Veuillez sélectionner une raison de rejet"

#. js-lingui-id: LOuCXG
msgid "Current street address"
msgstr "Adresse de la rue actuelle"

#. js-lingui-id: LRpvAQ
msgid "bedrooms"
msgstr "chambres"

#. js-lingui-id: LTE9JA
msgid "Add Lead"
msgstr "Ajouter un prospect"

#. js-lingui-id: LTPxQT
msgid "Adverse media screening"
msgstr "Vérification des médias adverses"

#. js-lingui-id: LXHzuB
msgid "Collection Details"
msgstr "Détails de la collection"

#. js-lingui-id: LYixP5
msgid "Description (English)"
msgstr "Description (anglais)"

#. js-lingui-id: Ld+F/n
msgid "Very High Risk"
msgstr "Risque très élevé"

#. js-lingui-id: LdA9gy
msgid "Submissions"
msgstr "Soumissions"

#. js-lingui-id: Lek+XJ
msgid "Confidence"
msgstr "Confiance"

#. js-lingui-id: LhgWCf
msgid "Leads"
msgstr "Prospects"

#. js-lingui-id: LiXUlk
msgid "Agent Resolution Tools"
msgstr "Outils de résolution des agents"

#. js-lingui-id: LpmpQP
msgid "Start your rental journey here as the primary applicant"
msgstr "Commencez votre demande de location ici en tant que locataire principal"

#. js-lingui-id: LrzeOq
msgid "Verification Check"
msgstr "Vérification"

#. js-lingui-id: LtI9AS
msgid "Owner"
msgstr "Propriétaire"

#. js-lingui-id: LunyK6
msgid "Criminal Check"
msgstr "Vérification des antécédents criminels"

#. js-lingui-id: Lyw/ID
msgid "Unsatisfactory credit score"
msgstr "Cote de crédit insatisfaisante"

#. js-lingui-id: M/mkqh
msgid "Would you like to receive updates about your application?"
msgstr "Souhaitez-vous recevoir des mises à jour concernant votre demande ?"

#. js-lingui-id: M1j835
msgid "You must provide your Social Insurance Number (SIN) to proceed with the credit check"
msgstr "Vous devez fournir votre numéro d'assurance sociale (SIN) pour procéder à la vérification de crédit"

#. js-lingui-id: M5d0SP
msgid "Get in touch with us"
msgstr "Contactez-nous"

#. js-lingui-id: M7toNQ
msgid "Employment Reference"
msgstr "Référence d'emploi"

#. js-lingui-id: M8Ezeb
msgid "Show all listings with no submissions"
msgstr "Afficher toutes les annonces sans soumissions"

#. js-lingui-id: M9f590
msgid "Message to Tenant"
msgstr "Message au locataire"

#. js-lingui-id: MBK3eV
msgid "Total Leads"
msgstr "Nombre total de prospects"

#. js-lingui-id: MCar+A
msgid "Unit# {unitIdx}"
msgstr "Unité # {unitIdx}"

#. js-lingui-id: MDSNaj
msgid "This is the unit that the leads will be associated with."
msgstr "C'est l'unité à laquelle les prospects seront associés."

#. js-lingui-id: MFKlMB
msgid "Invite"
msgstr "Inviter"

#. js-lingui-id: MFeLgd
msgid "Currently processing with the property manager"
msgstr "En cours de traitement avec le propriétaire"

#. js-lingui-id: MFmWqO
msgid "Snooze until"
msgstr "Mettre en veille jusqu'à"

#. js-lingui-id: MHZVb9
msgid "Add Unit"
msgstr "Ajouter une unité"

#. js-lingui-id: MHrjPM
msgid "Title"
msgstr "Titre"

#. js-lingui-id: MJjU9q
msgid "Personal References"
msgstr "Références personnelles"

#. js-lingui-id: MKY58I
msgid "Manage your notifications settings."
msgstr "Gérer vos paramètres de notifications."

#. js-lingui-id: MLbP4/
msgid "What happens to my data after the application process?"
msgstr "Que devient mes données après le processus de candidature?"

#. js-lingui-id: MNQQ32
msgid "You must accept the following consents in order to continue with the application"
msgstr "Vous devez accepter les consentements suivants pour pouvoir continuer avec la candidature"

#. js-lingui-id: MRvPaD
msgid "Which address are you looking to rent?"
msgstr "Quelle adresse recherchez-vous à louer?"

#. js-lingui-id: MTqQMG
msgid "Not set"
msgstr "Non défini"

#. js-lingui-id: MUWaDL
msgid "By signing in, you agree to our <0>Terms of Service</0> and <1>Privacy Policy</1>"
msgstr "En vous connectant, vous acceptez nos <0>Conditions d'utilisation</0> et notre <1>Politique de confidentialité</1>"

#. js-lingui-id: MXQYu9
msgid "Fraudulent activity recorded within the last 10 years."
msgstr "Activité frauduleuse enregistrée au cours des 10 dernières années."

#. js-lingui-id: MXwX+5
msgid "Reply-to email address"
msgstr "Adresse courriel de réponse"

#. js-lingui-id: MYF9A3
msgid "No issues"
msgstr "Aucun problème"

#. js-lingui-id: MZ2jYd
msgid "Civil Cases"
msgstr "Affaires civiles"

#. js-lingui-id: MaaF2N
msgid "Evaluations, comments, or opinions expressed by third parties in the report solely represent their authors and do not reflect Eversa's official position."
msgstr "Les évaluations, commentaires ou opinions exprimées par des tiers dans le rapport représentent uniquement leurs auteurs et ne reflètent pas la position officielle d'Eversa."

#. js-lingui-id: Mb1gMp
msgid "Candidate Selection Confirmation"
msgstr "Confirmation de sélection de candidat"

#. js-lingui-id: Mc2mRX
msgid "Upload Units CSV"
msgstr "Téléverser les unités CSV"

#. js-lingui-id: Mc4C+Q
msgid "General Information"
msgstr "Informations générales"

#. js-lingui-id: MedRpe
msgid "Action Required: Missing Documents"
msgstr "Action requise: Documents manquants"

#. js-lingui-id: MjE6Ou
msgid "Payment status legend"
msgstr "Légende du statut de paiement"

#. js-lingui-id: Mk5J6H
msgid "Start Live Chat"
msgstr "Commencer un chat en direct"

#. js-lingui-id: MlMR7R
msgid "You are applying in anonymous mode. Do not exit until the process is completed."
msgstr "Vous postulez en mode anonyme. Ne quittez pas la page avant la fin du processus."

#. js-lingui-id: Mm7JVd
msgid "Select the financial documents the tenant needs to provide"
msgstr "Sélectionnez les documents financiers que le locataire doit fournir"

#. js-lingui-id: MnTRqF
msgid "Debt-to-Income Risk"
msgstr "Risque de dette/revenu"

#. js-lingui-id: MqRv3R
msgid "This application has been snoozed until <0>{formatedDate}</0> while we wait for additional information from the applicant."
msgstr "Cette candidature a été mise en veille jusqu'à <0>{formatedDate}</0> pendant que nous attendons des informations supplémentaires du locataire."

#. js-lingui-id: MrALkn
msgid "Unnamed Unit"
msgstr "Unité sans nom"

#. js-lingui-id: MtylGR
msgid "Last payment on"
msgstr "Dernier paiement le"

#. js-lingui-id: N+JUcd
msgid "AI Analyzing..."
msgstr "Analyse par IA..."

#. js-lingui-id: N0bsdK
msgid "I understand that this accommodation allows smoking only within the designated areas of the premises"
msgstr "Je comprends que cet hébergement n'autorise pas les animaux de compagnie et confirme que je n'ai pas d'animaux de compagnie et aucun adoptés durant mon bail"

#. js-lingui-id: N0tfJu
msgid "Enter detailed explanation for rejection"
msgstr "Entrez une explication détaillée du rejet"

#. js-lingui-id: N10ubo
msgid "Application Form"
msgstr "Formulaire de candidature"

#. js-lingui-id: N18LVt
msgid "You've successfully assigned {firstName} {lastName} as the visit agent for this submission"
msgstr "Vous avez assigné {firstName} {lastName} comme agent de visite pour cette soumission"

#. js-lingui-id: N3z5On
msgid "Application form updated"
msgstr "Formulaire de candidature mis à jour"

#. js-lingui-id: N40H+G
msgid "All"
msgstr "Tous"

#. js-lingui-id: N6Pxr9
msgid "View all"
msgstr "Tout afficher"

#. js-lingui-id: N6YUZ6
msgid "No reports available"
msgstr "Aucun rapport disponible"

#. js-lingui-id: N8s2uA
msgid "Current Employer"
msgstr "Employeur actuel"

#. js-lingui-id: N9+NTZ
msgid "SOQUIJ Check"
msgstr "Vérification SOQUIJ"

#. js-lingui-id: NAfv8v
msgid "You can either share this link with your applicants or invite them directly:"
msgstr "Vous pouvez partager ce lien avec vos candidats ou inviter un locataire directement :"

#. js-lingui-id: NCKmP9
msgid "Smart tenant screening and verification"
msgstr "Sélection et vérification intelligentes des locataires"

#. js-lingui-id: NDzzB2
#. placeholder {0}: Math.floor( (Date.now() - new Date(submission.createdAt).getTime()) / (1000 * 60 * 60 * 24), )
msgid "{0, plural, one {day ago} other {days ago}}"
msgstr "{0, plural, one {jour} other {jours}}"

#. js-lingui-id: NEz9zJ
msgid "{title} Logo"
msgstr "{title} Logo"

#. js-lingui-id: NLRDW6
msgid "I own my property"
msgstr "Je possède ma propriété"

#. js-lingui-id: NMkGFJ
msgid "Your application is currently under review. You will be notified once your application status has been updated."
msgstr "Votre candidature est actuellement en cours de révision. Vous serez notifié une fois que le statut de votre candidature aura été mis à jour."

#. js-lingui-id: NN9s1/
msgid "Listed Units"
msgstr "Unités listées"

#. js-lingui-id: NP1kQD
msgid "Credit Score Distribution"
msgstr "Distribution du score de crédit"

#. js-lingui-id: NRbfCD
msgid "Customize which emails are sent to tenants, managers, and rental agents."
msgstr "Personnalisez les emails envoyés aux locataires, aux gestionnaires et aux agents de location."

#. js-lingui-id: NReIne
msgid "Staff members have access to most features but cannot modify organization settings or manage billing information."
msgstr "Les membres du personnel ont accès à la plupart des fonctionnalités mais ne peuvent pas modifier les paramètres de l'organisation ou gérer les informations de facturation."

#. js-lingui-id: NSB8fL
msgid "Enable projects to allow you to better manage big building with floor plans."
msgstr "Activez les projets pour vous permettre de mieux gérer les grands bâtiments avec des plans d'étage."

#. js-lingui-id: NSMp/T
msgid "Past 7 Years"
msgstr "7 dernières années"

#. js-lingui-id: NT6xx2
msgid "{tenantName} real estate: {type} for rent, {bedrooms} bedrooms, {city}"
msgstr "{tenantName} immobilier: {type} à louer, {bedrooms} chambres, {city}"

#. js-lingui-id: NV08sc
msgid "Additional Income Verification"
msgstr "Vérification des revenus supplémentaires"

#. js-lingui-id: NWCzYK
msgid "Verified by"
msgstr "Vérifié par"

#. js-lingui-id: NWzF+B
msgid "Configure your project information and media"
msgstr "Configurez les informations et les médias de votre projet"

#. js-lingui-id: NXnhFo
msgid "Select a visit agent"
msgstr "Sélectionnez un agent de visite"

#. js-lingui-id: NjELnu
msgid "Your current application does not meet the minimum requirements. The property manager requires an additional person (partner, friend, parent or endorser) to strengthen your application before it can be processed."
msgstr "Votre candidature actuelle ne répond pas aux exigences minimales. Le propriétaire exige un autre candidat (conjoint, ami, parent ou co-signataire) pour renforcer votre candidature avant qu'elle ne soit traitée."

#. js-lingui-id: Nm9j8O
msgid "No reason provided"
msgstr "Aucune raison fournie"

#. js-lingui-id: NmHsVh
msgid "Agency"
msgstr "Agence"

#. js-lingui-id: Nna+K+
msgid "Require tenants to provide employment references"
msgstr "Exiger que les locataires fournissent des références d'emploi"

#. js-lingui-id: NoqawS
msgid "Your application was declined for reasons not listed above."
msgstr "Votre candidature a été rejetée pour des raisons non listées ci-dessus."

#. js-lingui-id: Np28ib
msgid "or drag and drop"
msgstr "ou glisser-déposer"

#. js-lingui-id: NqjG2t
msgid "End Date (Optional)"
msgstr "Date de fin (optionnel)"

#. js-lingui-id: NsJhl4
msgid "Application code"
msgstr "Code de candidature"

#. js-lingui-id: Nu4oKW
msgid "Description"
msgstr "Description"

#. js-lingui-id: NuKR0h
msgid "Others"
msgstr "Autres"

#. js-lingui-id: NuSsH1
msgid "Available Now"
msgstr "Disponible maintenant"

#. js-lingui-id: NxgXoy
msgid "New Application"
msgstr "Nouvelle candidature"

#. js-lingui-id: NytLLx
msgid "Quick reference for API usage"
msgstr "Référence rapide pour l'utilisation de l'API"

#. js-lingui-id: O00iuX
msgid "Delivery Status"
msgstr "Statut de la livraison"

#. js-lingui-id: O19s8b
msgid "Move to lead"
msgstr "Convertir en prospect"

#. js-lingui-id: O38AQw
msgid "Criminal record"
msgstr "Casier judiciaire"

#. js-lingui-id: O3oNi5
msgid "Email"
msgstr "E-mail"

#. js-lingui-id: O5dfBV
msgid "TAL check price must be greater than or equal to 0"
msgstr "Le prix de la vérification TAL doit être supérieur ou égal à 0"

#. js-lingui-id: OBPWiD
msgid "At least one check must be selected."
msgstr "Au moins une vérification doit être sélectionnée."

#. js-lingui-id: OD4V1R
msgid "Invite New Applicant"
msgstr "Inviter un nouveau candidat"

#. js-lingui-id: ODIyTS
msgid "Total Applicants"
msgstr "Nombre total de candidats"

#. js-lingui-id: OEEQKT
msgid "Good"
msgstr "Bon"

#. js-lingui-id: OEY+18
msgid "I understand that this accommodation allows a maximum of <strong>{limit}</strong>. I do not own and do not intend to own, adopt, or foster any pets exceeding the maximum allowed for the duration of my lease"
msgstr "Je comprends que cet hébergement n'autorise pas les animaux de compagnie et confirme que je n'ai pas d'animaux de compagnie et aucun adoptés durant mon bail"

#. js-lingui-id: OJx3wK
msgid "Not available"
msgstr "Non disponible"

#. js-lingui-id: OMIIhk
msgid "View profile & reports"
msgstr "Voir le profil et les rapports"

#. js-lingui-id: OMoGg1
msgid "Group Snoozed Submissions"
msgstr "Grouper les soumissions en attente"

#. js-lingui-id: ONWvwQ
msgid "Upload"
msgstr "Téléverser"

#. js-lingui-id: OQtpE1
msgid "People in the accommodation"
msgstr "Le nombre dans le logement"

#. js-lingui-id: OS7Bzf
msgid "Documentation of any additional sources of income"
msgstr "Documents montrant vos revenus supplémentaires"

#. js-lingui-id: OTK3hi
msgid "May need additional verification"
msgstr "Peut nécessiter une vérification supplémentaire"

#. js-lingui-id: OTi1Uv
msgid "Your Recent Searches"
msgstr "Vos recherches récentes"

#. js-lingui-id: OXE9D1
msgid "Add Building"
msgstr "Ajouter un bâtiment"

#. js-lingui-id: Ob2yoM
msgid "Bankruptcy Details"
msgstr "Détails de la faillite"

#. js-lingui-id: OdaIDu
msgid "Financial Documents"
msgstr "Documents financiers"

#. js-lingui-id: OhdzQS
msgid "We strive to provide the best experience possible. Our team is here to help you every step of the way."
msgstr "Nous nous efforçons de fournir la meilleure expérience possible. Notre équipe est là pour vous aider à chaque étape du processus."

#. js-lingui-id: OiAzW8
msgid "What you can try:"
msgstr "Ce que vous pouvez faire :"

#. js-lingui-id: OiZ8hq
msgid "Late Payments"
msgstr "Paiements en retard"

#. js-lingui-id: Omol7X
msgid "Please provide your current or previous employer information"
msgstr "Veuillez fournir les informations de votre employeur actuel ou précédent"

#. js-lingui-id: On0aF2
msgid "Website"
msgstr "Site Web"

#. js-lingui-id: OqE648
msgid "Has the landlord approved this submission"
msgstr "Le propriétaire a approuvé cette soumission"

#. js-lingui-id: OrJTfQ
msgid "After submitting the address, you'll be directed to the full application form."
msgstr "Après avoir soumis l'adresse, vous serez redirigé vers le formulaire de candidature complet."

#. js-lingui-id: OsMawZ
msgid "Request additional documents"
msgstr "Demander des documents supplémentaires"

#. js-lingui-id: OsQEiG
msgid "Years at Current Job"
msgstr "Nombre d'années dans le travail actuel"

#. js-lingui-id: OtBeea
msgid "How many parking spots are available?"
msgstr "Combien de places de stationnement sont disponibles?"

#. js-lingui-id: OudWKn
msgid "Save Threshold"
msgstr "Enregistrer le seuil"

#. js-lingui-id: Oue+Zo
msgid "Upload an XLSX file containing listing data. The file should contain columns for project, street, city, region, postal code, unit alias, area, bedrooms, bathrooms, availability, status, and price."
msgstr "Téléverser un fichier XLSX contenant des données d'annonces. Le fichier doit contenir les colonnes pour le projet, la rue, la ville, la région, le code postal, l'alias de l'unité, la superficie, le nombre de chambres, le nombre de salles de bain, la disponibilité, le statut et le prix."

#. js-lingui-id: P+2STN
msgid "The phone is required"
msgstr "Le numéro de téléphone est requis"

#. js-lingui-id: P+gnB7
msgid "Please try again"
msgstr "Veuillez réessayer"

#. js-lingui-id: P05GKN
msgid "By entering your email and clicking verify, you agree to our <0>Terms of Service</0> and <1>Privacy Policy</1>"
msgstr "En saisissant votre e-mail et en cliquant sur vérifier, vous acceptez nos <0>Conditions d'utilisation</0> et notre <1>Politique de confidentialité</1>"

#. js-lingui-id: P1vDY9
msgid "Invite a candidate to submit their rental application"
msgstr "Inviter un candidat à soumettre sa candidature de location"

#. js-lingui-id: P31uf3
msgid "Your session has expired, please log-in again"
msgstr "Votre session a expiré, veuillez vous reconnecter"

#. js-lingui-id: P3a4ZV
msgid "* Based on 40 hour work week, 52 weeks per year"
msgstr "* Basé sur une semaine de travail de 40 heures, 52 semaines par an"

#. js-lingui-id: P3iqiW
msgid "Walk Score®"
msgstr "Score de mobilité"

#. js-lingui-id: P6mkiz
msgid "Last Activity On"
msgstr "Dernière activité le"

#. js-lingui-id: P8LTFo
msgid "Departure date: "
msgstr "Date de départ : "

#. js-lingui-id: P9FngO
msgid "How secure is your application system?"
msgstr "À quel point votre système de candidature est-il sécurisé?"

#. js-lingui-id: P9cEa2
msgid "30 days"
msgstr "30 jours"

#. js-lingui-id: P9vDWz
msgid "You have activated reference checks for enhanced screening! This premium feature automatically includes both employment and landlord reference checks to provide comprehensive verification of your applicants' rental and employment history."
msgstr "Vous avez activé les vérifications de références pour un meilleur filtrage! Cette fonctionnalité premium inclut automatiquement la vérification des références d'emploi et de propriétaire pour une validation complète des antécédents locatifs et professionnels de vos candidats."

#. js-lingui-id: PAt0J+
msgid "Delete Lead"
msgstr "Supprimer le prospect"

#. js-lingui-id: PG3GFs
msgid "This user is a new arrival and may have limited credit history."
msgstr "Cet utilisateur est un nouvel arrivant et peut avoir un historique de crédit limité."

#. js-lingui-id: PMd7cF
msgid "Search by unit #..."
msgstr "Rechercher par unité"

#. js-lingui-id: PUhyfz
msgid "{v} bedrooms"
msgstr "{v} chambres"

#. js-lingui-id: PVHnhm
msgid "Contact information for scheduling property visits"
msgstr "Informations de contact pour planifier les visites de propriété"

#. js-lingui-id: PWlTvh
msgid "Records"
msgstr "Dossiers juridiques"

#. js-lingui-id: PaFTsF
msgid "Financial Health & Income"
msgstr "Santé financière et revenu"

#. js-lingui-id: Pc5PZG
msgid "Contact Person's Name"
msgstr "Nom du contact"

#. js-lingui-id: PcMNcC
msgid "Existing application"
msgstr "Candidature existante"

#. js-lingui-id: PgBPZr
msgid "Entry Date"
msgstr "Date d'entrée"

#. js-lingui-id: PhT57J
msgid "Manage your analytics settings."
msgstr "Gérer vos paramètres d'analyse."

#. js-lingui-id: Phi/9J
msgid "Delete lead"
msgstr "Supprimer le prospect"

#. js-lingui-id: PiK6Ld
msgid "Sat"
msgstr "Sam"

#. js-lingui-id: PkavNK
msgid "Re-open submission"
msgstr "Rouvrir la soumission"

#. js-lingui-id: PpZkda
msgid "Features"
msgstr "Fonctionnalités"

#. js-lingui-id: Ppm/ZC
msgid "Consider requesting additional income verification or a co-signer."
msgstr "Considérer la demande d'une vérification supplémentaire des revenus ou d'un co-signataire."

#. js-lingui-id: Pqo+0V
msgid "Upload images"
msgstr "Téléverser des images"

#. js-lingui-id: Pu6jDK
msgid "Enter endorser details yourself directly into the application."
msgstr "Saisissez les détails de votre co-signataire directement dans la candidature."

#. js-lingui-id: PxMcud
msgid "Current balance"
msgstr "Solde actuel"

#. js-lingui-id: PzVLHy
msgid "Show all listings with no sumbissions"
msgstr "Afficher toutes les annonces sans soumissions"

#. js-lingui-id: Q+34AT
msgid "{tooltipText}: N/A"
msgstr "{tooltipText}: N/A"

#. js-lingui-id: Q0h3vr
msgid "Application Complete"
msgstr "Candidature terminée"

#. js-lingui-id: Q2bkKO
msgid "No Hit"
msgstr "Aucun résultat"

#. js-lingui-id: Q605++
msgid "More flexible requirements"
msgstr "Exigences plus flexibles"

#. js-lingui-id: Q7h9s/
msgid "Create project"
msgstr "Créer un projet"

#. js-lingui-id: Q891VP
msgid "Enter building address"
msgstr "Entrez l'adresse du bâtiment"

#. js-lingui-id: QBVJWt
msgid "Already Started or Current Tenant?"
msgstr "Déjà commencé ou actuellement locataire?"

#. js-lingui-id: QDEWii
msgid "Verified"
msgstr "Vérifié"

#. js-lingui-id: QFd3BD
msgid "You can reorder images by dragging them once uploaded"
msgstr "Vous pouvez réorganiser les images en les faisant glisser une fois téléchargées"

#. js-lingui-id: QG3fwQ
msgid "The webhook will receive updates for specified events."
msgstr "Le webhook recevra des mises à jour pour les événements spécifiés."

#. js-lingui-id: QHxHGy
msgid "We have received your application, it is currently under review"
msgstr "Nous avons reçu votre candidature, elle est actuellement en cours de révision"

#. js-lingui-id: QJKd/s
msgid "Building added successfully"
msgstr "Bâtiment ajouté avec succès"

#. js-lingui-id: QJe728
msgid "{bedrooms} bedrooms, {city} - {tenantName} {type} for rent"
msgstr "{bedrooms} chambres, {city} - {type} {tenantName} à louer"

#. js-lingui-id: QJwofm
msgid "Export data"
msgstr "Exporter les données"

#. js-lingui-id: QN14C2
msgid "When you merge applicants, their individual submissions will be removed and all their information will be consolidated into this submission. This action cannot be undone."
msgstr "Lorsque vous fusionnez des candidats, leurs soumissions individuelles seront supprimées et toutes leurs informations seront consolidées dans cette soumission. Cette action ne peut pas être annulée."

#. js-lingui-id: QN2QH5
msgid "Date of Birth Provided"
msgstr "Date de naissance fournie"

#. js-lingui-id: QNRVvn
msgid "Co-applicants"
msgstr "Co-demandeurs"

#. js-lingui-id: QOk9ZU
msgid "No credit check data available."
msgstr "Aucune donnée de vérification de crédit disponible."

#. js-lingui-id: QP/Bmv
msgid "Add a banner to the top of the website to display important information."
msgstr "Ajoutez une bannière en haut du site Web pour afficher des informations importantes."

#. js-lingui-id: QQQzoh
msgid "No of rooms"
msgstr "Nombre de chambres"

#. js-lingui-id: QQluOg
msgid "Upload Additional Documents:"
msgstr "Téléverser des documents supplémentaires:"

#. js-lingui-id: QRyHTH
msgid "Submission Listing"
msgstr "Liste de soumissions"

#. js-lingui-id: QVDuYI
msgid "Upload Listings"
msgstr "Téléverser les listes d'annonces"

#. js-lingui-id: QVgwmt
msgid "Please try again later. Or contact support if the issue persists."
msgstr "Veuillez réessayer plus tard. Ou contactez le support si le problème persiste."

#. js-lingui-id: QWdKwH
msgid "Move"
msgstr "Déplacer"

#. js-lingui-id: QccLbz
msgid "Moderate Candidate"
msgstr "Candidat modéré"

#. js-lingui-id: Qg+NuS
msgid "Your Weekly Submissions"
msgstr "Vos soumissions hebdomadaires"

#. js-lingui-id: QhQvCz
msgid "Require tenants to provide government-issued ID"
msgstr "Exiger que les locataires fournissent un document d'identité émis par le gouvernement"

#. js-lingui-id: QiJB1x
msgid "Additional documents needed"
msgstr "Documents supplémentaires nécessaires"

#. js-lingui-id: QjNzf3
msgid "Admin User"
msgstr "Utilisateur administrateur"

#. js-lingui-id: QkFkwk
msgid "Unit #{alias}"
msgstr "Unité #{alias}"

#. js-lingui-id: QlxNyT
msgid "Verify credit history"
msgstr "Vérifier l'historique de crédit"

#. js-lingui-id: Qm1NmK
msgid "OR"
msgstr "OÙ"

#. js-lingui-id: QoC/7/
msgid "Quebec court civil and penal records"
msgstr "Dossiers civils et pénaux des tribunaux du Québec"

#. js-lingui-id: QrhaVg
msgid "Units"
msgstr "Unités"

#. js-lingui-id: QuBpLd
msgid "Requirements"
msgstr "Exigences"

#. js-lingui-id: QyNoAF
msgid "Choose a property to begin the application process"
msgstr "Choisissez un bien pour commencer le processus de candidature"

#. js-lingui-id: Qze0/r
msgid "Send verification code"
msgstr "Envoyer le code de vérification"

#. js-lingui-id: R+YFk2
msgid "On Hold"
msgstr "En attente"

#. js-lingui-id: R+w/Va
msgid "Billing"
msgstr "Facturation"

#. js-lingui-id: R0+RqB
msgid "Legal Check"
msgstr "Vérification légale"

#. js-lingui-id: R0R7jA
msgid "Through the tenant's application process, they cover the cost of their credit reports, which are then seamlessly sent to the landlord at no additional charge."
msgstr "Grâce au processus de candidature du locataire, ils couvrent le coût de leurs rapports de crédit, qui sont ensuite envoyés de manière transparente au propriétaire sans aucun supplément."

#. js-lingui-id: R2fPOr
msgid "Enable 'Send to Prospect' for Staff"
msgstr "Activer 'Envoyer au prospect' pour le personnel"

#. js-lingui-id: R2hbQl
msgid "Enforce Social Insurance Number"
msgstr "Appliquer le numéro d'assurance sociale"

#. js-lingui-id: R5NYZD
msgid "Additional Tenants"
msgstr "Co-locataires supplémentaires"

#. js-lingui-id: R5dbc1
msgid "Documentation showing your savings or available funds"
msgstr "Documents montrant vos économies ou fonds disponibles"

#. js-lingui-id: RBaua8
msgid "Example: Please provide the requested documents and meet the specified requirements by the deadline to have your application reconsidered."
msgstr "Exemple : Fournissez les documents demandés et respectez les exigences spécifiées avant la date limite pour que votre candidature soit réexaminée."

#. js-lingui-id: RFy4ce
msgid "Identity Documents Required"
msgstr "Documents d'identité requis"

#. js-lingui-id: RJU7Bf
msgid "checks completed"
msgstr "vérifications effectuées"

#. js-lingui-id: RNQ2Zp
msgid "Enter your annual salary"
msgstr "Entrez votre salaire annuel"

#. js-lingui-id: RNxrCU
msgid "Upload a file"
msgstr "Téléverser un fichier"

#. js-lingui-id: RO7ADZ
msgid "An unexpected error occurred while processing the file"
msgstr "Une erreur inattendue est survenue lors du traitement du fichier"

#. js-lingui-id: ROFS4M
msgid "Credit report and financial history analysis"
msgstr "Analyse du rapport de crédit et de l'historique financier"

#. js-lingui-id: RPpzp7
msgid "Waiting for agent to review"
msgstr "En attente de la révision de l'agent"

#. js-lingui-id: RT4sg3
msgid "Website URL (Slug)"
msgstr "URL du site web (slug)"

#. js-lingui-id: RTXsbw
msgid "Manage submission assignments"
msgstr "Gérer les affectations de soumissions"

#. js-lingui-id: RU/s5b
msgid "Rental Reference"
msgstr "Référence locative"

#. js-lingui-id: RX5Q01
msgid "No favorites selected for this submission"
msgstr "Aucune annonce favorites selectionné pour cette soumission"

#. js-lingui-id: RYPEU6
msgid "Identity proof (optional)"
msgstr "Preuve d'identité (optionnelle)"

#. js-lingui-id: RYrbVH
msgid "Project created"
msgstr "Projet créé"

#. js-lingui-id: RakwsO
msgid "Show only my tasks"
msgstr "Afficher uniquement mes tâches"

#. js-lingui-id: RhQWz/
msgid "Payment details"
msgstr "Détails du paiement"

#. js-lingui-id: RhxPrm
msgid "Enable Listing Website"
msgstr "Activer le site web de listage"

#. js-lingui-id: RiPMje
msgid "Enter organization address"
msgstr "Entrez l'adresse de l'organisation"

#. js-lingui-id: RkpuBJ
msgid "Manage your API key, webhook integration, and access the API documentation"
msgstr "Gérer votre clé API, l'intégration webhook et accéder à la documentation API"

#. js-lingui-id: RmNOHZ
msgid "Your most recent tax return or assessment"
msgstr "Votre dernier relevé de taxe ou évaluation"

#. js-lingui-id: RmiRP/
msgid "Drag and drop images directly into the upload area"
msgstr "Glissez-déposez les images directement dans la zone de téléchargement"

#. js-lingui-id: Ro+iRT
msgid "Partial applications"
msgstr "Demandes partielles"

#. js-lingui-id: RocnF9
msgid "Very Good"
msgstr "Vraiment bon"

#. js-lingui-id: Rrkfcw
msgid "Potential Options to Consider"
msgstr "Options potentielles à considérer"

#. js-lingui-id: Ru/s1Y
msgid "Enter the address of where you lived"
msgstr "Entrez l'adresse de l'endroit où vous avez vécu"

#. js-lingui-id: RvBxbz
msgid "Based on our review of the submitted documentation, your application has been declined. However, the property manager will reconsider your application upon addressing the following requirements:"
msgstr "Sur la base de notre examen des documents soumis, votre candidature a été rejetée. Cependant, le gestionnaire de propriété examinera à nouveau votre candidature après avoir abordé les exigences suivantes :"

#. js-lingui-id: RxzN1M
msgid "Enabled"
msgstr "Activé"

#. js-lingui-id: S+y6fs
msgid "All Buildings"
msgstr "Tous les bâtiments"

#. js-lingui-id: S04xTN
msgid "Form Status"
msgstr "Statut du formulaire"

#. js-lingui-id: S1vyuz
msgid "Error while downloading the file"
msgstr "Erreur lors du téléchargement du fichier"

#. js-lingui-id: S5Hzia
msgid "{tenantName} real estate: Rent this {type} with {bedrooms} bedrooms in {city}"
msgstr "{tenantName} immobilier: Louez ce {type} de {bedrooms} chambres à {city}"

#. js-lingui-id: S86Z1R
msgid "You are not signed in"
msgstr "Vous n'êtes pas connecté"

#. js-lingui-id: S8ugMC
msgid "Print report"
msgstr "Imprimer le rapport"

#. js-lingui-id: S9y7VS
msgid "Enter and save essential details about the current tenant, including contact info and the end date of his lease. Keep accurate records for streamlined reference and easy access."
msgstr "Saisissez et enregistrez les informations essentielles sur le locataire actuel, notamment ses coordonnées et la date de fin de son bail. Conservez des enregistrements précis pour une référence simplifiée et un accès facile."

#. js-lingui-id: SCV/b4
msgid "Credit Score"
msgstr "Score de crédit"

#. js-lingui-id: SQ6963
msgid "Legal & Criminal Records"
msgstr "Dossiers juridiques et criminels"

#. js-lingui-id: SUb8x0
msgid "Total available"
msgstr "Total disponible"

#. js-lingui-id: SVLJab
msgid "Applicant's perimission is required"
msgstr "L'autorisation du demandeur est requise"

#. js-lingui-id: SZw9tS
msgid "View Details"
msgstr "Voir les détails"

#. js-lingui-id: SbcTPi
msgid "Rows per page:"
msgstr "Lignes par page:"

#. js-lingui-id: Sdjhxj
msgid "Rental Agents"
msgstr "Agents de Location"

#. js-lingui-id: SeCtxx
msgid "Allow agent actions"
msgstr "Autoriser les actions des agents"

#. js-lingui-id: SejRZT
msgid "Please provide a recent pay stub (stub dated within the last 30 days), T4A or recent notice of assessment"
msgstr "Veuillez fournir un talon de paie récent (daté des 30 derniers jours), un T4A ou un avis de cotisation récent"

#. js-lingui-id: Sg8Gt/
msgid "Strengthen your combined financial profile"
msgstr "Renforcez votre profil financier combiné"

#. js-lingui-id: SiJSKO
msgid "Good utilization"
msgstr "Bonne utilisation"

#. js-lingui-id: Sje7dc
msgid "Analytics updated"
msgstr "Analyse mise à jour"

#. js-lingui-id: SkqHao
msgid "Requested documents"
msgstr "Documents demandés"

#. js-lingui-id: SkxaWJ
msgid "Current Address"
msgstr "Adresse actuelle"

#. js-lingui-id: SlfejT
msgid "Error"
msgstr "Erreur"

#. js-lingui-id: SmCDLv
msgid "Add Applicant"
msgstr "Ajouter un candidat"

#. js-lingui-id: SovVci
msgid "The tenant will be able to resubmit their application once they meet the conditions you specify below. If they don't meet these conditions by the deadline, their application will be automatically marked as rejected. Make sure to set a reasonable deadline and clear requirements."
msgstr "Le locataire pourra soumettre à nouveau sa candidature une fois qu'il aura rempli les conditions que vous avez spécifiées ci-dessous. Si ceux-ci ne sont pas remplis à la date limite, leur candidature sera automatiquement marquée comme rejetée. Assurez-vous de fixer une date limite raisonnable et des exigences claires."

#. js-lingui-id: SpTJJn
msgid "Electricity"
msgstr "Électricité"

#. js-lingui-id: SrElbc
msgid "Notification sent to the applicant confirming they have been selected as the new tenant"
msgstr "Notification envoyée au demandeur confirmant qu'il a été sélectionné comme nouveau locataire"

#. js-lingui-id: Sxm1lO
msgid "All Statuses"
msgstr "Tous les statuts"

#. js-lingui-id: SxyD6I
msgid "Notification sent to the applicant when their application status changes during the review process"
msgstr "Notification envoyée au demandeur lorsque leur état de candidature change pendant le processus de révision"

#. js-lingui-id: T+3pZF
msgid "Secure and confidential"
msgstr "Sécurisé et confidentiel"

#. js-lingui-id: T8NLTv
msgid "Select the identity documents the tenant needs to provide"
msgstr "Sélectionnez les documents d'identité que le locataire doit fournir"

#. js-lingui-id: TCc8aM
msgid "Please provide proof of identity for your file (ex. Driver's license, Passport)"
msgstr "Veuillez fournir une preuve d'identité pour votre dossier (ex. permis de conduire, passeport)"

#. js-lingui-id: THBZFM
msgid "We Couldn't Find This Page"
msgstr "Nous n'avons pas trouvé cette page"

#. js-lingui-id: TIQeV2
msgid "Update the prices for credit report services"
msgstr "Mettre à jour les prix pour les services de rapports de crédit"

#. js-lingui-id: TJBHlP
msgid "Standard"
msgstr "Standard"

#. js-lingui-id: TKSnHl
msgid "Not currently renting"
msgstr "Actuellement non locataire"

#. js-lingui-id: TMLAx2
msgid "Required"
msgstr "Requis"

#. js-lingui-id: TP41b8
msgid "Select a building"
msgstr "Sélectionnez un bâtiment"

#. js-lingui-id: TPtCIY
msgid "Significant Price Change"
msgstr "Changement de prix significatif"

#. js-lingui-id: TUttPn
msgid "Submission not found"
msgstr "La soumission n'a pas été trouvée"

#. js-lingui-id: TWG4iz
msgid "Financial Requirements Not Met"
msgstr "Exigences financières non remplies"

#. js-lingui-id: TWe481
msgid "Thorough criminal record verification"
msgstr "Vérification approfondie du casier judiciaire"

#. js-lingui-id: TYbPfZ
msgid "{title} Applicant Portal"
msgstr "{title} Portail des candidats"

#. js-lingui-id: TZuCK5
msgid "Allow staff actions"
msgstr "Autoriser les actions du personnel"

#. js-lingui-id: TdW6jm
msgid "Complete your profile"
msgstr "Complétez votre profil"

#. js-lingui-id: TdfEV7
msgid "Archived"
msgstr "Archivé"

#. js-lingui-id: TjCXuD
msgid "Manage Applicants"
msgstr "Gérer les candidats"

#. js-lingui-id: Tk0GD2
msgid "Affordability Analysis"
msgstr "Analyse de l'accessibilité"

#. js-lingui-id: TnAfah
msgid "Pay Stub"
msgstr "Talon de paie"

#. js-lingui-id: ToEuex
msgid "Write a message explaining what additional information you need from the tenant. This message will be sent directly to them."
msgstr "Écrivez un message expliquant ce que vous avez besoin de plus du locataire. Ce message sera envoyé directement à eux."

#. js-lingui-id: TqQi+9
msgid "Enable Banner"
msgstr "Activer la bannière"

#. js-lingui-id: TqaqN9
msgid "Last action on"
msgstr "Dernière action le"

#. js-lingui-id: TuOczd
msgid "Updated Proof of Income"
msgstr "Preuve de revenus mise à jour"

#. js-lingui-id: TvDoCV
msgid "Delivery Progress"
msgstr "Progression de la livraison"

#. js-lingui-id: Tx6jp7
msgid "Property managers typically respond within 24-48 business hours after you submit your complete profile or any requested additional documentation. This timeline may vary depending on the verification process and property manager's schedule."
msgstr "Les gestionnaires immobiliers répondent généralement dans un délai de 24 à 48 heures ouvrables après la soumission de votre profil complet ou de toute documentation supplémentaire demandée. Ce délai peut varier en fonction du processus de vérification et du planning du gestionnaire immobilier."

#. js-lingui-id: Ty+xfU
msgid "Your application requires attention. It may be cancelled or discarded if no response by"
msgstr "Votre candidature nécessite une attention. Elle pourrait être annulée ou abandonnée si aucune réponse dans"

#. js-lingui-id: Tz0i8g
msgid "Settings"
msgstr "Paramètres"

#. js-lingui-id: U/v4Ri
msgid "Enter the address of the property you're interested in applying for."
msgstr "Entrez l'adresse de la propriété à laquelle vous souhaitez postuler."

#. js-lingui-id: U0euB4
msgid "This notification is system enforced and cannot be disabled"
msgstr "Cette notification est systématiquement appliquée et ne peut être désactivée"

#. js-lingui-id: U1gwi9
msgid "You apply alone, or want to start an application to invite your co-tenants"
msgstr "Vous faites une demande seul, ou souhaitez commencer une demande pour inviter vos co-locataires"

#. js-lingui-id: U3pytU
msgid "Admin"
msgstr "Admin"

#. js-lingui-id: U6iChU
msgid "ACTIONS"
msgstr "ACTIONS"

#. js-lingui-id: U7AdEr
msgid "Cannot proceed: One or more requirements are not met. Please update the applicant's profile."
msgstr "Impossible de continuer : une ou plusieurs exigences ne sont pas remplies. Veuillez mettre à jour le profil du candidat."

#. js-lingui-id: U8ebX+
msgid "Landlord approved"
msgstr "Approuvé par le propriétaire"

#. js-lingui-id: UABggz
msgid "Important message"
msgstr "Message important"

#. js-lingui-id: UAZTy6
msgid "We collect only the minimum information necessary to process your rental application effectively. This includes basic personal details, employment information, and rental history required for property managers to make informed decisions."
msgstr "Nous recueillons uniquement les informations minimales nécessaires pour traiter efficacement votre demande de location. Cela inclut des informations personnelles de base, des informations sur l'emploi et l'historique de location requis pour que les gestionnaires immobiliers puissent prendre des décisions éclairées."

#. js-lingui-id: UB12M3
msgid "Current Monthly Rent"
msgstr "Loyer mensuel actuel"

#. js-lingui-id: UEI0uP
msgid "Try a different search"
msgstr "Essayez une recherche différente"

#. js-lingui-id: UHeMni
msgid "We are going to perform background and credit verification of your information"
msgstr "Nous allons effectuer une vérification des antécédents et du crédit de vos informations"

#. js-lingui-id: UItjqv
msgid "% of Income"
msgstr "% du revenu"

#. js-lingui-id: UOx1jT
msgid "Back to"
msgstr "Retour à"

#. js-lingui-id: URmyfc
msgid "Details"
msgstr "Détails"

#. js-lingui-id: USXXjt
msgid "No results for \"{query}\""
msgstr "Aucun résultat pour \"{query}\""

#. js-lingui-id: UXBCwc
msgid "Last Name"
msgstr "Nom de famille"

#. js-lingui-id: UZZhNI
msgid "Application under review"
msgstr "Candidature en cours d'examen"

#. js-lingui-id: UbRKMZ
msgid "Pending"
msgstr "En attente"

#. js-lingui-id: UgSwvS
msgid "Affiliations with flagged organizations detected."
msgstr "Affiliations avec des organisations signalées détectées."

#. js-lingui-id: Uh88It
msgid "Lead created successfully"
msgstr "Prospect créé avec succès"

#. js-lingui-id: UigvAS
msgid "Eversa Analysis Configuration"
msgstr "Configuration de l'analyse Eversa"

#. js-lingui-id: UlrUNT
msgid "Applicants merged"
msgstr "Les candidats on été fusionner"

#. js-lingui-id: UoPq9k
msgid "{type} with {bedrooms} bedrooms for rent by {tenantName}, {address}, {city}"
msgstr "{type} de {bedrooms} chambres à louer par {tenantName}, {address}, {city}"

#. js-lingui-id: Uoc0xs
msgid "Send an invitation email to a new applicant"
msgstr "Envoyer un email d'invitation à un nouveau candidat"

#. js-lingui-id: Ur48dJ
msgid "reg."
msgstr "reg."

#. js-lingui-id: Ur6Oka
msgid "Messages and notifications for this application"
msgstr "Messages et notifications pour cette candidature"

#. js-lingui-id: UrKHn4
msgid "Not Started"
msgstr "Non commencé"

#. js-lingui-id: Uv4dnT
msgid "Street"
msgstr "Rue"

#. js-lingui-id: UvRWAL
msgid "You can update your profile information at any time through your tenant portal. Any changes will be automatically reflected in your active applications."
msgstr "Vous pouvez mettre à jour les informations de votre profil à tout moment via votre portail locataire. Toute modification sera automatiquement reflétée dans vos candidatures actives."

#. js-lingui-id: UwX6bL
msgid "Your application is submitted<0/> and under review 🎉"
msgstr "Votre candidature est soumise<0/> et en examen 🎉"

#. js-lingui-id: V1EGGU
msgid "First name"
msgstr "Prénom"

#. js-lingui-id: V2/kSX
msgid "Unsnooze this application to continue with the process"
msgstr "Réactivez cette candidature pour continuer le processus"

#. js-lingui-id: V2cwns
msgid "Documents from your guarantor including their ID and proof of income"
msgstr "Documents de votre endosseur incluant leur ID et la preuve de leurs revenus"

#. js-lingui-id: V2krU2
msgid "Your account is deactivated. Please contact support."
msgstr "Votre compte est désactivé. Veuillez contacter le support."

#. js-lingui-id: V7H/BS
msgid "Submission has been successfully snoozed until {formatedDate}."
msgstr "Cette candidature a été mise en veille jusqu'à {formatedDate}"

#. js-lingui-id: V8BSAN
msgid "Monthly income"
msgstr "Revenu mensuel"

#. js-lingui-id: VBTGXl
msgid "Unverified"
msgstr "Non vérifié"

#. js-lingui-id: VClcVY
msgid "Income-to-Rent Ratio Requirement"
msgstr "Exigence de ratio Revenu/Loyer"

#. js-lingui-id: VDMShG
msgid "Tenant organization created successfully"
msgstr "Organisation locataire créée avec succès"

#. js-lingui-id: VEu4pO
msgid "Manage your application reports."
msgstr "Gérer vos rapports de candidature."

#. js-lingui-id: VIuZGf
msgid "I'm renting"
msgstr "Je loue"

#. js-lingui-id: VIyEtN
msgid "Add Tenant"
msgstr "Ajouter un locataire"

#. js-lingui-id: VKwYDf
msgid "Type document name and press Enter or comma to add"
msgstr "Entrez le nom du document et appuyez sur Entrée ou sur la virgule pour ajouter"

#. js-lingui-id: VN75fO
msgid "Recent Bank Statements"
msgstr "Relevés bancaires récents"

#. js-lingui-id: VNPi9T
msgid "A letter from your employer confirming your employment and salary"
msgstr "Une lettre de votre employeur confirmant votre emploi et votre salaire"

#. js-lingui-id: VO0PXY
msgid "Delivery Management"
msgstr "Gestion des livraisons"

#. js-lingui-id: VTjnH0
msgid "Date of birth must be a valid date in the past and not more than 120 years ago"
msgstr "La date de naissance doit être une date valide dans le passé et ne doit pas remonter à plus de 120 ans."

#. js-lingui-id: VVMkbs
msgid "Financial Overview"
msgstr "Aperçu financier"

#. js-lingui-id: VWjMYe
msgid "Snooze has been successfully acknowledged"
msgstr "La mise en veille a été reconnue avec succès"

#. js-lingui-id: VYETp/
msgid "Manage your billing settings."
msgstr "Gérer vos paramètres de facturation."

#. js-lingui-id: VZeG/A
msgid "Coming Soon"
msgstr "Bientôt disponible"

#. js-lingui-id: Vc6DYr
msgid "Enter French description"
msgstr "Entrez la description en français"

#. js-lingui-id: VdX6/S
msgid "Send an email to the tenant"
msgstr "Envoyer un email au locataire"

#. js-lingui-id: Vf0mQb
msgid "Oops! The listing you're looking for doesn't exist or has been removed."
msgstr "Oops ! L'annonce que vous cherchez n'existe pas ou a été déplacée."

#. js-lingui-id: VgBF86
msgid "New Arrival"
msgstr "Nouvel arrivant"

#. js-lingui-id: Vi2Pqx
msgid "by"
msgstr "par"

#. js-lingui-id: VlrEvi
msgid "Invalid document type selected"
msgstr "Type de document non valide sélectionné"

#. js-lingui-id: VmIhpU
msgid "You have been redirected to the home page"
msgstr "Vous avez été redirigé vers la page d'accueil"

#. js-lingui-id: VnBgXL
msgid "Enable Submission Assignment"
msgstr "Activer les responsables de soumission"

#. js-lingui-id: VnNZ36
msgid "No Project Available"
msgstr "Aucun projet disponible"

#. js-lingui-id: VoT8jh
msgid "All Submissions"
msgstr "Toutes les candidatures"

#. js-lingui-id: VouIXn
msgid "Error loading report!"
msgstr "Erreur lors du chargement du rapport !"

#. js-lingui-id: VpG3jB
msgid "Add lead to unit"
msgstr "Ajouter un prospect à l'unité"

#. js-lingui-id: VqFXBQ
msgid "Message from {messageSender}:"
msgstr "Message de {messageSender}:"

#. js-lingui-id: VuaarY
msgid "Please provide an explanation for other reason"
msgstr "Veuillez fournir une explication pour toute autre raison"

#. js-lingui-id: W+RP4q
msgid "Delete Applicant"
msgstr "Supprimer le candidat"

#. js-lingui-id: W0BuNH
msgid "Unverified AI Salary"
msgstr "Salaire IA non vérifié"

#. js-lingui-id: W2mcaN
msgid "You are currently signed in with a staff account. You cannot apply on a listing."
msgstr "Vous êtes actuellement connecté avec un compte administrateur. Vous ne pouvez pas appliquer sur une annonce."

#. js-lingui-id: W37bxI
msgid "Enter English description"
msgstr "Entrez la description en anglais"

#. js-lingui-id: W9KP0X
msgid "Credit History"
msgstr "Historique de crédit"

#. js-lingui-id: WDcQq9
msgid "Unlisted"
msgstr "Non répertorié"

#. js-lingui-id: WE2GMj
msgid " more than the previous unit."
msgstr " de plus que l'unité précédente."

#. js-lingui-id: WFIGh+
msgid "Uploaded Documents:"
msgstr "Documents téléversés:"

#. js-lingui-id: WFf2ZQ
msgid "Manage units in this building"
msgstr "Gérer les unités dans ce bâtiment"

#. js-lingui-id: WG8MI5
msgid "Clear your browser cache and refresh the page"
msgstr "Nettoyez le cache de votre navigateur et rafraîchissez la page"

#. js-lingui-id: WGkFsd
msgid "Online application"
msgstr "Application en ligne"

#. js-lingui-id: WJ5s0G
msgid "Submission Status Update"
msgstr "Mise à jour de l'état de la soumission"

#. js-lingui-id: WNai8g
msgid "Your configured minimum ratio (Income to Rent)"
msgstr "Votre ratio minimum configuré (Revenu/Loyer)"

#. js-lingui-id: WNrbGX
msgid "This account is not authorized to sign in to this application. Please contact support."
msgstr "Ce compte n'est pas autorisé à se connecter à cette application. Veuillez contacter le support."

#. js-lingui-id: WS0xSN
msgid "Quebec residential properties"
msgstr "Propriétés résidentielles du Québec"

#. js-lingui-id: WZ8g4+
msgid "Animals allowed in the unit"
msgstr "Animaux acceptés dans l'unité"

#. js-lingui-id: WZubgm
msgid "Payment Setup Required"
msgstr "Configuration du paiement requise"

#. js-lingui-id: WbTDwg
msgid "In Progress"
msgstr "En cours"

#. js-lingui-id: Weq9zb
msgid "General"
msgstr "Général"

#. js-lingui-id: WndzGF
msgid "Ask your administrator to configure payment"
msgstr "Contactez votre administrateur pour configurer"

#. js-lingui-id: Wsk5pi
msgid "Project Settings"
msgstr "Paramètres du projet"

#. js-lingui-id: WuOFQd
msgid "Completed on {financeDate}"
msgstr "Complété le {financeDate}"

#. js-lingui-id: WwJwIo
msgid "{tenantName} real estate: Spacious {type} with {bedrooms} bedrooms for rent in {city}"
msgstr "{tenantName} immobilier: {type} spacieux de {bedrooms} chambres à louer à {city}"

#. js-lingui-id: WwP87g
msgid "Apply once, valid for 60 days"
msgstr "Appliquer une fois, valide pour 60 jours"

#. js-lingui-id: WxfcfZ
msgid "It's empty"
msgstr "C'est vide"

#. js-lingui-id: X/VKtM
msgid "Delivery Management View Options"
msgstr "Options de vue de gestion des livraisons"

#. js-lingui-id: X0QTsk
msgid "Qualification Analysis"
msgstr "Analyse de qualification"

#. js-lingui-id: X0m5kl
msgid "Salary Breakdown"
msgstr "Détail du salaire"

#. js-lingui-id: X5c31T
msgid "Applicant's permission"
msgstr "Autorisation du demandeur"

#. js-lingui-id: X8ASN1
msgid "Waiting for agent to approve"
msgstr "En attente de l'approbation par l'agent"

#. js-lingui-id: X8RtOS
msgid "Delivery Agent Details"
msgstr "Détails de l'agent de livraison"

#. js-lingui-id: X9d0q3
msgid "Confirm Rejection"
msgstr "Confirmer le rejet"

#. js-lingui-id: X9kySA
msgid "Favorites"
msgstr "Favoris"

#. js-lingui-id: XAH5zB
msgid "Enter French title"
msgstr "Entrez le titre en français"

#. js-lingui-id: XGmlvq
msgid "Team Member Roles"
msgstr "Rôles des membres de l'équipe"

#. js-lingui-id: XILg0L
msgid "Invalid email address"
msgstr "Adresse courriel invalide"

#. js-lingui-id: XJrFpX
msgid "Proof of income (optional)"
msgstr "Preuve de revenus (optionnelle)"

#. js-lingui-id: XLHm9h
msgid "Require tenants to upload proof of income documents"
msgstr "Exiger que les locataires fournissent des documents de preuve de revenus"

#. js-lingui-id: XMRrWw
msgid "Verification Status"
msgstr "Statut de vérification"

#. js-lingui-id: XOIEih
msgid "Eversa Market Intelligence"
msgstr "Eversa intelligence du marché"

#. js-lingui-id: XOPBvW
msgid "Confirmation that an application has been successfully received in the system"
msgstr "Confirmation que l'application a été reçue avec succès dans le système"

#. js-lingui-id: XPPeYX
msgid "Credit Limit"
msgstr "Limite de crédit"

#. js-lingui-id: XQqH0U
msgid "Add additional information for the visit agent. (e.g: current tenant details, possible unit# to visit etc...)"
msgstr "Ajouter des informations supplémentaires pour l'agent de visite. (ex: détails sur l'occupant actuel, unité éventuelle à visiter, etc.)"

#. js-lingui-id: XRWzs3
msgid "Configure the features of your website. These features can be enabled or disabled."
msgstr "Configurer les fonctionnalités de votre site web. Ces fonctionnalités peuvent être activées ou désactivées."

#. js-lingui-id: XU9aUK
msgid "Acceptance"
msgstr "Acceptation"

#. js-lingui-id: XUOsJo
msgid "Upload Documents"
msgstr "Télécharger des documents"

#. js-lingui-id: XVSust
msgid "Missed Payment"
msgstr "Paiement manqué"

#. js-lingui-id: XXFT/4
msgid "I am a new arrival to Canada (immigrant, international student, or temporary worker)"
msgstr "Je suis un nouvel arrivant au Canada (immigrant, étudiant international, ou travailleur temporaire)"

#. js-lingui-id: XZDoO8
msgid "Enter Tenant Details"
msgstr "Saisissez les informations du locataire"

#. js-lingui-id: XachSV
msgid "Action Required: Review your Application"
msgstr "Action requise : Examiner votre candidature"

#. js-lingui-id: XdO6hR
msgid "Completed on"
msgstr "Terminé le"

#. js-lingui-id: XibS9K
msgid "Team Members"
msgstr "Membres de l'équipe"

#. js-lingui-id: Xl3sIK
msgid "Vulnerable sector check"
msgstr "Vérification du secteur vulnérable"

#. js-lingui-id: XnEQ12
msgid "Failed to upload csv file"
msgstr "Échec du téléchargement du fichier CSV"

#. js-lingui-id: XnT0vs
msgid "Large Unit Change Trigger"
msgstr "Déclencheur de changement d'unité important"

#. js-lingui-id: XqxJmS
msgid "Is the prepaid rent required?"
msgstr "Le prépaiement du loyer est-il requis?"

#. js-lingui-id: Xz3NE3
msgid "Units/Buildings"
msgstr "Unités/Bâtiments"

#. js-lingui-id: Y/fDke
msgid "Other (Non-Legal Reason)"
msgstr "Autre (Raison non légale)"

#. js-lingui-id: Y72kOS
msgid "Right to Access and Correction:"
msgstr "Droit d'accès et de correction:"

#. js-lingui-id: Y7WHtv
msgid "Enter Facebook URL"
msgstr "Entrez l'URL de Facebook"

#. js-lingui-id: Y9TPjC
msgid "{city} rental: {type} with {bedrooms} bedrooms for rent, {tenantName} real estate"
msgstr "Location à {city}: {type} de {bedrooms} chambres à louer, {tenantName} immobilier"

#. js-lingui-id: YBGFCn
msgid "When a submission is unsnoozed by the tenant completing the required action, it will move to the selected step. If no step is selected, the submission will keep its current step."
msgstr "Lorsqu'une soumission est réactivée par le locataire après avoir effectué l'action requise, elle passera à l'étape sélectionnée. Si aucune étape n'est sélectionnée, la soumission conservera son étape actuelle."

#. js-lingui-id: YBzMIm
msgid "Annually:"
msgstr "Par année:"

#. js-lingui-id: YCmxKV
msgid "No Credit Score"
msgstr "Pas de score de crédit"

#. js-lingui-id: YJns+p
msgid "Application on Hold"
msgstr "Candidature en attente"

#. js-lingui-id: YMfmlH
msgid "This salary seems unusually high. Please verify the amount."
msgstr "Ce salaire semble élevé. Veuillez vérifier le montant."

#. js-lingui-id: YPjyXG
msgid "Please select at least one applicant"
msgstr "Veuillez sélectionner au moins un candidat"

#. js-lingui-id: YSwcF6
msgid "This application has been put on hold until <0>{formatedDate}</0> while we wait for additional information from the applicant."
msgstr "Cette candidature a été mise en veille jusqu'au <0>{formatedDate}</0> pendant que nous attendons des informations supplémentaires du locataire."

#. js-lingui-id: YT6bro
msgid "You've successfully removed the assignee from this submission"
msgstr "Vous avez retiré avec succès le responsable de cette soumission"

#. js-lingui-id: YTCz3Y
msgid "Requirements Checklist"
msgstr "Liste des exigences"

#. js-lingui-id: YUltpZ
msgid "Upload a CSV file containing unit data. The file should contain columns for unit number, floor, and any other relevant data."
msgstr "Téléverser un fichier CSV contenant les données de l'unité. Le fichier doit contenir des colonnes pour le numéro de l'unité, l'étage et toute autre donnée pertinente."

#. js-lingui-id: YY+s6C
msgid "This category is empty for now."
msgstr "Cette catégorie est vide pour l'instant."

#. js-lingui-id: YZCpAB
msgid "Delete Promotion"
msgstr "Supprimer la Promotion"

#. js-lingui-id: YaEBJt
msgid "This account has been written off"
msgstr "Ce compte a été radié"

#. js-lingui-id: YahcST
msgid "Incomplete Application"
msgstr "Candidature incomplète"

#. js-lingui-id: YirHq7
msgid "Feedback"
msgstr "Commentaires"

#. js-lingui-id: YjKETn
msgid "{tenantTitle} | {street}, {city}"
msgstr "{tenantTitle} | {street}, {city}"

#. js-lingui-id: YkbyP9
msgid "Financial stability assessment"
msgstr "Évaluation de la stabilité financière"

#. js-lingui-id: Yo/CwQ
msgid "Unit updated successfully"
msgstr "Unité mise à jour avec succès"

#. js-lingui-id: YpGzmW
msgid "Your application<0/> has been rejected"
msgstr "Votre candidature<0/> a été rejetée"

#. js-lingui-id: YudRP7
msgid "You are editing the application. Do not exit until the process is completed."
msgstr "Vous modifiez la demande. Ne quittez pas avant que le processus ne soit terminé."

#. js-lingui-id: YvAmot
msgid "Included Analysis"
msgstr "Analyse incluse"

#. js-lingui-id: YzSJxy
msgid "{value, plural, one {bathroom} two {bathrooms} other {bathrooms}}"
msgstr "{value, plural, one {salle de bain} two {salles de bain} other {salles de bain}}"

#. js-lingui-id: YzZwmB
msgid "How many animals are allowed?"
msgstr "Combien d'animaux sont autorisés?"

#. js-lingui-id: Z1tR1p
msgid "Banner Text English"
msgstr "Texte de la bannière en anglais"

#. js-lingui-id: Z3FXyt
msgid "Loading..."
msgstr "Chargement..."

#. js-lingui-id: Z59X0b
msgid "I don't have a landlord reference"
msgstr "Je n'ai pas de référence de propriétaire"

#. js-lingui-id: Z6PbaC
msgid "We are currently waiting on your co-applicant to complete their application"
msgstr "Nous attendons actuellement que votre co-demandeur complète sa candidature."

#. js-lingui-id: ZCW63d
msgid "Upload a featured image for your project that will be displayed on listing pages"
msgstr "Téléchargez une image en vedette pour votre projet qui sera affichée sur les pages d'annonces"

#. js-lingui-id: ZCXgK6
msgid "Bike Score®"
msgstr "Score de vélo"

#. js-lingui-id: ZDdb1D
msgid "Select agent"
msgstr "Sélectionner un agent"

#. js-lingui-id: ZFLX50
msgid "Update building information"
msgstr "Mettre à jour les informations du bâtiment"

#. js-lingui-id: ZJJrSW
msgid "Landlord Review"
msgstr "Examen par le propriétaire"

#. js-lingui-id: ZJRzFw
msgid "Upload a featured image for this building that will be displayed on listing pages"
msgstr "Téléchargez une image en vedette pour ce bâtiment qui sera affichée sur les pages d'annonces"

#. js-lingui-id: ZNR48C
msgid "Debt-to-income ratio calculation"
msgstr "Calcul du ratio dette/revenu"

#. js-lingui-id: ZNbr0u
msgid "I acknowledge and agree that any fees paid to <0>Eversa</0> are non-refundable and will be used to process and analyze my profile. The property manager will refund the application fee if your application is selected."
msgstr "Je reconnais et accepte que tous les frais payés à <0>Eversa</0> ne sont pas remboursables et seront utilisés pour traiter et analyser mon profil. Le gestionnaire immobilier remboursera les frais de dossier si votre candidature est sélectionnée."

#. js-lingui-id: ZPs6Fh
msgid "Good standing"
msgstr "Bonne réputation"

#. js-lingui-id: ZSDQwQ
msgid "Language:"
msgstr "Langue:"

#. js-lingui-id: ZU3JQG
msgid "Submitted"
msgstr "Soumis"

#. js-lingui-id: ZW5uL6
msgid "Total Credit Checks"
msgstr "Total des vérifications de crédit"

#. js-lingui-id: ZWSiK2
msgid "Hold to Merge"
msgstr "Maintenir pour fusionner"

#. js-lingui-id: ZYkdBw
msgid "Unit# (Optional)"
msgstr "Unité# (Facultatif)"

#. js-lingui-id: ZYrTdn
msgid "Search leads"
msgstr "Rechercher des prospects"

#. js-lingui-id: ZZHjJR
msgid "Oups, this listing is no longer available."
msgstr "Oups, cette annonce n'est plus disponible."

#. js-lingui-id: Za5k8Z
msgid "No updates yet"
msgstr "Aucune mise à jour pour le moment"

#. js-lingui-id: ZchOpj
msgid "Homeowner"
msgstr "Propriétaire"

#. js-lingui-id: Zl/iSo
msgid "Financial Documents Required"
msgstr "Documents financiers requis"

#. js-lingui-id: ZlwDi6
msgid "Analytics"
msgstr "Analytique"

#. js-lingui-id: ZoOIuR
msgid "Rental history analysis"
msgstr "Analyse de l'historique locatif"

#. js-lingui-id: Zork3f
msgid "Driver's License"
msgstr "Permis de conduire"

#. js-lingui-id: ZpSbWv
msgid "Agent Dashboard"
msgstr "Tableau de bord des agents"

#. js-lingui-id: Zr0egD
msgid "Send a credit check request to an applicant by email, once they have completed the application you will be notified."
msgstr "Envoyez une demande de vérification de crédit à un candidat par e-mail, une fois qu'il a terminé la candidature, vous serez notifié."

#. js-lingui-id: ZrFiVl
msgid "Type or choose an assignee"
msgstr "Tapez ou choisissez un responsable"

#. js-lingui-id: ZrsGjm
msgid "Inventory"
msgstr "Inventaire"

#. js-lingui-id: ZsZeV2
msgid "Email is required"
msgstr "L'email est requis"

#. js-lingui-id: ZudkOx
msgid "Control your rental application form"
msgstr "Contrôler le formulaire de candidature locative"

#. js-lingui-id: Zw2dYJ
msgid "No leads available"
msgstr "Aucun prospect disponible"

#. js-lingui-id: a/jCru
msgid "{daysSinceUpdated} days ago"
msgstr "Il ya {daysSinceUpdated} jours"

#. js-lingui-id: a3EgZz
msgid "Payment History"
msgstr "Historique de paiement"

#. js-lingui-id: a3pVqb
msgid "Frequently asked questions"
msgstr "Questions fréquemment posées"

#. js-lingui-id: a4ma1L
msgid "Units in Project"
msgstr "Unités dans le projet"

#. js-lingui-id: a4ruqo
msgid "Unsnooze"
msgstr "Réactiver"

#. js-lingui-id: a5+3cU
msgid "Verify the file is valid and try again. Or contact support if the issue persists."
msgstr "Vérifiez que le fichier est valide et réessayez. Ou contactez le support si le problème persiste."

#. js-lingui-id: a5JPSe
msgid "Living with parents"
msgstr "Vivre avec les parents"

#. js-lingui-id: a7u1N9
msgid "Price"
msgstr "Prix"

#. js-lingui-id: a91YWO
msgid "A fee of ${formattedPrice} will have to be paid to complete your housing request"
msgstr "Des frais de ${formattedPrice} devront être payés pour compléter votre demande de logement"

#. js-lingui-id: a9eYBr
msgid "Manage your API key"
msgstr "Gérez votre clé API"

#. js-lingui-id: aAIQg2
msgid "Appearance"
msgstr "Apparence"

#. js-lingui-id: aCl9zQ
msgid "Add project"
msgstr "Ajouter un projet"

#. js-lingui-id: aDPoVW
msgid "This submission is on hold"
msgstr "Cette candidature est en veille"

#. js-lingui-id: aG5d+K
msgid "Leads Stats"
msgstr "Statistiques des prospects"

#. js-lingui-id: aI4dXu
msgid "Continue your home search journey"
msgstr "Continuez votre recherche de logement"

#. js-lingui-id: aIXsmO
msgid "Has the tenant accepted the visit on this listing"
msgstr "Le locataire a accepté la visite sur cette annonce"

#. js-lingui-id: aIy42X
msgid "Cancel Delivery"
msgstr "Annuler la livraison"

#. js-lingui-id: aJ4pMe
msgid "FAQs"
msgstr "FAQs"

#. js-lingui-id: aJwGh/
msgid "For accurate affordability analysis, we require monthly income of at least $1,000 and monthly rent of at least $100. Please update the information to see the complete affordability assessment."
msgstr "Pour une analyse d'accessibilité précise, nous avons besoin d'un revenu mensuel d'au moins $1,000 et d'un loyer mensuel d'au moins $100. Veuillez mettre à jour les informations pour voir l'analyse d'accessibilité complète."

#. js-lingui-id: aK1ReW
msgid "Income Verification"
msgstr "Vérification des revenus"

#. js-lingui-id: aOIfD3
msgid "Monthly:"
msgstr "Par mois:"

#. js-lingui-id: aOS+ix
msgid "Upload Additional Documents"
msgstr "Téléverser des documents supplémentaires"

#. js-lingui-id: aP4Av2
msgid "Generated on"
msgstr "Généré le"

#. js-lingui-id: aQST8Z
msgid "Financial"
msgstr "Finances"

#. js-lingui-id: aQk4Lr
msgid "The tenant has not paid the deposit and the financial information has not been verified."
msgstr "Le locataire n'a pas payé la caution et les informations financières n'ont pas été vérifiées."

#. js-lingui-id: aSwfbR
msgid "Unit"
msgstr "Unité"

#. js-lingui-id: aTe3TO
msgid "The electricity bill ownership has been transferred to the tenant."
msgstr "La propriété de la facture d'électricité a été transférée au locataire."

#. js-lingui-id: aTr/DF
msgid "Select how you'd like to proceed with the application"
msgstr "Sélectionnez la procédure de candidature"

#. js-lingui-id: aVTekH
msgid "Clear assignee"
msgstr "Retirer le responsable"

#. js-lingui-id: aVlWNp
msgid "The tenant has received the rules and regulations and has agreed to them."
msgstr "Le locataire a reçu les règlements et les a accepté."

#. js-lingui-id: aWgRnQ
msgid "Manage your submission assignement and statuses"
msgstr "Gérer votre affectation et le statut de la soumission"

#. js-lingui-id: aZufkv
msgid "Credit Check Not Run"
msgstr "Vérification de crédit non exécutée"

#. js-lingui-id: agPptk
msgid "Medium"
msgstr "Moyen"

#. js-lingui-id: ajC7hw
msgid "Credit report has not been run yet"
msgstr "Le rapport de crédit n'a pas encore été effectué"

#. js-lingui-id: an5hVd
msgid "Images"
msgstr "Images"

#. js-lingui-id: anPGKK
msgid "Invite new members by email address"
msgstr "Inviter de nouveaux membres par adresse e-mail"

#. js-lingui-id: arlFOI
msgid "Why are you rejecting this application?"
msgstr "Pourquoi voulez-vous rejeter cette candidature ?"

#. js-lingui-id: asK/EM
msgid "Reference check price must be greater than or equal to 0"
msgstr "Le prix de la vérification de référence doit être supérieur ou égal à 0"

#. js-lingui-id: auDIrX
msgid "{diffDays}d remaining"
msgstr "{diffDays}j restants"

#. js-lingui-id: b3Ch0G
msgid "Reference ID"
msgstr "ID de référence"

#. js-lingui-id: b3FA4T
msgid "Where was the property you rented?"
msgstr "Où se trouvait la propriété que vous avez louée ?"

#. js-lingui-id: b4zIfV
msgid "Listing Not Found"
msgstr "Annonce non trouvée"

#. js-lingui-id: b5d759
msgid "identity"
msgstr "identité"

#. js-lingui-id: b5zVyG
msgid "The tenant has not provided proof of insurance."
msgstr "Le locataire n'a pas fourni de justificatif d'assurance."

#. js-lingui-id: b6V5pg
msgid "Your delivery calendar is empty for this week."
msgstr "Votre calendrier de livraison est vide pour cette semaine."

#. js-lingui-id: b9Us19
msgid "A delivery agent has been assigned to this delivery."
msgstr "Un agent de livraison a été affecté à cette livraison."

#. js-lingui-id: bBPc2Z
msgid "Go to My Website"
msgstr "C'est parti !"

#. js-lingui-id: bBhxEK
msgid "This user has provided consent for credit bureau checks and has signed the application."
msgstr "Cet utilisateur a fourni son consentement pour les vérifications de bureau de crédit et a signé l'application."

#. js-lingui-id: bD8I7O
msgid "Complete"
msgstr "Complété"

#. js-lingui-id: bEYd5k
msgid "Application Status"
msgstr "Statut de la candidature"

#. js-lingui-id: bGJMLQ
msgid "Required Documents"
msgstr "Documents requis"

#. js-lingui-id: bHJ//P
msgid "Failed to create project"
msgstr "Impossible de créer le projet"

#. js-lingui-id: bJZm1W
msgid "Applicants"
msgstr "Candidats"

#. js-lingui-id: bMPz54
msgid "Credit Score:"
msgstr "Score de crédit:"

#. js-lingui-id: bQ9w8f
msgid "Payment not received"
msgstr "Paiement non reçus"

#. js-lingui-id: bScRyj
msgid "Repossession"
msgstr "Repossession"

#. js-lingui-id: bUCGL6
msgid "Pre-Check Verification"
msgstr "Vérification préalable"

#. js-lingui-id: bUdTU6
msgid "The first image you upload will be used as the featured image for this building on the listing page and in search results."
msgstr "La première image que vous téléchargez sera utilisée comme image en vedette pour ce bâtiment sur la page d'annonce et dans les résultats de recherche."

#. js-lingui-id: bXJllT
msgid "Application Code"
msgstr "Code d'application"

#. js-lingui-id: bb1jb1
msgid "Select consents that are required for this unit"
msgstr "Sélectionnez les consentements requis pour cette unité"

#. js-lingui-id: bb1u4g
msgid "Revolving"
msgstr "Crédit renouvelable"

#. js-lingui-id: bbWfDN
msgid "Base:"
msgstr "Base:"

#. js-lingui-id: bc/cKi
msgid "Tenants"
msgstr "Locataires"

#. js-lingui-id: be6D0D
msgid "Submission"
msgstr "Soumission"

#. js-lingui-id: bfAdf+
msgid "Income Information"
msgstr "Informations sur les revenus"

#. js-lingui-id: bfIwN6
msgid "Company address"
msgstr "Addresse de l'entreprise"

#. js-lingui-id: bgDPLn
msgid "Family-oriented properties"
msgstr "Propriétés orientées familles"

#. js-lingui-id: bj5PN1
msgid "Other Documents"
msgstr "Autres documents"

#. js-lingui-id: bkxnxA
msgid "Landlord"
msgstr "Propriétaire"

#. js-lingui-id: bokdBj
msgid "Candidate meets most criteria but requires manual review of debt ratio"
msgstr "Le candidat répond à la plupart des critères mais nécessite un examen manuel du ratio d'endettement"

#. js-lingui-id: bpK9mh
msgid "Confirm and Continue"
msgstr "Confirmer et continuer"

#. js-lingui-id: brh7GE
msgid "Listing website updated"
msgstr "Site web d'annonce mis à jour"

#. js-lingui-id: bw4L+q
msgid "Rental History"
msgstr "Historique de location"

#. js-lingui-id: c0Jlur
msgid "Other financial institutions and credit providers"
msgstr "Autres institutions financières et fournisseurs de crédit"

#. js-lingui-id: c4RuNX
msgid "Change address"
msgstr "Changer l'adresse"

#. js-lingui-id: c4SUwh
msgid "Waiting for tenant to schedule visit"
msgstr "En attente du locataire pour planifier une visite"

#. js-lingui-id: c4TT53
msgid "Proof of Income"
msgstr "Preuve de revenus"

#. js-lingui-id: c56Ta0
msgid "Make sure you have all necessary documents ready for the next step."
msgstr "Assurez-vous d'avoir tous les documents nécessaires prêts pour la prochaine étape."

#. js-lingui-id: c5LWDG
msgid "Your application has been received"
msgstr "Votre candidature a été reçue"

#. js-lingui-id: c63Cj8
msgid "Archive listing"
msgstr "Archiver l'annonce"

#. js-lingui-id: c6Fkhw
msgid "Current rent must be greater than 0"
msgstr "Le loyer mensuel actuel doit être supérieur à 0"

#. js-lingui-id: c6k4x1
msgid "We couldn't calculate a valid debt-to-income ratio for this applicant. This may be due to missing financial information or inconsistencies in the reported data."
msgstr "Nous n'avons pas pu calculer un ratio dette/revenu valide pour ce candidat. Cela peut être dû à des informations financières manquantes ou des incohérences dans les données rapportées."

#. js-lingui-id: c7mXbX
msgid "{tenantName}: {type} with {bedrooms} bedrooms for rent, {address}, {city}"
msgstr "{tenantName}: {type} {bedrooms} chambres à louer, {address}, {city}"

#. js-lingui-id: c9JTLS
msgid "T4A or Notice of Assessment"
msgstr "T4A ou Avis de cotisation"

#. js-lingui-id: cD5cmv
msgid "Financial strain likely (40-50% of available income)"
msgstr "Strain financier probable (40-50% du revenu disponible)"

#. js-lingui-id: cFdvuz
msgid "Leave a note on this submission (optional)"
msgstr "Laissez une note sur cette soumission (optionnel)"

#. js-lingui-id: cIGApK
msgid "Help & Feedback"
msgstr "Aide & Feedback"

#. js-lingui-id: cJjlGa
msgid "Not processed by Eversa"
msgstr "Non traité par Eversa"

#. js-lingui-id: cJyysm
msgid "Please select one of the standard legal grounds for declining this rental application. This helps ensure fair and transparent decision-making."
msgstr "Veuillez sélectionner une des raisons légales standard pour rejeter cette candidature. Cela garantit un traitement équitable et transparent."

#. js-lingui-id: cMDleX
msgid "For technical issues, contact Eversa Support at <0>support@eversa.app</0> or start a live chat below."
msgstr "Pour les problèmes techniques, contactez Eversa Support à <0>support@eversa.app</0> ou commencez un chat en direct ci-dessous."

#. js-lingui-id: cMocp9
msgid "This applicant has been removed from the application"
msgstr "Ce candidat a été retiré de la candidature"

#. js-lingui-id: cOJb0s
msgid "No Inquiries Found"
msgstr "Aucune demande trouvée"

#. js-lingui-id: cQoFif
msgid "Call us"
msgstr "Contactez-nous"

#. js-lingui-id: cQzdcM
msgid "Min Prices"
msgstr "Prix min"

#. js-lingui-id: cSev+j
msgid "Filters"
msgstr "Filtres"

#. js-lingui-id: cVOset
msgid "Financial Check Not Run"
msgstr "Vérification financière non exécutée"

#. js-lingui-id: cVPmuB
msgid "I do not want to share my Social Insurance Number"
msgstr "Je ne souhaite pas partager mon numéro d'assurance sociale"

#. js-lingui-id: cVyQR/
msgid "Luxury rentals"
msgstr "Locations de luxe"

#. js-lingui-id: cWTgy7
msgid "Enter project name"
msgstr "Entrez le nom du projet"

#. js-lingui-id: cYyKAC
msgid "Merge Applicants"
msgstr "Fusionner les candidats"

#. js-lingui-id: ce4osx
msgid "Payment history analysis"
msgstr "Analyse de l'historique des paiements"

#. js-lingui-id: cgONby
msgid "The landlord will receive a comprehensive <0>Eversa™ Report</0> to evaluate your application and accessibility requirements."
msgstr "Le propriétaire recevra un <0>rapport Eversa™</0> complet pour évaluer votre candidature et ses exigences d'accessibilité."

#. js-lingui-id: ch5ovu
msgid "Building has been archived."
msgstr "Le bâtiment a été archivé."

#. js-lingui-id: cj1/wV
msgid "Step"
msgstr "Étape"

#. js-lingui-id: cklVjM
msgid "Timeline"
msgstr "Chronologie"

#. js-lingui-id: cnGeoo
msgid "Delete"
msgstr "Supprimer"

#. js-lingui-id: cnbbjE
msgid "Add additional applicants"
msgstr "Ajouter des co-demandeurs"

#. js-lingui-id: cqbM5J
msgid "This feature is currently under development."
msgstr "Cette fonctionnalité est actuellement en développement."

#. js-lingui-id: cukKHK
msgid "The background check information for this applicant is currently unavailable."
msgstr "Les informations de vérification des antécédents de ce candidat ne sont actuellement pas disponibles."

#. js-lingui-id: d/UNFS
msgid "Unit created successfully"
msgstr "Unité créée avec succès"

#. js-lingui-id: d8Y9sW
msgid "Debt-to-Income Ratio"
msgstr "Ratio dette/revenu"

#. js-lingui-id: dEJ3xG
msgid "Please tell us about your current living situation"
msgstr "Veuillez nous informer sur votre situation actuelle"

#. js-lingui-id: dEgA5A
msgid "Cancel"
msgstr "Annuler"

#. js-lingui-id: dEzB1X
msgid "I understand the risk"
msgstr "Je comprends le risque"

#. js-lingui-id: dJW40d
msgid "Postal Code"
msgstr "Code Postal"

#. js-lingui-id: dKXIKM
msgid "Top Buildings by Amount"
msgstr "Bâtiments les plus chers"

#. js-lingui-id: dN7i8v
msgid "STATUS"
msgstr "STATUT"

#. js-lingui-id: dRVq80
msgid "Show all listings with submissions"
msgstr "Affiché les annonces avec une soumission"

#. js-lingui-id: dVTBTD
msgid "Hourly Rate:"
msgstr "Taux horaire:"

#. js-lingui-id: dXoieq
msgid "Summary"
msgstr "Résumé"

#. js-lingui-id: dZmVpz
msgid "Credit Score Scale"
msgstr "Échelle de notation de crédit"

#. js-lingui-id: dZxSSS
msgid "Trusted Individual"
msgstr "Personne de confiance"

#. js-lingui-id: da4KrH
msgid "Deliveries"
msgstr "Livraisons"

#. js-lingui-id: db9vEi
msgid "View all units"
msgstr "Afficher toutes les unités"

#. js-lingui-id: dblERr
msgid "Understood"
msgstr "Compris"

#. js-lingui-id: dfN8rY
msgid "Self-Employment Documentation"
msgstr "Documents de travail indépendant"

#. js-lingui-id: dg3VpM
msgid "Workplace"
msgstr "Lieu de travail"

#. js-lingui-id: dm2vYF
msgid "Not specified"
msgstr "Non spécifié"

#. js-lingui-id: dtOoGl
msgid "Manager"
msgstr "Gestionnaire"

#. js-lingui-id: dtu2LP
msgid "This submission has not been updated in over 3 days"
msgstr "Cette soumission n'a pas été mise à jour depuis plus de 3 jours"

#. js-lingui-id: dvYuhh
msgid "Moderate"
msgstr "Modéré"

#. js-lingui-id: dwVQaS
msgid "Remove service estimates section from generated reports."
msgstr "Supprimer la section des estimations de service des rapports générés."

#. js-lingui-id: e/cvV1
msgid "Verifying..."
msgstr "Vérification..."

#. js-lingui-id: e0NrBM
msgid "Project"
msgstr "Projet"

#. js-lingui-id: e551h5
msgid "View Current Tenant Information"
msgstr "Voir les informations du locataire actuel"

#. js-lingui-id: e5P3SW
msgid "Rent Only: "
msgstr "Loyer uniquement: "

#. js-lingui-id: e7PviE
msgid "within"
msgstr "dans"

#. js-lingui-id: e8gUzr
msgid "Is there a cost associated with using Eversa?"
msgstr "Y a-t-il un coût associé à l'utilisation d'Eversa?"

#. js-lingui-id: eC1gV9
msgid "Invalid file type"
msgstr "Type de fichier invalide"

#. js-lingui-id: eFeJ86
msgid "Endorser"
msgstr "Endosseur"

#. js-lingui-id: eJ3lf1
msgid "Previous Tenant"
msgstr "Locataire précédent"

#. js-lingui-id: eKLncL
msgid "Reference Check"
msgstr "Vérification de référence"

#. js-lingui-id: eMvjNv
msgid "Identity verified"
msgstr "Identité vérifiée"

#. js-lingui-id: ePAbSx
msgid "{names}'s submission"
msgstr "Soumission de {names}"

#. js-lingui-id: ePK91l
msgid "Edit"
msgstr "Modifier"

#. js-lingui-id: ePYQjq
msgid "Identity"
msgstr "Identité"

#. js-lingui-id: eTFgny
msgid "Keep the current step"
msgstr "Garder l'étape actuelle"

#. js-lingui-id: eTTrWd
msgid "Are you sure you want to delete this unit?"
msgstr "Êtes-vous sûr de vouloir supprimer cette unité?"

#. js-lingui-id: eZsnff
msgid "Unit is required"
msgstr "L'unité est requise"

#. js-lingui-id: eb1pqI
msgid "You cannot proceed with adding new applicants until a payment option has been set up. Please configure your payment settings first."
msgstr "Vous ne pouvez pas procéder à l'ajout de nouveaux candidats avant de configurer une option de paiement. Veuillez d'abord configurer vos paramètres de paiement."

#. js-lingui-id: ecUA8p
msgid "Today"
msgstr "Aujourd'hui"

#. js-lingui-id: ed798D
msgid "Payment incomplete"
msgstr "Paiement incomplet"

#. js-lingui-id: egHj6c
msgid "Assign Applicant to a unit"
msgstr "Affecter le candidat à une unité"

#. js-lingui-id: egwwZ4
msgid "This is where you'll follow the process to apply for the property. Follow the steps below to complete your rental application."
msgstr "C'est ici que vous suivrez le processus pour postuler à la propriété. Suivez les étapes ci-dessous pour compléter votre candidature."

#. js-lingui-id: eiDmZm
msgid "Select an Entry Date for this unit"
msgstr "Sélectionnez une date d'entrée pour cette unité"

#. js-lingui-id: ekCRTP
msgid "Rejected"
msgstr "Rejeté"

#. js-lingui-id: emyGv5
msgid "Application updated"
msgstr "Candidature mise à jour"

#. js-lingui-id: eps54V
msgid "Removed"
msgstr "Retiré"

#. js-lingui-id: esw3GM
msgid "Total Debt"
msgstr "Total de la dette"

#. js-lingui-id: euc6Ns
msgid "Duplicate"
msgstr "Dupliqué"

#. js-lingui-id: ewhiPL
msgid "Moderate Risk"
msgstr "Risque modéré"

#. js-lingui-id: eygUXi
msgid "Here's everyone currently on your application, including you. Review who's listed to add your missing co-applicant."
msgstr "Voici tous les candidats actuellement sur votre candidature, y compris vous. Examinez qui est listé pour ajouter votre co-applicant manquant."

#. js-lingui-id: eyvkH3
msgid "Enter the french description"
msgstr "Entrez la description en français"

#. js-lingui-id: f+Zl9t
msgid "To proceed with the evaluation of your file, you must enter your payment information"
msgstr "Pour poursuivre l'évaluation de votre dossier, vous devez entrer vos informations de paiement"

#. js-lingui-id: f3o0kM
msgid "Editing Application"
msgstr "Modification de la demande"

#. js-lingui-id: f51db3
msgid "Scan to verify"
msgstr "Scanner pour vérifier"

#. js-lingui-id: f7/Eil
msgid "Delivery Agent"
msgstr "Agent de livraison"

#. js-lingui-id: f8SsES
msgid "Are you sure you want to remove {applicantName} from the submission?"
msgstr "Êtes-vous sûr de vouloir retirer {applicantName} de la soumission ?"

#. js-lingui-id: f9b1sj
msgid "No agents assigned"
msgstr "Nb. d'agents assignés"

#. js-lingui-id: fAdPRh
msgid "Please enter your gross annual salary before taxes"
msgstr "Veuillez entrer votre salaire annuel brut avant impôts"

#. js-lingui-id: fByw/g
msgid "Individual"
msgstr "Individuel"

#. js-lingui-id: fDF1VQ
msgid "Tenants will be charged the following fees when applying:"
msgstr "Les locataires seront facturés les frais suivants lorsqu'ils postuleront :"

#. js-lingui-id: fF1oUJ
msgid "Promotion Price"
msgstr "Prix promotionnel"

#. js-lingui-id: fFQGk9
msgid "Description of the listing"
msgstr "Description de l'annonce"

#. js-lingui-id: fMXWoZ
msgid "{tenantName} real estate: {type} with {bedrooms} bedrooms for rent, {address}, {city}"
msgstr "{tenantName} immobilier: {type} {bedrooms} chambres à louer, {address}, {city}"

#. js-lingui-id: fO3Xr7
msgid "Property Details"
msgstr "Détails de la propriété"

#. js-lingui-id: fO6syE
msgid "Deadline for conditions"
msgstr "Date limite pour les conditions"

#. js-lingui-id: fSGoiV
msgid "Enter listing description in French"
msgstr "Entrez la description de l'annonce en français"

#. js-lingui-id: fTUn9h
msgid "Installment"
msgstr "Prêt"

#. js-lingui-id: fU4eQN
msgid "Mark as completed"
msgstr "Marquer comme terminé"

#. js-lingui-id: fUByRl
msgid "Absolutely not! Eversa is fundamentally free for landlords. The only expense involved is when tenants apply, as they cover the application fee. This fee includes the provision of credit reports to landlords, should they choose to request them. However, for landlords who prefer not to have tenants cover the cost of credit reports, the option is available to pay for it themselves through Eversa."
msgstr "Absolument non ! Eversa est fondamentalement gratuit pour les propriétaires. Le seul coût impliqué est lorsque les locataires s'inscrivent, car ils couvrent le coût de la candidature. Ce coût inclut la fourniture de rapports de crédit aux propriétaires, s'ils choisissent de les demander. Cependant, pour les propriétaires qui préfèrent ne pas avoir les locataires couvrir le coût des rapports de crédit, l'option est disponible pour payer eux-mêmes via Eversa."

#. js-lingui-id: fUQgpA
msgid "Hide Service Estimates on Reports"
msgstr "Masquer les estimations de service sur les rapports"

#. js-lingui-id: fUqA01
msgid "Co Applicant"
msgstr "Co-demandeur"

#. js-lingui-id: fcWrnU
msgid "Sign out"
msgstr "Déconnexion"

#. js-lingui-id: fcrjX7
msgid "Hmm.. looks like this resource doesn't have any notes."
msgstr "Hmm.. il semble que cette ressource n'ait aucune note."

#. js-lingui-id: feCRNv
msgid "Change email"
msgstr "Changer l'email"

#. js-lingui-id: fhAyL2
msgid "Valid until "
msgstr "Valable jusqu'au"

#. js-lingui-id: fhShV9
msgid "Unit has been successfully assigned to the submission"
msgstr "L'unité a été attribuée avec succès à la soumission"

#. js-lingui-id: fj5byd
msgid "N/A"
msgstr "N/A"

#. js-lingui-id: fmq4AW
msgid "Housing Information"
msgstr "Informations sur le logement"

#. js-lingui-id: foCvf0
msgid "Please choose one of the following methods to add them"
msgstr "Veuillez choisir l'une des méthodes suivantes pour les ajouter"

#. js-lingui-id: fp0Y29
msgid "Added {createdAtDate} ({createdAtAgo} ago)"
msgstr "Ajouté le {createdAtDate} ({createdAtAgo} ago)"

#. js-lingui-id: fpMgHS
msgid "Mon"
msgstr "Lun"

#. js-lingui-id: fsgSjm
msgid "Unit #"
msgstr "Unité #"

#. js-lingui-id: fwi1qh
msgid "Enter banner text in French"
msgstr "Entrez le texte de la bannière en français"

#. js-lingui-id: fyTCYk
msgid "Select Unit"
msgstr "Sélectionnez le logement"

#. js-lingui-id: fzUQAw
msgid "Enter Facebook Pixel ID"
msgstr "Entrez l'ID de votre pixel Facebook"

#. js-lingui-id: g/M3bA
msgid "Feature flags updated"
msgstr "Paramètres des fonctionnalités mis à jour"

#. js-lingui-id: g0+4qo
msgid "Check criminal records"
msgstr "Vérifier les antécédents criminels"

#. js-lingui-id: g0/RsH
msgid "{city}: {type} with {bedrooms} bedrooms, {tenantName} rental"
msgstr "{city}: {type} {bedrooms} chambres, location {tenantName}"

#. js-lingui-id: g1W6VN
msgid "Set requirements that would allow the tenant to reapply"
msgstr "Définir les exigences qui permettraient au locataire de soumettre à nouveau"

#. js-lingui-id: g2UNkE
msgid "Powered by"
msgstr "Propulsé par"

#. js-lingui-id: g40wrD
msgid "What's included in your application"
msgstr "Qu'est-ce qui est inclus dans votre candidature"

#. js-lingui-id: g7FtKA
msgid "The tenant has provided proof of insurance."
msgstr "Le locataire a fourni une preuve d'assurance."

#. js-lingui-id: g7ZTwA
msgid "{bathrooms} bathrooms, {bedrooms} bedrooms, {area} sqft"
msgstr "{bathrooms} salles de bain, {bedrooms} chambres, {area} m2"

#. js-lingui-id: g7jwTg
msgid "Showing"
msgstr "Affichage"

#. js-lingui-id: g8jjNi
msgid "Consents"
msgstr "Consentements"

#. js-lingui-id: gGyz7m
msgid "Enter the tenant's basic details"
msgstr "Saisissez les informations de base du locataire"

#. js-lingui-id: gI4Spy
msgid "Employment Letter of Offer"
msgstr "Lettre d'offre de travail"

#. js-lingui-id: gKTfBi
msgid "You are about to select <0>{selected}</0> as the tenant for this unit. Please confirm your selection and if necessary, specify how to handle the remaining applications."
msgstr "Vous allez sélectionner <0>{selected}</0> comme locataire pour cette unité. Veuillez confirmer votre sélection et, si nécessaire, spécifier comment gérer les candidatures restantes."

#. js-lingui-id: gM+MdT
msgid "Require applicants to provide their Social Insurance Number during the application process."
msgstr "Exiger aux candidats de fournir leur numéro d'assurance sociale pendant le processus de candidature."

#. js-lingui-id: gMo7XR
msgid "Manual Review"
msgstr "Révision manuelle"

#. js-lingui-id: gOdB00
msgid "Credit check request sent"
msgstr "Demande de vérification de crédit envoyée"

#. js-lingui-id: gQ7G5a
msgid "Number of years at current job"
msgstr "Nombre d'années dans le travail actuel"

#. js-lingui-id: gQBxBJ
msgid "Your information is only shared with the property manager handling your application and their authorized landlords or subprocessors. We never sell or share your data with unauthorized third parties."
msgstr "Vos informations sont uniquement partagées avec le gestionnaire immobilier qui traite votre candidature et leurs propriétaires ou sous-traitants autorisés. Nous ne vendons ni ne partageons vos données avec des tiers non autorisés."

#. js-lingui-id: gSwPlk
msgid "We are missing your billing information"
msgstr "Ils nous manquent vos information de paiement."

#. js-lingui-id: gbVkz/
msgid "Waiting for tenant to sign lease"
msgstr "En attente de la signature du bail par le locataire"

#. js-lingui-id: gcIka/
msgid "First-time renters"
msgstr "Locataires premiers"

#. js-lingui-id: gkebzV
msgid "No leads are available in this category at the moment."
msgstr "Aucun prospect n'est disponible dans cette catégorie pour le moment."

#. js-lingui-id: glCYLq
msgid "Customize the way your tenants fill in your rental application form."
msgstr "Personnaliser la façon dont vos locataires remplissent le formulaire de candidature locative."

#. js-lingui-id: gm0Lz3
msgid "Back to Admin Panel"
msgstr "Retour au tableau de bord administrateur"

#. js-lingui-id: gmkKhS
msgid "Remove applicant"
msgstr "Retirer le candidat"

#. js-lingui-id: gn7UzG
msgid "Living Arrangement"
msgstr "Situation de vie"

#. js-lingui-id: gov1Vf
msgid "Your application was declined due to information found in your criminal background check."
msgstr "Votre candidature a été rejetée en raison d'informations trouvées dans votre vérification de l'historique criminel."

#. js-lingui-id: gpWjJX
msgid "Verify the references provided by the tenant for their work and rental history."
msgstr "Vérifiez les références fournies par le locataire pour son travail et son historique de location."

#. js-lingui-id: gq6s8P
msgid "Reason for cancellation"
msgstr "Motif d'annulation"

#. js-lingui-id: gt5a0W
msgid "Promotion Details <0/>"
msgstr "Détails de la promotion <0/>"

#. js-lingui-id: gwfP2S
msgid "Issue with check"
msgstr "Problème avec chèque"

#. js-lingui-id: gxYz5c
msgid "Found"
msgstr "Trouvé"

#. js-lingui-id: gy9MoY
msgid "Proceed with the application without email notifications. The tenant will not receive any application updates."
msgstr "Continuer sans notifications par email. Le locataire ne recevra aucune mise à jour de la candidature."

#. js-lingui-id: gyjsV2
msgid "Commercial"
msgstr "Commercial"

#. js-lingui-id: gyrmfy
msgid "Uploading... {uploadProgress}%"
msgstr "Téléversement... {uploadProgress}%"

#. js-lingui-id: gzZ8OH
msgid "{tenantName}: {type} with {bedrooms} bedrooms for rent in {city}, {address}"
msgstr "{tenantName}: {type} de {bedrooms} chambres à louer à {city}, {address}"

#. js-lingui-id: h28hXf
msgid "90 days"
msgstr "90 jours"

#. js-lingui-id: h3GuHp
msgid "Applicant added"
msgstr "Candidat ajouté"

#. js-lingui-id: h5e1I4
msgid "We regret to inform you that your rental application has been rejected. While this is the current decision, there may be options to strengthen your application. We understand this news may be disappointing."
msgstr "Nous sommes désolés de vous informer que votre candidature à la location a été rejetée. Bien que cela soit la décision actuelle, il peut y avoir des options pour renforcer votre candidature. Nous comprenons que cette nouvelle peut être décevante."

#. js-lingui-id: hBm3J/
msgid "Organization name is required"
msgstr "Le nom de l'organisation est requis"

#. js-lingui-id: hCpDDZ
msgid "Invite an applicant via e-mail, or fill out a rental application form in person"
msgstr "Inviter un candidat par courriel ou complétez la demande de location en personne"

#. js-lingui-id: hF3aS6
msgid "Create Project"
msgstr "Créer un projet"

#. js-lingui-id: hFmUep
msgid "Payment pending - Tenant is paying"
msgstr "Paiement en attente - Le locataire paye"

#. js-lingui-id: hInJTA
msgid "Banner Text French"
msgstr "Texte de la bannière en français"

#. js-lingui-id: hJF/sr
msgid "Assigned:"
msgstr "Attribué:"

#. js-lingui-id: hM7Rhq
msgid "Reply-To Settings"
msgstr "Paramètres de réponse"

#. js-lingui-id: hOdqT6
msgid "Comprehensive tenant screening and verification"
msgstr "Contrôle et vérification complets des locataires"

#. js-lingui-id: hPur4k
msgid "Identity Verification"
msgstr "Vérification d'identité"

#. js-lingui-id: hQRttt
msgid "Submit"
msgstr "Soumettre"

#. js-lingui-id: hSVgUS
msgid "Applicant Information"
msgstr "Informations sur le candidat"

#. js-lingui-id: hTRnIR
msgid "Credit Report"
msgstr "Rapport de crédit"

#. js-lingui-id: hVTUaS
msgid "API Configuration"
msgstr "Configuration de l'API"

#. js-lingui-id: hWQs8X
msgid "Employment"
msgstr "Emploi"

#. js-lingui-id: hXzOVo
msgid "Next"
msgstr "Suivant"

#. js-lingui-id: hYgDIe
msgid "Create"
msgstr "Créer"

#. js-lingui-id: hbI+8q
msgid "Applicant has been successfully removed from the submission"
msgstr "Le candidat a été retiré avec succès de la soumission"

#. js-lingui-id: hcv6uc
msgid "Your payment was not successful"
msgstr "Votre paiement n'a pas été réussi"

#. js-lingui-id: heXFeC
msgid "Finalize and pay"
msgstr "Finaliser et payer"

#. js-lingui-id: hehnjM
msgid "Amount"
msgstr "Montant"

#. js-lingui-id: hgMhjQ
msgid "Select Listing"
msgstr "Sélectionnez l'annonce"

#. js-lingui-id: hh5ouw
msgid "Birthdate <0>(Required)</0>"
msgstr "Date de naissance <0>(Obligatoire)</0>"

#. js-lingui-id: hjGM6C
msgid "For accurate affordability analysis, we need complete financial information including income, existing debt obligations, and credit history. Please ensure all required financial data is provided."
msgstr "Pour une analyse d'accessibilité précise, nous avons besoin d'informations financières complètes, y compris le revenu, les dettes existantes et l'historique de crédit. Veuillez vous assurer que toutes les données financières requises est fournie."

#. js-lingui-id: hjaZqm
msgid "Project Overview"
msgstr "Aperçu du projet"

#. js-lingui-id: hkyw9A
msgid "Credit Check Dashboard"
msgstr "Tableau de bord de vérification de crédit"

#. js-lingui-id: hq7duP
msgid "Unknown action"
msgstr "Action inconnue"

#. js-lingui-id: htTcVX
msgid "Status:"
msgstr "Statut:"

#. js-lingui-id: htjiy6
msgid "Light Logo"
msgstr "Logo clair"

#. js-lingui-id: hwGp6h
msgid "Enter organization name"
msgstr "Entrez le nom de l'organisation"

#. js-lingui-id: hwXhZ8
msgid "Unsnooze Step"
msgstr "Étape de réactivation"

#. js-lingui-id: hzKQCy
msgid "Email Address"
msgstr "Adresse e-mail"

#. js-lingui-id: i+/x21
msgid "Option for prepaid rent"
msgstr "Demander un prepaiment du loyer"

#. js-lingui-id: i0qMbr
msgid "Home"
msgstr "Accueil"

#. js-lingui-id: i3o6QM
msgid "Insurance Proof"
msgstr "Preuve d'assurance"

#. js-lingui-id: i42zVQ
msgid "Chosen"
msgstr "Choisi"

#. js-lingui-id: i4V84s
msgid "No buildings for this month"
msgstr "Aucun bâtiment pour ce mois"

#. js-lingui-id: i8GmNv
msgid "User has provided consent for credit bureau checks"
msgstr "L'utilisateur a fourni son consentement pour les vérifications de bureau de crédit"

#. js-lingui-id: iDJJPV
msgid "Tenant Details"
msgstr "Détails du locataire"

#. js-lingui-id: iDNBZe
msgid "Notifications"
msgstr "Notifications"

#. js-lingui-id: iEQQyu
msgid "Agent"
msgstr "Agent"

#. js-lingui-id: iH8pgl
msgid "Back"
msgstr "Retour"

#. js-lingui-id: iIYyyz
msgid "Departure Date"
msgstr "Date de départ"

#. js-lingui-id: iJ5vP5
msgid "This application has been rejected with condition to be fulfilled before <0>{countdownDate}</0>"
msgstr "Cette demande a été refusée, condition à remplir avant le <0>{countdownDate}</0>"

#. js-lingui-id: iLZGud
msgid "Very Low Risk"
msgstr "Risque très faible"

#. js-lingui-id: iMFcF3
msgid "Unit:"
msgstr "Unité:"

#. js-lingui-id: iNoUCp
msgid "All features"
msgstr "Toutes les fonctionnalités"

#. js-lingui-id: iOPfhV
msgid "Could not retrieve complete applicant information (name, DOB, or address). Please check the profile and try again."
msgstr "Impossible de récupérer les informations complètes du candidat (nom, date de naissance ou adresse). Veuillez vérifier le profil et réessayer."

#. js-lingui-id: iQXbtV
msgid "Your Workload Overview"
msgstr "Aperçu de votre charge de travail"

#. js-lingui-id: iRV0QI
msgid "This submission was discarded as the applicants are no longer pursuing the application process. Their information is saved as a lead for future reference. You can always contact them or reopen their application later."
msgstr "Cette soumission a été abandonnée car les candidats ne poursuivent plus le processus de candidature. Leurs informations sont enregistrées comme un prospect pour une référence future. Vous pouvez toujours les contacter ou rouvrir leur candidature plus tard."

#. js-lingui-id: iRt239
msgid "Low Risk (≤43%)"
msgstr "Faible risque (≤43%)"

#. js-lingui-id: iWU6r6
msgid "Show Timeline"
msgstr "Afficher l'historique"

#. js-lingui-id: ibSQNg
msgid "Please provide contact information for your references"
msgstr "Veuillez fournir les informations de contact pour vos références"

#. js-lingui-id: iboNXd
msgid "Amount received"
msgstr "Montant reçu"

#. js-lingui-id: idPYrj
msgid "{tenantName}: {type} for rent, {bedrooms} bedrooms, {address}, {city}"
msgstr "{tenantName}: {type} à louer, {bedrooms} chambres, {address}, {city}"

#. js-lingui-id: idhKCE
msgid "Primary Applicant"
msgstr "Applicant Principale"

#. js-lingui-id: ieAHV7
msgid "Reference Rating"
msgstr "Évaluation de référence"

#. js-lingui-id: ik2cu/
msgid "Didn't receive code?"
msgstr "N'avez-vous pas reçu le code?"

#. js-lingui-id: ikeVX6
msgid "When did you start living here?"
msgstr "Quand avez-vous commencé à vivre ici?"

#. js-lingui-id: ilQjgP
msgid "USER"
msgstr "UTILISATEUR"

#. js-lingui-id: ilTx8u
msgid "Start or continue your application process"
msgstr "Commencez ou continuez votre processus de candidature"

#. js-lingui-id: in7EUA
msgid "Wait a few minutes and try again"
msgstr "Attendez quelques minutes et réessayez"

#. js-lingui-id: in9MKE
msgid "Are all features included in the free version?"
msgstr "Toutes les fonctionnalités sont incluses dans la version gratuite?"

#. js-lingui-id: iqxT9f
msgid "Message for Tenant"
msgstr "Message pour le locataire"

#. js-lingui-id: isRobC
msgid "New"
msgstr "Nouveau"

#. js-lingui-id: iuJFAy
msgid "Low Risk"
msgstr "Risque faible"

#. js-lingui-id: ivIm6I
msgid "Charged once per applicant"
msgstr "Facturé une fois par candidat"

#. js-lingui-id: iy15g/
msgid "Enter banner text in English"
msgstr "Entrez le texte de la bannière en anglais"

#. js-lingui-id: iyOEiI
msgid "Tenant"
msgstr "Locataire"

#. js-lingui-id: j/ToNV
msgid "Social Insurance Number"
msgstr "Numéro d'assurance sociale"

#. js-lingui-id: j/cgaV
msgid "Impact on monthly income"
msgstr "Impact sur le revenu mensuel"

#. js-lingui-id: j16c2i
msgid "We regret to inform you that your rental application has been removed from consideration. While this is the current status, there may be options to strengthen your application. We understand this news may be disappointing."
msgstr "Nous sommes désolés de vous informer que votre candidature à la location a été retirée de la considération. Bien que cela soit le statut actuel, il peut y avoir des options pour renforcer votre candidature. Nous comprenons que cette nouvelle peut être décevante."

#. js-lingui-id: j1ElMW
msgid "Unit deleted successfully"
msgstr "Unité supprimée avec succès"

#. js-lingui-id: j1MRp+
msgid "Are you sure you want to cancel the delivery for this submission?"
msgstr "Êtes-vous sûr de vouloir annuler la livraison pour cette soumission?"

#. js-lingui-id: j2OqfX
msgid "Country Code"
msgstr "Code du pays"

#. js-lingui-id: j2rI5/
msgid "Reference Type"
msgstr "Type de référence"

#. js-lingui-id: jCNUYo
msgid "Have questions or need assistance? Our team is here to help you find your perfect place."
msgstr "Vous avez des questions ou avez besoin d'assistance? Notre équipe est là pour vous aider à trouver le logement idéal."

#. js-lingui-id: jE1bem
msgid "All set! No deliveries are scheduled right now."
msgstr "Tout est bon! Aucune livraison n'est prévue pour le moment."

#. js-lingui-id: jErFHA
msgid "Court Name"
msgstr "Nom du tribunal"

#. js-lingui-id: jEu4bB
msgid "Columns"
msgstr "Colonnes"

#. js-lingui-id: jIPNJG
msgid "Basic Information"
msgstr "Informations de base"

#. js-lingui-id: jJ6dzg
msgid "Salary must be greater than 0"
msgstr "Le salaire doit être supérieur à 0."

#. js-lingui-id: jJQZUi
msgid "Please provide contact details for your current or previous landlord or property manager"
msgstr "Veuillez fournir les coordonnées de contact pour votre propriétaire ou gestionnaire de propriété actuel ou précédent"

#. js-lingui-id: jJzvFJ
msgid "Employment Length"
msgstr "Durée de l'emploi"

#. js-lingui-id: jLW6SE
msgid "The reported monthly income (${income}) is too low for an accurate affordability analysis. Please verify the income information."
msgstr "Le revenu mensuel rapporté (${income}) est trop bas pour une analyse d'accessibilité précise. Veuillez vérifier les informations de revenu."

#. js-lingui-id: jNLD8R
msgid "Start typing an address..."
msgstr "Commencez à taper une adresse..."

#. js-lingui-id: jNX9Hl
msgid "Missing Credit"
msgstr "Crédit manquant"

#. js-lingui-id: jP5+uW
msgid "Combine multiple applicants into a single submission"
msgstr "Combiner plusieurs candidats en une seule soumission"

#. js-lingui-id: jQX8V+
msgid "By Status"
msgstr "Par statut"

#. js-lingui-id: jRuA33
msgid "Credit Check Report"
msgstr "Rapport des vérifications de crédit"

#. js-lingui-id: jTxtBH
msgid "Moderate utilization"
msgstr "Utilisation modérée"

#. js-lingui-id: jVI3ce
msgid "Invite Candidate"
msgstr "Inviter un candidat"

#. js-lingui-id: jVit+R
msgid "Acting as {tenantSlug} with admin privileges. Actions recorded."
msgstr "Vous êtes en train d'impersonner {tenantSlug} avec des privilèges administratifs. Les actions sont enregistrées."

#. js-lingui-id: jWR9A7
msgid "Sign out of your account"
msgstr "Se déconnecter de votre compte"

#. js-lingui-id: jWaJuP
msgid "Missing User"
msgstr "Utilisateur manquant"

#. js-lingui-id: jYbKwR
msgid "Enables staff to take actions during this submission step"
msgstr "Permet au personnel de prendre des actions pendant cette étape de soumission"

#. js-lingui-id: ja7jsW
msgid "Current Living Arrangement"
msgstr "Situation de vie actuelle"

#. js-lingui-id: jcnQjB
msgid "Sign in to continue your application or access your tenant portal"
msgstr "Se connecter pour continuer votre candidature ou accéder à votre portail locataire"

#. js-lingui-id: jePyJ9
msgid "Error Code: {errorCode}"
msgstr "Code d'erreur: {errorCode}"

#. js-lingui-id: jfC/xh
msgid "Contact"
msgstr "Contact"

#. js-lingui-id: jg6q1p
msgid "Application Reports"
msgstr "Rapports de candidature"

#. js-lingui-id: jilCAY
msgid "Owners have full administrative access to the organization, including managing team members, billing, and all organization settings."
msgstr "Les propriétaires ont accès administratif complet à l'organisation, y compris la gestion des membres de l'équipe, la facturation et tous les paramètres de l'organisation."

#. js-lingui-id: jjlrdR
msgid "Start Application"
msgstr "Commencer la candidature"

#. js-lingui-id: jlYOCC
msgid "Criminal record check"
msgstr "Vérification du registre criminel"

#. js-lingui-id: jmsnSb
msgid "Choose File"
msgstr "Choisir un fichier"

#. js-lingui-id: joaY8v
msgid "The tenant has not received the rules and regulations."
msgstr "Le locataire n'a pas reçu les règlements du bâtiment."

#. js-lingui-id: joygfD
msgid "Moderate stretch (30-40% of available income)"
msgstr "Stretch modéré (30-40% du revenu disponible)"

#. js-lingui-id: jp0+jP
msgid "Select the applicants you want to merge"
msgstr "Sélectionnez les candidats que vous souhaitez fusionner"

#. js-lingui-id: jpctdh
msgid "View"
msgstr "Voir"

#. js-lingui-id: jtc5/e
msgid "No submissions found"
msgstr "Aucune soumission trouvée"

#. js-lingui-id: jyxrtr
msgid "Neighborhood"
msgstr "Quartier"

#. js-lingui-id: k/ANik
msgid "Finances"
msgstr "Finances"

#. js-lingui-id: k1Jind
msgid "Allow staff members to see and use the 'Send to Prospect' button."
msgstr "Autoriser les membres du personnel à voir et utiliser le bouton 'Envoyer au prospect'."

#. js-lingui-id: k2ZWbt
msgid "You must pay your profile verification fee to continue"
msgstr "Vous devez payer vos frais de vérification de profil pour continuer"

#. js-lingui-id: kDuHO3
msgid "No verifications selected"
msgstr "Aucune vérification sélectionnée"

#. js-lingui-id: kFFkAk
msgid "Background information unavailable"
msgstr "Informations d'antécédents indisponibles"

#. js-lingui-id: kGO4H2
msgid "Completed on {rulesDate}"
msgstr "Complété le {rulesDate}"

#. js-lingui-id: kHYqrd
msgid "Type the address here..."
msgstr "Tapez l'adresse ici..."

#. js-lingui-id: kJ1Oks
msgid "Payment history"
msgstr "Historique des paiements"

#. js-lingui-id: kKHBpG
msgid "Total Application Fee"
msgstr "Frais de candidature total"

#. js-lingui-id: kNeEXg
msgid "Current Price"
msgstr "Prix actuel"

#. js-lingui-id: kO9x/r
msgid "Configure your intelligent tenant screening parameters powered by Eversa's advanced analytics"
msgstr "Configurez les paramètres de vérification de locataire intelligents alimentés par les analyses avancées d'Eversa"

#. js-lingui-id: kODvZJ
msgid "First Name"
msgstr "Prénom"

#. js-lingui-id: kTTERt
msgid "The application hold has been marked as completed. Please review the application and proceed with the next steps."
msgstr "La mise en attente de la candidature a été marquée comme terminée. Veuillez examiner la candidature et procéder aux étapes suivantes."

#. js-lingui-id: kTcFUK
msgid "60 days"
msgstr "60 jours"

#. js-lingui-id: kWURkg
msgid "Annual Income"
msgstr "Revenu annuel"

#. js-lingui-id: kbZGHg
msgid "Address History (6+ Months)"
msgstr "Historique des adresses (6+ mois)"

#. js-lingui-id: kfeUSb
msgid "There was an error assigning the submission"
msgstr "Une erreur s'est produite lors de l'attribution de la soumission"

#. js-lingui-id: kgFvGM
msgid "Long-term leases"
msgstr "Baux à long terme"

#. js-lingui-id: kh/2xY
msgid "Information Missing"
msgstr "Informations manquantes"

#. js-lingui-id: kjm4uO
msgid "How long does the application process take?"
msgstr "Combien de temps dure le processus de candidature?"

#. js-lingui-id: kjoU6t
msgid "Converted to project"
msgstr "Converti en projet"

#. js-lingui-id: kmE79G
msgid "Unknown account type"
msgstr "Type de compte inconnu"

#. js-lingui-id: knDRX+
msgid "{bedrooms} bedrooms, {tenantName} {type} for rent in {city}, {address}"
msgstr "{bedrooms} chambres, {type} {tenantName} à louer à {city}, {address}"

#. js-lingui-id: kqqfc7
msgid "Complete all requirements before delivery"
msgstr "Complétez tous les exigences avant la livraison"

#. js-lingui-id: ktRQXJ
msgid "Fill in the details below to create a new tenant organization"
msgstr "Remplissez les détails ci-dessous pour créer une nouvelle organisation locataire"

#. js-lingui-id: kuE2S/
msgid "Browse Available Properties"
msgstr "Parcourez les propriétés disponibles"

#. js-lingui-id: kvwxvf
msgid "Description (French)"
msgstr "Description (français)"

#. js-lingui-id: kw7NLK
msgid "Listing is required"
msgstr "L'annonce est requise"

#. js-lingui-id: kxPyT8
msgid "tenant@example.com"
msgstr "locataire@exemple.com"

#. js-lingui-id: kxZ7LS
msgid "Webhook updated"
msgstr "Webhook mis à jour"

#. js-lingui-id: kycuCv
msgid "Show submissions assigned to me"
msgstr "Afficher les soumissions assignées à moi"

#. js-lingui-id: kzMF2k
msgid "This credit check may impact your credit score, depending on the nature of the credit score, depending on the nature of the request and the policies of the credit bureau."
msgstr "Cette vérification de crédit peut affecter votre score de crédit, en fonction de la nature du score de crédit, en fonction de la nature de la demande et des politiques du bureau de crédit."

#. js-lingui-id: l2iifO
msgid "I am done"
msgstr "Je suis prêt"

#. js-lingui-id: l4GvBw
msgid "Manage this submission's address"
msgstr "Gérer l'adresse de cette soumission"

#. js-lingui-id: l6MW/b
msgid "Detailed debt analysis including payment history, debt utilization trends, <0/>and debt-to-income ratios across different categories like credit cards, loans and mortgages."
msgstr "Analyse détaillée de la dette, y compris l'historique des paiements, les tendances d'utilisation de la dette et les ratios dette/revenu dans différentes catégories telles que les cartes de crédit, les prêts et les hypothèques."

#. js-lingui-id: l75CjT
msgid "Yes"
msgstr "Oui"

#. js-lingui-id: l7fStm
msgid "Utilities"
msgstr "Charges"

#. js-lingui-id: l8u/ot
msgid "Building updated successfully"
msgstr "Bâtiment mis à jour avec succès"

#. js-lingui-id: l9fkrm
msgid "Consent"
msgstr "Consentements"

#. js-lingui-id: lCF0wC
msgid "Refresh"
msgstr "Actualiser"

#. js-lingui-id: lCLuUQ
msgid "Try adding more characters to your search term."
msgstr "Essayez d'ajouter plus de caractères à votre terme de recherche."

#. js-lingui-id: lHYEwC
msgid "Credit score verification"
msgstr "Vérification du score de crédit"

#. js-lingui-id: lKhoOk
msgid "We couldn't find any background information for this applicant"
msgstr "Nous n'avons trouvé aucune information d'antécédents pour ce candidat"

#. js-lingui-id: lOD90K
msgid "Promote Unit"
msgstr "Promouvoir l'unité"

#. js-lingui-id: lOPsFO
msgid "Add an Applicant"
msgstr "Ajouter un applicant"

#. js-lingui-id: lOoJGy
msgid "Basic application processing"
msgstr "Traitement de candidature de base"

#. js-lingui-id: lSQYpT
msgid "No References Available"
msgstr "Aucune référence disponible"

#. js-lingui-id: lWfUAp
msgid "Open Full Application"
msgstr "Ouvrir le formulaire complet"

#. js-lingui-id: lXGdbb
msgid "Assigned"
msgstr "Attribué"

#. js-lingui-id: lXa/Jf
msgid "General Notifications"
msgstr "Notifications générales"

#. js-lingui-id: lXkUEV
msgid "Availability"
msgstr "Disponibilité"

#. js-lingui-id: lYGfRP
msgid "English"
msgstr "Anglais"

#. Language switcher. Need to be other language
#. Language switcher. Need to be other language
#. js-lingui-explicit-id
msgid "language"
msgstr "Anglais"

#. js-lingui-id: lb+3SG
msgid "Put this submission on hold and let the applicant know what additional information you need from them."
msgstr "Mettre cette candidature en veille et laisser le locataire savoir ce que vous avez besoin de plus d'eux."

#. js-lingui-id: lgRDKv
msgid "Submission is rejected with conditions"
msgstr "La soumission est rejetée sous conditions"

#. js-lingui-id: lhJcoY
msgid "Detailed debt category information is not available at the moment. This may be due to missing credit report data."
msgstr "Les informations détaillées sur les catégories de dettes ne sont pas disponibles pour le moment. Cela peut être dû à des données de rapport de crédit manquantes."

#. js-lingui-explicit-id
msgid "listings.apply.consents"
msgstr "Accepter les consentements"

#. js-lingui-explicit-id
msgid "listings.apply.consents-description"
msgstr "Approuver les termes et conditions de la candidature"

#. js-lingui-explicit-id
msgid "listings.apply.credit-check"
msgstr "Complétez votre vérification de crédit"

#. js-lingui-explicit-id
msgid "listings.apply.credit-check-description"
msgstr "Nous effectuerons une vérification de crédit pour analyser votre demande"

#. js-lingui-explicit-id
msgid "listings.apply.documents-uploads"
msgstr "Téléverser des documents"

#. js-lingui-explicit-id
msgid "listings.apply.documents-uploads-description"
msgstr "Téléverser votre preuve de travail et d'identité requise."

#. js-lingui-explicit-id
msgid "listings.apply.payment-description"
msgstr "Finalisez et payez les frais de dossier."

#. js-lingui-explicit-id
msgid "listings.apply.personal-details"
msgstr "Détails personnels"

#. js-lingui-explicit-id
msgid "listings.apply.personal-details-description"
msgstr "Nous avons besoin de vos renseignements personnels pour vous contacter et traiter votre demande."

#. js-lingui-id: ljiIpd
msgid "The listing will be re-opened as a result of this operation."
msgstr "L'annonce sera réouverte suite à cette opération."

#. js-lingui-id: ljrfNc
msgid "My Settings"
msgstr "Mes paramètres"

#. js-lingui-id: lpJtvA
msgid "Your application requires an additional person (partner, friend, parent or endorser) to strengthen your application. Please proceed to the section below to add this person."
msgstr "Votre candidature nécessite une personne supplémentaire (partenaire, ami, parent ou endosseur) pour renforcer votre candidature. Veuillez procéder à la section ci-dessous pour ajouter cette personne."

#. js-lingui-id: luAHZ6
msgid "Deliveries for"
msgstr "Livraisons pour"

#. js-lingui-id: ly4ADG
msgid "Commented on"
msgstr "Commenté le"

#. js-lingui-id: m01loN
msgid "We've received your application. You can follow the remaining steps below to complete your rental application process."
msgstr "Nous avons reçu votre candidature. Vous pouvez suivre les étapes restantes ci-dessous pour compléter le processus de candidature à la location."

#. js-lingui-id: m16xKo
msgid "Add"
msgstr "Ajouter"

#. js-lingui-id: m2KF6A
msgid "Verify income stability and payment history before proceeding."
msgstr "Vérifiez la stabilité du revenu et l'historique des paiements avant de procéder."

#. js-lingui-id: m3akJp
msgid "I don't have a work reference"
msgstr "Je n'ai pas de référence d'emploi"

#. js-lingui-id: m4Nqxf
msgid "Upload Documents:"
msgstr "Téléverser des documents:"

#. js-lingui-id: m8Ew6A
msgid "View agent dashboard"
msgstr "Voir le tableau de bord des agents"

#. js-lingui-id: mAr4Dl
msgid "All Listings"
msgstr "Toutes les annonces"

#. js-lingui-id: mCimdw
msgid "Preparing your application..."
msgstr "Préparation de votre candidature..."

#. js-lingui-id: mDJV6q
msgid "Support via email and chat"
msgstr "Assistance par e-mail et chat"

#. js-lingui-id: mJcdxJ
msgid "unlisted"
msgstr "non listé"

#. js-lingui-id: mLR/c3
msgid "Upload the required documents below."
msgstr "Téléverser les documents requis ci-dessous."

#. js-lingui-id: mMQSH4
msgid "Bedrooms"
msgstr "Chambres"

#. js-lingui-id: mOFgdC
msgid "Maximum"
msgstr "Maximum"

#. js-lingui-id: mOjKS5
msgid "Social Security Number"
msgstr "Numéro d'assurance sociale"

#. js-lingui-id: mUwcD7
msgid "New Entries"
msgstr "Nouvelles entrées"

#. js-lingui-id: mWHt8Y
msgid "Marketing Stats"
msgstr "Statistiques marketing"

#. js-lingui-id: mXtW19
msgid "Last 24 Months"
msgstr "24 derniers mois"

#. js-lingui-id: mYGY3B
msgid "Date"
msgstr "Date"

#. js-lingui-id: mbM6E8
msgid "List View"
msgstr "Afficher (Liste)"

#. js-lingui-id: mcbkPO
msgid "Save Webhook"
msgstr "Enregistrer le webhook"

#. js-lingui-id: mcfB2A
msgid "Move to"
msgstr "Déplacer à"

#. js-lingui-id: mdRvRh
msgid "View all {leadsLength} leads"
msgstr "Voir tous les {leadsLength} prospects"

#. js-lingui-id: mhc5cx
msgid "Your payment was successful"
msgstr "Votre paiement a été réussi"

#. js-lingui-id: mhsnB6
msgid "Retired"
msgstr "Retraité"

#. js-lingui-id: miQvV4
msgid "APPLICANT"
msgstr "CANDIDAT"

#. js-lingui-id: min/oe
msgid "The phone is invalid"
msgstr "Le numéro de téléphone est invalide"

#. js-lingui-id: mmcbA6
msgid "Select a unit"
msgstr "Sélectionner une unité"

#. js-lingui-id: mnRo94
msgid "No background information found"
msgstr "Aucune information d'antécédents trouvée"

#. js-lingui-id: moEkos
msgid "The first image you upload will be used as the featured image for this project on the listing page and in search results."
msgstr "La première image que vous téléchargez sera utilisée comme image en vedette pour ce projet sur la page d'annonce et dans les résultats de recherche."

#. js-lingui-id: msQkES
msgid "Time: {timestamp}"
msgstr "Temps: {timestamp}"

#. js-lingui-id: mtGDyy
msgid "Incomplete"
msgstr "Incomplet"

#. js-lingui-id: mve+bF
msgid "Enter Ads Conversion ID"
msgstr "Entrez l'ID de conversion des annonces"

#. js-lingui-id: mvjCaf
msgid "I am retired"
msgstr "Je suis retraité"

#. js-lingui-id: myXW4v
msgid "Work Reference"
msgstr "Référence d'emploi"

#. js-lingui-id: mzD+xl
msgid "Adding more tenants to your application could strengthen the combined financial profile."
msgstr "Ajouter plus de locataires à votre candidature peut renforcer le profil financier combiné.  "

#. js-lingui-id: n1ekoW
msgid "Sign In"
msgstr "Se connecter"

#. js-lingui-id: n3MSJu
msgid "Application Fee Summary"
msgstr "Récapitulatif des frais de candidature"

#. js-lingui-id: n7JQEk
msgid "Project not found"
msgstr "Projet introuvable"

#. js-lingui-id: n9u/m0
msgid "Employer"
msgstr "Employeur"

#. js-lingui-id: nEUrSn
msgid "No description available"
msgstr "Aucune description disponible"

#. js-lingui-id: nGKQKf
msgid "Select a Listing"
msgstr "Sélectionner une annonce"

#. js-lingui-id: nK1ecQ
msgid "This listing is not published, this is only a preview"
msgstr "Cette annonce n'est pas publiée, ce n'est qu'un aperçu"

#. js-lingui-id: nKRwdH
msgid "Please select a specific building first to add a unit."
msgstr "Veuillez selectionné un bâtiment avant d'ajouter une unité"

#. js-lingui-id: nLC6tu
msgid "French"
msgstr "Français"

#. js-lingui-id: nMHIQ7
msgid "Enables visit agents to take actions during this submission step"
msgstr "Permet aux agents de visite de prendre des actions lors de cette étape de candidature"

#. js-lingui-id: nMZWl5
msgid "The project has been created and you can now add buildings to it"
msgstr "Le projet a été créé et vous pouvez maintenant ajouter des bâtiments à cela"

#. js-lingui-id: nOhz3x
msgid "Logout"
msgstr "Se déconnecter"

#. js-lingui-id: nQYfYJ
msgid "Financial data is not available at the moment. This may be due to missing financial information or inconsistencies in the reported data."
msgstr "Les données financières ne sont pas disponibles pour le moment. Cela peut être dû à des informations financières manquantes ou des incohérences dans les données signalées."

#. js-lingui-id: nTWWCZ
msgid "Low"
msgstr "Faible"

#. js-lingui-id: nU5DXS
msgid "Visit Agent"
msgstr "Agent de visite"

#. js-lingui-id: nVsHM3
msgid "You will then have a pass allowing you to apply for free on other listings for a period of 30 days"
msgstr "Vous aurez alors un pass vous permettant de postuler gratuitement sur d'autres annonces pendant une période de 30 jours"

#. js-lingui-id: nb+Oy7
msgid "Quebec civil court records search"
msgstr "Recherche dans les enregistrements de la cour civile du Québec"

#. js-lingui-id: nbuFqP
msgid "Electricity Proof"
msgstr "Preuve d'électricité"

#. js-lingui-id: neXsCN
msgid "Poor Rental History"
msgstr "Historique de location défavorable"

#. js-lingui-id: neqk4D
msgid "Proceed with standard verification process."
msgstr "Procéder avec le processus de vérification standard."

#. js-lingui-id: nfnm9D
msgid "Organization Name"
msgstr "Nom de l'organisation"

#. js-lingui-id: nhT3ZT
msgid "Submission has been successfully sent to leads"
msgstr "La soumission a été envoyée avec succès aux prospects"

#. js-lingui-id: nhaNzc
msgid "Click to browse or drag and drop your CSV file here"
msgstr "Cliquez pour parcourir ou glisser-déposer votre fichier CSV ici"

#. js-lingui-id: nhn/TI
msgid "Calendar View"
msgstr "Afficher (Calendrier)"

#. js-lingui-id: ni5s4I
msgid "High Risk (≥48%)"
msgstr "Haut risque (≥48%)"

#. js-lingui-id: niOZHm
msgid "Proof of Funds/Savings"
msgstr "Preuve de fonds/économies"

#. js-lingui-id: nig8jh
msgid "eg: rentals@acmeinc.com"
msgstr "ex: rentals@acmeinc.com"

#. js-lingui-id: nim7CO
msgid "Est. Utilities"
msgstr "Est. des services"

#. js-lingui-id: njmBly
msgid "Hide Details"
msgstr "Masquer les détails"

#. js-lingui-id: nmgmCl
msgid "Main Applicant"
msgstr "Candidat principal"

#. js-lingui-id: nqHFGw
msgid "Started "
msgstr "Commencé "

#. js-lingui-id: nqpcbE
msgid "Pixel ID"
msgstr "Pixel ID"

#. js-lingui-id: nspXst
msgid "Income Value"
msgstr "Valeur du revenu"

#. js-lingui-id: ntFtnu
msgid "Applicant successfully deleted"
msgstr "Candidat supprimé avec succès"

#. js-lingui-id: ntmxFO
msgid "Strong compensating factors needed"
msgstr "Facteurs compensatoires forts nécessaires"

#. js-lingui-id: nuh/Wq
msgid "Webhook URL"
msgstr "URL du webhook"

#. js-lingui-id: nwGUh0
msgid "Application Confirmation"
msgstr "Confirmation de la candidature"

#. js-lingui-id: nwtY4N
msgid "Something went wrong"
msgstr "Quelque chose s'est mal passé"

#. js-lingui-id: nxg9ym
msgid "Property Manager"
msgstr "Gestionnaire immobilier"

#. js-lingui-id: o+7sJL
msgid "Credit Profile"
msgstr "Profil de crédit"

#. js-lingui-id: o+XJ9D
msgid "Change"
msgstr "Changer"

#. js-lingui-id: o1281j
msgid "View as yourself"
msgstr "Voir en tant que vous-même"

#. js-lingui-id: oFXWhF
msgid "Check your internet connection"
msgstr "Vérifiez votre connexion internet"

#. js-lingui-id: oFl0WW
msgid "Price + Promo"
msgstr "Prix + Promo"

#. js-lingui-id: oMHCRM
msgid "In accordance with privacy laws, you have the right to request access to and correction of your credit information from the relevant credit bureau."
msgstr "Conformément aux lois de la vie privée, vous avez le droit de demander l'accès et la correction de vos informations de crédit du bureau de crédit approprié."

#. js-lingui-id: oNhB4x
msgid "By discarding this submission, you are confirming that you don't want to proceed with this submission for now, it will still be available in the admin dashboard."
msgstr "En supprimant cette soumission, vous confirmez que vous ne souhaitez pas poursuivre cette soumission pour le moment, elle sera toujours disponible dans le tableau de bord administrateur."

#. js-lingui-id: oPhDgZ
msgid "Candidate Report"
msgstr "Rapport du candidat"

#. js-lingui-id: oSy7+Q
msgid "Type and press Enter to add"
msgstr "Taper et appuyer sur Entrée pour ajouter"

#. js-lingui-id: oTQAzG
msgid "{tenantTitle} | Apartment for rent {street}, {city}"
msgstr "{tenantTitle} | Appartement à louer {street}, {city}"

#. js-lingui-id: oUN0j9
msgid "Manage your submission settings."
msgstr "Gérer vos paramètres de soumission."

#. js-lingui-id: oVNQYH
msgid "Your configured minimum score"
msgstr "Votre ratio minimum configuré"

#. js-lingui-id: oWN+Nf
msgid "Regional Avg"
msgstr "Moyenne régionale"

#. js-lingui-id: oYPtMG
msgid "Total payments"
msgstr "Total des paiements"

#. js-lingui-id: oZd08v
msgid "Building"
msgstr "Bâtiment"

#. js-lingui-id: oaYerQ
msgid "Enter Analytics ID"
msgstr "Entrez l'ID Analytics"

#. js-lingui-id: ofldSs
msgid "Area"
msgstr "Surface"

#. js-lingui-id: ohP1RY
msgid "Can't find your address?"
msgstr "Vous ne trouvez pas votre adresse?"

#. js-lingui-id: oiutW1
msgid "Your Application"
msgstr "Votre candidature"

#. js-lingui-id: om2CIo
msgid "Please explain why you don't have a work reference"
msgstr "Veuillez expliquer pourquoi vous n'avez pas de référence d'emploi"

#. js-lingui-id: on8/3S
msgid "Submission Steps"
msgstr "Étapes de soumission"

#. js-lingui-id: ongtbP
msgid "Open the full application form to edit all details"
msgstr "Ouvrir le formulaire complet pour modifier tous les détails"

#. js-lingui-id: ovBpbn
msgid "Please enter a realistic number of years (maximum 100)"
msgstr "Veuillez entrer un nombre réaliste d'années (maximum 100)"

#. js-lingui-id: oyIs+l
msgid "Prices"
msgstr "Prix"

#. js-lingui-id: p1fgy4
msgid "How will I be notified about my application status?"
msgstr "Comment serai-je informé de l'état de ma candidature?"

#. js-lingui-id: p4zy6y
msgid "Lived here since"
msgstr "J'habite ici depuis"

#. js-lingui-id: p6F0VQ
msgid "Bankruptcy"
msgstr "Faillite"

#. js-lingui-id: p6InQT
msgid "Date Filed"
msgstr "Date de dépôt"

#. js-lingui-id: p7Zk0t
msgid "Cannot load units without project data"
msgstr "Impossible de charger les unités sans données de projet"

#. js-lingui-id: p8YLf5
msgid "Previous Tenant Details"
msgstr "Détails du locataire précédent"

#. js-lingui-id: pBcGZu
msgid "Rental Board"
msgstr "Conseil de logement"

#. js-lingui-id: pCKi8o
msgid "Action completed"
msgstr "Action terminée"

#. js-lingui-id: pEZLGC
msgid "Select Property"
msgstr "Sélectionnez le logement"

#. js-lingui-id: pFNIVp
msgid "View credit check reports"
msgstr "Voir les rapports de vérification de crédit"

#. js-lingui-id: pHXpGv
msgid "No address provided"
msgstr "Aucune adresse fournie"

#. js-lingui-id: pJLvdS
msgid "Please select"
msgstr "Veuillez sélectionner"

#. js-lingui-id: pJu9Fa
msgid "Select Events"
msgstr "Sélectionner les événements"

#. js-lingui-id: pKg7/f
msgid "Are you sure you want to delete this promotion?"
msgstr "Êtes-vous sûr de vouloir supprimer cette promotion?"

#. js-lingui-id: pMJABf
msgid "Agent:"
msgstr "Agent:"

#. js-lingui-id: pN22GK
msgid "Your application was declined based on your previous rental history records."
msgstr "Votre candidature a été rejetée sur la base de votre historique de location précédent."

#. js-lingui-id: pNTxeB
msgid "Your application did not meet our required financial criteria for this property."
msgstr "Votre candidature n'a pas répondu aux critères financiers requis pour cette propriété."

#. js-lingui-id: pPofBq
msgid "{city}: {tenantName} {type} for rent, {bedrooms} bedrooms, {address}"
msgstr "{city}: {type} {tenantName} à louer, {bedrooms} chambres, {address}"

#. js-lingui-id: pQjjYo
msgid "Link copied to clipboard"
msgstr "Lien copié dans le presse-papiers"

#. js-lingui-id: pWQHSr
msgid "Availability date"
msgstr "Date de disponibilité"

#. js-lingui-id: pYKeLz
msgid "Email already exists"
msgstr "Courriel déjà existant"

#. js-lingui-id: paehRh
msgid "Log Out"
msgstr "Se déconnecter"

#. js-lingui-id: paqH4b
msgid "Partial Match"
msgstr "Correspondance partielle"

#. js-lingui-id: pe3lV8
msgid "Please select an address"
msgstr "Veuillez sélectionner une adresse"

#. js-lingui-id: pgi/z4
msgid "{tenantName} {type}: {bedrooms} bedrooms for rent, {address}, {city}"
msgstr "{type} {tenantName}: {bedrooms} chambres à louer, {address}, {city}"

#. js-lingui-id: ph32zj
msgid "By signing below, you confirm that <0>you have read and understand the terms of the credit check and authorize us to obtain your credit report</0> . You understand that this credit check will be used to evaluate your application and may affect your credit score. You certify that all information provided is accurate and consent to the verification of this information."
msgstr "En signant ci-dessous, vous confirmez que vous avez lu et compris les termes de la vérification de crédit et avez autorisé notre entreprise à obtenir votre rapport de crédit. Vous comprenez que cette vérification de crédit sera utilisée pour évaluer votre candidature et peut affecter votre score de crédit. Vous certifiez que toutes les informations fournies sont exactes et que vous consentez à la vérification de ces informations."

#. js-lingui-id: phGV+Q
msgid "Add your SIN to our secured form to improve your chances to obtain a credit report. This information is not saved and is only used to verify your identity when running the credit check."
msgstr "Ajoutez votre numéro d'assurance sociale à notre formulaire sécurisé pour améliorer vos chances d'obtenir un rapport de crédit. Cette information n'est pas enregistrée et n'est utilisée que pour vérifier votre identité lors de la vérification de crédit."

#. js-lingui-id: pl0SnL
msgid "Invalid SIN number"
msgstr "Numéro d'assurance sociale invalide"

#. js-lingui-id: plhHQt
msgid "No data"
msgstr "Aucune donnée"

#. js-lingui-id: pnZnHJ
msgid "Submission has been successfully approved by the owner"
msgstr "La soumission a été approuvée avec succès par le propriétaire"

#. js-lingui-id: pofvdg
msgid "Eviction Records"
msgstr "Enregistrements d'éviction"

#. js-lingui-id: pqSsD8
msgid "Credit Cards"
msgstr "Cartes de crédit"

#. js-lingui-id: pqZ3rq
msgid "Delivery not scheduled"
msgstr "La livraison n'est pas prévue"

#. js-lingui-id: psfVQr
msgid "High-interest loans"
msgstr "Prêts à intérêt élevé"

#. js-lingui-id: puxKQA
msgid "Move to next step"
msgstr "Passer à l'étape suivante"

#. js-lingui-id: pwYmr+
msgid "Total debt impact on monthly income"
msgstr "Impact total des dettes sur le revenu mensuel"

#. js-lingui-id: pwfsqf
msgid "Select a reason"
msgstr "Sélectionner une raison"

#. js-lingui-id: pz0qTl
msgid "You've finalized this submission and has sent to delivery successfully"
msgstr "Vous avez finalisé cette soumission et l'avez envoyée avec succès à la livraison"

#. js-lingui-id: q+hNag
msgid "Collection"
msgstr "Collection"

#. js-lingui-id: q6zvmX
msgid "Last 100"
msgstr "100 derniers"

#. js-lingui-id: qCwYMT
msgid "Payment plan"
msgstr "Plan de paiement"

#. js-lingui-id: qE0pRR
msgid "Choose this applicant"
msgstr "Choisir ce candidat"

#. js-lingui-id: qEZ/dZ
msgid "Drag and drop the steps to reorder them. You can also toggle the visibility of each step and change the color associated with each step."
msgstr "Faites glisser et déposez les étapes pour les réorganiser. Vous pouvez également activer ou désactiver la visibilité de chaque étape et changer la couleur associée à chaque étape."

#. js-lingui-id: qGgBdU
msgid "Poor"
msgstr "Faible"

#. js-lingui-id: qJb6G2
msgid "Try Again"
msgstr "Réessayer"

#. js-lingui-id: qMN6oz
msgid "The submission will need to be re-evaluated by the team."
msgstr "La soumission devra être réévaluée par l'équipe."

#. js-lingui-id: qNtzA+
msgid "We're working on it..."
msgstr "Nous y travaillons..."

#. js-lingui-id: qSk06M
msgid "DTI Ratio"
msgstr "Ratio DTI"

#. js-lingui-id: qU9/WI
msgid "{diffHours}h remaining"
msgstr "{diffHours}h restants"

#. js-lingui-id: qZZfkc
msgid "Only lowercase letters, numbers, and hyphens are allowed"
msgstr "Seuls les lettres minuscules, les chiffres et les tirets sont autorisés"

#. js-lingui-id: qc0GJ9
msgid "The debt category breakdown requires data from credit reports and financial verification. This information may still be processing or unavailable."
msgstr "La décomposition des dettes nécessite des données de rapports de crédit et de vérification financière. Cette information peut toujours être en cours de traitement ou indisponible."

#. js-lingui-id: qd1h8Q
msgid "No documents available"
msgstr "Aucun document disponible"

#. js-lingui-id: qer7sv
msgid "Financial strain possible. Consider additional verification"
msgstr "Strain financier possible. Considérer une vérification supplémentaire"

#. js-lingui-id: qg4y3S
msgid "Enter a valid email"
msgstr "Entrez un e-mail valide"

#. js-lingui-id: qiHkqZ
msgid "Your payment is complete."
msgstr "Votre paiement est terminé."

#. js-lingui-id: qjIzrT
msgid "Bankruptcies"
msgstr "Faillite"

#. js-lingui-id: qkP6F0
msgid "The listed monthly rent (${monthlyRent}) appears unusually low for an accurate affordability analysis. Please verify the rental information."
msgstr "Le loyer mensuel listé (${monthlyRent}) apparaît anormalement bas pour une analyse d'accessibilité précise. Veuillez vérifier les informations de location."

#. js-lingui-id: qmORKj
msgid "Select Building"
msgstr "Sélectionnez le bâtiment"

#. js-lingui-id: qoL5B+
msgid "How many people are allowed?"
msgstr "Combien de personnes sont autorisées?"

#. js-lingui-id: qqLY+j
msgid "Customization"
msgstr "Personnalisation"

#. js-lingui-id: qqWcBV
msgid "Completed"
msgstr "Complété"

#. js-lingui-id: qr6NSa
msgid "Internal processes"
msgstr "Processus internes"

#. js-lingui-id: qtLIFQ
msgid "Common Filters"
msgstr "Filtres communs"

#. js-lingui-id: qu74CH
msgid "An error occurred while processing your payment"
msgstr "Une erreur s'est produite lors du traitement de votre paiement"

#. js-lingui-id: qvQog4
msgid "Studio"
msgstr "Studio"

#. js-lingui-id: qwU6TW
msgid "One-time payment"
msgstr "Paiement unique"

#. js-lingui-id: qwmdAk
msgid "High credit utilization may negatively impact credit score. Consider reducing utilization below 70%."
msgstr "Une utilisation élevée du crédit peut négativement affecter le score de crédit. Considérez réduire l'utilisation en dessous de 70%."

#. js-lingui-id: r/JRtv
msgid "Quebec rental board decisions"
msgstr "Décisions du Conseil de location du Québec"

#. js-lingui-id: r0A7jg
msgid "See all photos"
msgstr "Voir toutes les photos"

#. js-lingui-id: r2mYrt
msgid "Credit check price must be greater than or equal to 0"
msgstr "Le prix de la vérification de crédit doit être supérieur ou égal à 0"

#. js-lingui-id: r4vBzc
msgid "Document Upload"
msgstr "Téléversement de documents"

#. js-lingui-id: r5FOa9
msgid "Enter email address"
msgstr "Entrez l'adresse e-mail"

#. js-lingui-id: r6k9wx
msgid "Recent Pay Stubs (last 3 months)"
msgstr "Bulletins de paie (derniers 3 mois)"

#. js-lingui-id: r6w7Qs
msgid "Employment history verification"
msgstr "Vérification de l'historique professionnel"

#. js-lingui-id: r6y+jM
msgid "Warning"
msgstr "Attention"

#. js-lingui-id: r7H0Xz
msgid "Property Management Company Logo"
msgstr "Logo de l'entreprise de gestion de propriété"

#. js-lingui-id: rJDHoM
msgid "Share application link"
msgstr "Partager le lien de candidature"

#. js-lingui-id: rJytxG
msgid "Animals"
msgstr "Animaux"

#. js-lingui-id: rNisc9
msgid "Proof of income"
msgstr "Preuve de revenu"

#. js-lingui-id: rNjtgJ
msgid "I understand that submitting this application does not guarantee approval and that property managers will make the final decision based on their criteria."
msgstr "Je comprends que la soumission de cette demande ne garantit pas l'approbation et que les gestionnaires immobiliers prendront la décision finale en fonction de leurs critères."

#. js-lingui-id: rSJOTq
msgid "Risk Summary"
msgstr "Résumé des risques"

#. js-lingui-id: rUNM3H
msgid "Exceptional"
msgstr "Exceptionnel"

#. js-lingui-id: rVCeLt
msgid "Enter your Analytics tracking ID (e.g., UA-XXXXXXXXX-X or G-XXXXXXXXXX)"
msgstr "Entrez votre ID de suivi Analytics (par exemple, UA-XXXXXXXXX-X ou G-XXXXXXXXXX)"

#. js-lingui-id: rZurQn
msgid "Promoted"
msgstr "Promu"

#. js-lingui-id: rg+U05
msgid "Featured Image"
msgstr "Image à la une"

#. js-lingui-id: rhoX4c
msgid "{value, plural, one {bedroom} two {bedrooms} other {bedrooms}}"
msgstr "{value, plural, one {chambre} two {chambres} other {chambres}}"

#. js-lingui-id: rll8wj
msgid "Your application needs attention. The property manager has left you a message below."
msgstr "Votre candidature nécessite une attention. Le propriétaire a laissé un message ci-dessous."

#. js-lingui-id: rnmGTr
msgid "The tenant will receive application updates at this email address"
msgstr "Le locataire recevra les mises à jour de la candidature à cette adresse e-mail"

#. js-lingui-id: roqqY2
msgid "Contact Information"
msgstr "Coordonnées"

#. js-lingui-id: rpQ2WQ
msgid "Save Banner Text"
msgstr "Enregistrer le texte de la bannière"

#. js-lingui-id: rptTLk
msgid "When an agent changes a unit price by more than the configured amount, send back to new entry."
msgstr "Lorsqu'un agent modifie le prix d'une unité de plus que le montant configuré, renvoyer à la nouvelle entrée."

#. js-lingui-id: rr48zN
msgid "Application process started - {calculatedSections} sections remaining"
msgstr "Processus de candidature commencé - {calculatedSections} sections restantes"

#. js-lingui-id: rsVtpX
msgid "Create Building"
msgstr "Créer un bâtiment"

#. js-lingui-id: rwgU2o
msgid "From {price}$"
msgstr "De {price}$"

#. js-lingui-id: rxWA39
msgid "Welcome back!"
msgstr "Content de te revoir!"

#. js-lingui-id: ryGlb7
msgid "Weekly:"
msgstr "Par semaine:"

#. js-lingui-id: rz6s8e
msgid "Snoozed"
msgstr "En Veille"

#. js-lingui-id: s/alvt
msgid "Example: Please provide the requested documents by the specified date to continue processing your application."
msgstr "Exemple: Veuillez fournir les documents demandés avant la date spécifiée pour continuer le traitement de votre candidature."

#. js-lingui-id: s/ereB
msgid "active"
msgstr "actif"

#. js-lingui-id: s62/cY
msgid "All rental properties"
msgstr "Toutes les propriétés de location"

#. js-lingui-id: s8IgPz
msgid "Income Qualification"
msgstr "Qualification des revenus"

#. js-lingui-id: sCtyHQ
msgid "Upload files"
msgstr "Téléverser des fichiers"

#. js-lingui-id: sJYPeP
msgid "Personal Details"
msgstr "Informations personnelles"

#. js-lingui-id: sKKp1Z
msgid "Start by assigning an agent to a submission"
msgstr "Commencez par affecter un agent à une soumission"

#. js-lingui-id: sTB2vw
msgid "The tenant could be accepted if they give"
msgstr "Le locataire pourrait être accepté s'ils donnent"

#. js-lingui-id: sYM08M
msgid "We are going to create your administrator account and you will be able to explore what makes Eversa great !"
msgstr "Nous allons créer votre compte administrateur et vous pourrez explorer ce qui rend Eversa génial !"

#. js-lingui-id: sZ4zMa
msgid "Your Environment has just been Launched"
msgstr "Votre environnement vient d'être lancé"

#. js-lingui-id: sgXaIn
msgid "Configure payment settings and requirements for rental applications"
msgstr "Configurer les paramètres de paiement et les exigences pour les candidatures de location"

#. js-lingui-id: slD65k
msgid "Applicant's email"
msgstr "Email du candidat"

#. js-lingui-id: smWh7D
msgid "Potential financial strain with {displayDebtRatioPCT} debt ratio. Rent (${monthlyRent}) is {rangeLabel} maximum budget (${displayMaxRent})."
msgstr "Potentielle pression financière avec un ratio de dette de {displayDebtRatioPCT}. Le loyer (${monthlyRent}) est {rangeLabel} du budget maximum (${displayMaxRent})."

#. js-lingui-id: soOV+a
msgid "Search by applicant name, ID, or address"
msgstr "Recherche par nom, ID ou adresse du candidat"

#. js-lingui-id: soxPFU
msgid "Last Payment"
msgstr "Dernier paiement"

#. js-lingui-id: sr0UJD
msgid "Go Back"
msgstr "Retour"

#. js-lingui-id: sr3b7J
msgid "We will not be more than <strong>{limit}</strong> people who will live in the accommodation, including the children"
msgstr "Nous ne serons plus de <strong>{limit}</strong> personnes qui vivront dans l'hébergement, y compris les enfants"

#. js-lingui-id: ssJCAn
msgid "Normal Risk"
msgstr "Risque normal"

#. js-lingui-id: stDiC6
msgid "Add Another Address"
msgstr "Ajouter une autre adresse"

#. js-lingui-id: sxMe+f
msgid "An email has been sent to {email}"
msgstr "Un e-mail a été envoyé à {email}"

#. js-lingui-id: sxkWRg
msgid "Advanced"
msgstr "Avancé"

#. js-lingui-id: szkz0e
msgid "Phone is required"
msgstr "Le numéro de téléphone est requis"

#. js-lingui-id: t/G6u4
msgid "Online lenders with standard rates"
msgstr "Prêteurs en ligne avec des taux standard"

#. js-lingui-id: t/YqKh
msgid "Remove"
msgstr "Retirer"

#. js-lingui-id: t0aIZQ
msgid "This applicant does not have any harmful background information"
msgstr "Ce candidat ne dispose d'aucune information d'antécédents préjudiciable"

#. js-lingui-id: t45b0O
msgid "Bathrooms"
msgstr "Salles de bain"

#. js-lingui-id: t58Fcj
msgid "File type"
msgstr "Type de fichier"

#. js-lingui-id: t6dDZf
msgid "Time remaining"
msgstr "Temps restant"

#. js-lingui-id: t9c3NB
msgid "Completed on {electricityDate}"
msgstr "Complété le {electricityDate}"

#. js-lingui-id: t9u0Gc
msgid "No files uploaded yet."
msgstr "Aucun fichier téléverser pour l'instant."

#. js-lingui-id: tDTrQ6
msgid "Make tenants pay for their application before they can submit it."
msgstr "Faire payer les locataires pour leur candidature avant qu'ils ne puissent la soumettre."

#. js-lingui-id: tEL1SL
msgid "Open applicant form"
msgstr "Ouvrir le formulaire du candidat"

#. js-lingui-id: tF7kSs
msgid "Credit Utilization"
msgstr "Utilisation du crédit"

#. js-lingui-id: tGNn2o
msgid "Application Rejected"
msgstr "Candidature rejetée"

#. js-lingui-id: tGl67c
msgid "Monthly Salary:"
msgstr "Salaire mensuel:"

#. js-lingui-id: tI215L
msgid "Manage your webhook endpoint"
msgstr "Gérez votre point de terminaison webhook"

#. js-lingui-id: tKaLQd
msgid "Select a submission or invite someone to apply"
msgstr "Selectionné une soumission ou invité une personne a appliqué"

#. js-lingui-id: tKgiqP
msgid "Provide clear instructions about what the tenant needs to do to have their application reconsidered."
msgstr "Fournissez des instructions claires sur ce que le locataire doit faire pour que sa candidature soit réexaminée."

#. js-lingui-id: tLXj4b
msgid "Hide 'Chosen' Category"
msgstr "Masquer la catégorie 'Choisi'"

#. js-lingui-id: tMOPL4
msgid "Your spouse or partner"
msgstr "Votre conjoint ou partenaire"

#. js-lingui-id: tOhm/A
msgid "Are you sure you want to delete this lead?"
msgstr "Êtes-vous sûr de vouloir supprimer ce prospect?"

#. js-lingui-id: tPrmjP
msgid "Address:"
msgstr "Adresse:"

#. js-lingui-id: tYLILB
msgid "Communication Timeline"
msgstr "Chronologie des communications"

#. js-lingui-id: tZ/8mF
msgid "Add other required documents"
msgstr "Ajouter d'autres documents requis"

#. js-lingui-id: tZxz1B
msgid "Manage buildings in this project"
msgstr "Gérer les bâtiments dans ce projet"

#. js-lingui-id: tfDRzk
msgid "Save"
msgstr "Enregistrer"

#. js-lingui-id: tgsqn1
msgid "Credit Inquiries"
msgstr "Demandes de crédit"

#. js-lingui-id: tid3OS
msgid "Debts Utilization Trends (Past 12 months)"
msgstr "Tendances d'utilisation des dettes (12 derniers mois)"

#. js-lingui-id: tlRI/Q
msgid "Monthly Income"
msgstr "Revenu mensuel"

#. js-lingui-id: tnD91w
msgid "Enter the full property address..."
msgstr "Saisissez l'adresse complète de la propriété..."

#. js-lingui-id: tv8QM/
msgid "The electricity bill ownership has not been transferred to the tenant."
msgstr "La propriété de la facture d'électricité n'a pas été transférée au locataire."

#. js-lingui-id: tvvrXQ
msgid "Min sqft"
msgstr "Min pieds carrés"

#. js-lingui-id: tzSAJQ
msgid "Send my application for review"
msgstr "Envoyer ma candidature pour examen"

#. js-lingui-id: u+SBsP
msgid "How does Eversa provide tenant credit reports for free?"
msgstr "Comment Eversa fournit-il des rapports de crédit des locataires gratuitement?"

#. js-lingui-id: u/fuB6
msgid "I certify that I have an annual income of at least <strong>{limit}$ CAD</strong>"
msgstr "Je certifie avoir un revenu annuel d'au moins <strong>{limit}$ CAD</strong>"

#. js-lingui-id: u/y58m
msgid "Your most recent pay stubs from the last 3 months"
msgstr "Vos justificatifs de paie récents des 3 derniers mois"

#. js-lingui-id: u529Qw
msgid "Your applicants on this submission"
msgstr "Vos candidats pour cette soumission"

#. js-lingui-id: u6R3pO
msgid "Select a Unit"
msgstr "Sélectionner une unité"

#. js-lingui-id: uAQUqI
msgid "Status"
msgstr "Statut"

#. js-lingui-id: uBQtcp
msgid "Latest Tax Assessment"
msgstr "Dernière évaluation fiscale"

#. js-lingui-id: uCGJnY
msgid "Setting conditions allows the tenant to reapply once they meet your requirements"
msgstr "Définir des conditions permet au locataire de soumettre à nouveau une fois qu'il aura rempli vos exigences"

#. js-lingui-id: uDfc2W
msgid "Finding the right place takes time. Let us help you discover other properties that match your preferences and needs."
msgstr "Trouver le bon endroit prend du temps. Laissez-nous vous aider à découvrir d'autres propriétés qui correspondent à vos préférences et besoins."

#. js-lingui-id: uDrt8M
msgid "Dark Logo"
msgstr "Logo sombre"

#. js-lingui-id: uEmTBH
msgid "Please sign in to continue"
msgstr "Veuillez vous connecter pour continuer"

#. js-lingui-id: uEsnqP
msgid "Written off"
msgstr "Radié"

#. js-lingui-id: uGJHZ+
msgid "Daily summary of activities and updates for listings and inquiries"
msgstr "Résumé quotidien des activités et des mises à jour pour les annonces et les demandes"

#. js-lingui-id: uJ+Ve2
msgid "Region"
msgstr "Région"

#. js-lingui-id: uUehLT
msgid "Waiting"
msgstr "En attente"

#. js-lingui-id: uW0HMo
msgid "Message to tenant"
msgstr "Message au locataire"

#. js-lingui-id: uXJkRJ
msgid "Enter date of birth"
msgstr "Entrez la date de naissance"

#. js-lingui-id: uXsB4R
msgid "Staff"
msgstr "Gestionnaire"

#. js-lingui-id: uZ1Oce
msgid "Edit lead"
msgstr "Modifier le prospect"

#. js-lingui-id: ucgZ0o
msgid "Organization"
msgstr "Organisation"

#. js-lingui-id: udG6YF
msgid "Creditor"
msgstr "Créancier"

#. js-lingui-id: uekMUe
msgid "Credit score"
msgstr "Score de crédit"

#. js-lingui-id: ugEMJY
msgid "Applications Reports"
msgstr "Rapports de candidatures"

#. js-lingui-id: ujb7Qp
msgid "Current Plan"
msgstr "Plan actuel"

#. js-lingui-id: ulw+Wr
msgid "Original Balance"
msgstr "Solde original"

#. js-lingui-id: upwQ06
msgid "Unit duplicated successfully"
msgstr "Unité dupliquée avec succès"

#. js-lingui-id: uurk+S
msgid "Occupancy Rate"
msgstr "Taux d'occupation"

#. js-lingui-id: uvIJKC
msgid "Create Listing"
msgstr "Créer une Annonce"

#. js-lingui-id: uwI8Dd
msgid "This payment covers the landlord's review of your application, including:"
msgstr "Ce paiement couvre l'examen du propriétaire de votre candidature, y compris:"

#. js-lingui-id: uyILW5
msgid "View as agent:"
msgstr "Voir en tant que agent:"

#. js-lingui-id: v1DfBC
msgid "Create a new building for this project"
msgstr "Créer un nouveau bâtiment pour ce projet"

#. js-lingui-id: v3C6ky
msgid "Update the tenant's information and application details"
msgstr "Mettre à jour les informations du locataire et les détails de la demande"

#. js-lingui-id: v7dfDY
msgid "Invalid code. Please try again."
msgstr "Code expiré ou invalide. Veuillez réessayer."

#. js-lingui-id: vC6cDj
msgid "Agents have limited access focused on day-to-day operations. They cannot access sensitive settings or manage team members."
msgstr "Les agents ont un accès limité concentré sur les opérations quotidiennes. Ils ne peuvent pas accéder aux paramètres sensibles ou gérer les membres de l'équipe."

#. js-lingui-id: vERlcd
msgid "Profile"
msgstr "Profil"

#. js-lingui-id: vHrHkm
msgid "Base fee"
msgstr "Frais de base"

#. js-lingui-id: vLs6n/
msgid "Send invitation email to the applicant"
msgstr "Envoyer un email d'invitation au candidat"

#. js-lingui-id: vLyv1R
msgid "Hide"
msgstr "Masquer"

#. js-lingui-id: vVWAuV
msgid "Enter building name"
msgstr "Entrez le nom du bâtiment"

#. js-lingui-id: vVadet
msgid "Drop your files here or click to browse"
msgstr "Glissez vos fichiers ici ou cliquez pour parcourir"

#. js-lingui-id: vW+T+d
msgid "An unknown error occurred"
msgstr "Une erreur inconnue s'est produite"

#. js-lingui-id: vXIe7J
msgid "Language"
msgstr "Langue"

#. js-lingui-id: vXPSuB
msgid "Update profile"
msgstr "Mettre à jour le profil"

#. js-lingui-id: vZbKTc
msgid "{city} rental: {type} with {bedrooms} bedrooms for rent by {tenantName}"
msgstr "Location {city}: {type} {bedrooms} chambres à louer par {tenantName}"

#. js-lingui-id: vZloPi
msgid "Student housing"
msgstr "Logements étudiants"

#. js-lingui-id: vbZwfI
msgid "Last update:"
msgstr "Dernière mise à jour :"

#. js-lingui-id: vc8/JX
msgid "Monthly payment"
msgstr "Paiement mensuel"

#. js-lingui-id: vdvXiO
msgid "This unit costs "
msgstr "Cette unité coûte "

#. js-lingui-id: ve9JTU
msgid "Last name is required"
msgstr "Le nom de famille est requis"

#. js-lingui-id: vhJinC
msgid "Visiting"
msgstr "En visite"

#. js-lingui-id: viN70j
msgid "Missed Payments"
msgstr "Paiements manqués"

#. js-lingui-id: vicmFE
msgid "Bank statement showing available funds"
msgstr "Extrait bancaire montrant les fonds disponibles"

#. js-lingui-id: vij+ii
msgid "Bank statements from the last 3 months"
msgstr "Relevés bancaires des 3 derniers mois"

#. js-lingui-id: vpAgJR
msgid "View on website"
msgstr "Voir sur le site web"

#. js-lingui-id: vpKmdr
msgid "Smoking Allowed?"
msgstr "Fumeur Autorisé?"

#. js-lingui-id: vq2WxD
msgid "Tue"
msgstr "Mar"

#. js-lingui-id: vrnnn9
msgid "Processing"
msgstr "En traitement"

#. js-lingui-id: vsCoTE
msgid "Time in process"
msgstr "Temps en traitement"

#. js-lingui-id: vv7kpg
msgid "Cancelled"
msgstr "Annulé"

#. js-lingui-id: vwH9Qa
msgid "Technical Support:"
msgstr "Support technique:"

#. js-lingui-id: w/cI8L
msgid "A valid government-issued photo ID such as a driver's license or passport"
msgstr "Une pièce d'identité valide émise par un gouvernement, telle qu'une licence de conduite ou un passeport"

#. js-lingui-id: w00zlN
msgid "Warning: By not providing your Social Insurance Number, you may face delays or difficulties in obtaining a credit report, as this information helps verify your identity. If we can't find a report, you may be forced to provide additional details and/or pay additional fees for us to process your application."
msgstr "Attention : En ne fournissant pas votre numéro d'assurance sociale, vous risquez de rencontrer des retards ou des difficultés pour obtenir un rapport de crédit, car cette information aide à vérifier votre identité. Si nous ne trouvons pas de rapport, vous devrez peut-être fournir des informations supplémentaires et/ou payer des frais supplémentaires pour que nous puissions traiter votre candidature."

#. js-lingui-id: w0A0UE
msgid "I'm living with my parents"
msgstr "Je vis avec mes parents"

#. js-lingui-id: w2zb+v
msgid "Who has access to my application information?"
msgstr "Qui a accès aux informations de ma candidature?"

#. js-lingui-id: w4PY79
msgid "Find a unit that's right for you."
msgstr "Trouvez une unité qui vous convient."

#. js-lingui-id: wBMWsJ
msgid "Project Address"
msgstr "Adresse du projet"

#. js-lingui-id: wBW91V
msgid "Not provided"
msgstr "Pas fourni"

#. js-lingui-id: wHxJQq
msgid "No applicants found"
msgstr "Aucun candidat trouvé"

#. js-lingui-id: wJijgU
msgid "Location"
msgstr "Emplacement"

#. js-lingui-id: wNuh6Y
msgid "Add New Building"
msgstr "Ajouter un nouveau bâtiment"

#. js-lingui-id: wO5Zi3
msgid "Visit Agent Details"
msgstr "Détails de l'agent de visite"

#. js-lingui-id: wQYgJ7
msgid "External Promotion"
msgstr "Promotion externe"

#. js-lingui-id: wWPAtV
msgid "sqft"
msgstr "pieds carrés"

#. js-lingui-id: wYOeEe
msgid "Meets Required Ratio"
msgstr "Répond au ratio requis"

#. js-lingui-id: wZ5gKd
msgid "Submission Workflow"
msgstr "Flux de soumission"

#. js-lingui-id: waLOUb
msgid "Enter phone number"
msgstr "Entrez le numéro de téléphone"

#. js-lingui-id: wfJoeV
msgid "Submission Assignment"
msgstr "Soumission Assignées"

#. js-lingui-id: wfKu6T
msgid "Manage your organization settings."
msgstr "Gérer les paramètres de votre organisation."

#. js-lingui-id: wg5NvF
msgid "{city}: {type} with {bedrooms} bedrooms for rent by {tenantName}"
msgstr "{city}: {type} de {bedrooms} chambres à louer par {tenantName}"

#. js-lingui-id: wiryFV
msgid "Create Tenant"
msgstr "Créer un locataire"

#. js-lingui-id: woCTcH
msgid "Enter price"
msgstr "Entrez le prix"

#. js-lingui-id: wqTYGd
msgid "Write description"
msgstr "Rédiger une description"

#. js-lingui-id: wtD38R
msgid "Social security number"
msgstr "Numéro d'assurance sociale"

#. js-lingui-id: wtuVU4
msgid "Frequency"
msgstr "Fréquence"

#. js-lingui-id: wvJa+N
msgid "Identity proof"
msgstr "Preuve d'identité"

#. js-lingui-id: wwiTff
msgid "Email Verification"
msgstr "Vérification de l'email"

#. js-lingui-id: wwssS3
msgid "Submission details"
msgstr "Détails de la soumission"

#. js-lingui-id: wxPVRP
msgid "Profile of {name}"
msgstr "Profil de {name}"

#. js-lingui-id: wzqqS+
msgid "Key Features"
msgstr "Fonctionnalités clés"

#. js-lingui-id: x1Prl9
msgid "Important Notice - Credit Check"
msgstr "Avis important - Vérification de crédit"

#. js-lingui-id: x2M4j/
msgid "Fill out your personal details on the application form"
msgstr "Remplissez vos informations personnelles dans le formulaire de candidature"

#. js-lingui-id: x7aiKJ
msgid "Allow Co-Applicants"
msgstr "Autoriser les co-locataires"

#. js-lingui-id: xCJdfg
msgid "Clear"
msgstr "Effacer"

#. js-lingui-id: xChGGW
msgid "Sex offender registry check"
msgstr "Vérification du registre des délinquants sexuels"

#. js-lingui-id: xDDDyb
msgid "Apply securely online"
msgstr "Postulez en ligne en toute sécurité"

#. js-lingui-id: xGVfLh
msgid "Continue"
msgstr "Continuer"

#. js-lingui-id: xIpn/4
msgid "High utilization - consider reducing"
msgstr "Utilisation élevée - considérer la réduction"

#. js-lingui-id: xJDnl+
msgid "Re-open"
msgstr "Rouvrir"

#. js-lingui-id: xKYFTw
msgid "You'll receive email notifications about your application status, including requests for additional information and final decisions. You can also check your application status anytime through your tenant portal."
msgstr "Vous recevrez des notifications par e-mail concernant l'état de votre candidature, y compris les demandes d'informations supplémentaires et les décisions finales. Vous pouvez également vérifier l'état de votre candidature à tout moment via votre portail locataire."

#. js-lingui-id: xL8XZS
msgid "Listings View"
msgstr "Vue des annonces"

#. js-lingui-id: xNAvO7
msgid "Provide extra proof of financial stability"
msgstr "Fournir une preuve supplémentaire de stabilité financière"

#. js-lingui-id: xPOvqP
msgid "Moderate financial profile with {displayDebtRatioPCT} debt ratio. Rent (${monthlyRent}) is within recommended budget (max ${displayMaxRent})."
msgstr "Profil financier modéré avec un ratio de dette de {displayDebtRatioPCT}. Le loyer (${monthlyRent}) est dans le budget recommandé (max ${displayMaxRent})."

#. js-lingui-id: xRzh4F
msgid "This application has been rejected with condition until <0>{formatedDate}</0> while we wait for additional information from the applicant."
msgstr "Cette candidature a été rejetée avec condition jusqu'au <0>{formatedDate}</0> pendant que nous attendons des informations supplémentaires de la part du candidat."

#. js-lingui-id: xST6lc
msgid "Enter your Ads Conversion ID (e.g., AW-XXXXXXXXX/X)"
msgstr "Entrez votre ID de conversion d'annonces (par exemple, AW-XXXXXXXXX/X)"

#. js-lingui-id: xUgUTh
msgid "Enter first name"
msgstr "Entrez le prénom"

#. js-lingui-id: xVhQZV
msgid "Fri"
msgstr "Ven"

#. js-lingui-id: xYilR2
msgid "Media"
msgstr "Médias"

#. js-lingui-id: xadA+H
msgid "Select a reason for rejection"
msgstr "Sélectionnez une raison de rejet"

#. js-lingui-id: xdc4b1
msgid "SIN cannot start with 0"
msgstr "Le numéro de sécurité sociale ne peut pas commencer par 0"

#. js-lingui-id: xfpSug
msgid "Debt-to-Income Ratio Limit"
msgstr "Limite du ratio dette/revenus"

#. js-lingui-id: xgABd1
msgid "You can activate this feature to let tenants know you will refund their application if they are chosen"
msgstr "Vous pouvez activer cette fonctionnalité pour informer les locataires que vous rembourserez leur candidature s'ils sont choisis"

#. js-lingui-id: xgWM7n
msgid "Website Features"
msgstr "Fonctionnalités du site web"

#. js-lingui-id: xleo2L
msgid "Unnamed Project"
msgstr "Projet sans nom"

#. js-lingui-id: xowcRf
msgid "Terms of Service"
msgstr "Conditions d'utilisation"

#. js-lingui-id: xt8m+1
msgid "Financial data is not available at the moment."
msgstr "Les données financières ne sont pas disponibles pour le moment."

#. js-lingui-id: xtAV07
msgid "Strong financial profile with {displayDebtRatioPCT} debt ratio. Rent (${monthlyRent}) is within comfortable budget (max ${displayMaxRent})."
msgstr "Profil financier solide avec un ratio de dette de {displayDebtRatioPCT}. Le loyer (${monthlyRent}) est dans le budget confortable (max ${displayMaxRent})."

#. js-lingui-id: xtVMrp
msgid "Building Rules"
msgstr "Règles de l'immeuble"

#. js-lingui-id: xuqEo1
msgid "What information do you collect and store?"
msgstr "Quelles informations collectez-vous et stockez-vous ?"

#. js-lingui-id: xwQRuc
msgid "Enter listing description in English"
msgstr "Entrez la description de l'annonce en anglais"

#. js-lingui-id: xxsw3W
msgid "Income"
msgstr "Revenu"

#. js-lingui-id: y/0uwd
msgid "Yesterday"
msgstr "Hier"

#. js-lingui-id: y1IX+e
msgid "Additional Co-Applicants"
msgstr "Co-applicants supplémentaires"

#. js-lingui-id: y1mxvW
msgid "Add a co-signer for additional security"
msgstr "Ajouter un co-signataire pour une sécurité supplémentaire"

#. js-lingui-id: y58u1a
msgid "A parent or endorser who can support your application"
msgstr "Un parent ou un endosseur qui peut soutenir votre candidature"

#. js-lingui-id: y5GZtQ
msgid "Listing ID is required"
msgstr "L'identifiant de l'annonce est requis"

#. js-lingui-id: y6V3iP
msgid "The tenant has paid the deposit and the financial information has been verified."
msgstr "Le locataire a payé le dépôt et les informations financières ont été vérifiées."

#. js-lingui-id: y9pBle
msgid "Contact Phone Number"
msgstr "Numéro de téléphone de contact"

#. js-lingui-id: yCVzGD
msgid "Liability Amount"
msgstr "Montant de la dette"

#. js-lingui-id: yFRXKt
msgid "Rent to Income"
msgstr "Loyer/Revenu"

#. js-lingui-id: yG2qjp
msgid "To be signed"
msgstr "À signer"

#. js-lingui-id: yIeIf2
msgid "Restore lead"
msgstr "Restaurer le prospect"

#. js-lingui-id: yS25z6
msgid "All residential rentals"
msgstr "Toutes les locations résidentielles"

#. js-lingui-id: yTaKp/
msgid "Agent Portal"
msgstr "Portail de l'agent"

#. js-lingui-id: yYDKjE
msgid "Upload Document"
msgstr "Télécharger un document"

#. js-lingui-id: yYxB17
msgid "Clear all"
msgstr "Tout effacer"

#. js-lingui-id: yZvjVv
msgid "Try using a different browser, or a different device"
msgstr "Essayez d'utiliser un navigateur différent, ou un appareil différent"

#. js-lingui-id: ycMMt1
msgid "Review and approve the consents required for your application"
msgstr "Examinez et approuvez les consentements nécessaires pour votre candidature"

#. js-lingui-id: ycZ2l4
msgid "It looks like you don't have submissions yet"
msgstr "Il semble que vous n'ayez pas encore de soumissions"

#. js-lingui-id: yca4wa
msgid "You have been invited to join this workspace."
msgstr "Vous avez été invité à rejoindre cet espace de travail."

#. js-lingui-id: yixoBN
msgid "Exact Match"
msgstr "Correspondance exacte"

#. js-lingui-id: yjAr5D
msgid "Your application requires an additional applicant to proceed. This could be:"
msgstr "Votre candidature nécessite un candidat supplémentaire pour continuer. Cela pourrait être :"

#. js-lingui-id: ylkOkk
msgid "Providing extra proof of income, savings, or other financial assets may help support your application."
msgstr "Fournir une preuve supplémentaire de revenus, d'épargne ou d'autres actifs financiers peut aider à soutenir votre candidature."

#. js-lingui-id: ynIIm/
msgid "{nbImages, plural, other {+ {nbImages} photos} one {one photo} two {two photos}}"
msgstr "{nbImages, plural, other {+ {nbImages} photos} one {une photo} two {deux photos}}"

#. js-lingui-id: yqDxLg
msgid "Company Address"
msgstr "Adresse de l'entreprise"

#. js-lingui-id: yt9SZ/
msgid "Registered on"
msgstr "Enregistré le"

#. js-lingui-id: yvxSxj
msgid "Unassigned leads"
msgstr "Prospects non assignés"

#. js-lingui-id: yx/fMc
msgid "High"
msgstr "Élevé"

#. js-lingui-id: yxJoM9
msgid "Is this unit currently occupied?"
msgstr "Cette unité est-elle actuellement occupée ?"

#. js-lingui-id: yz7wBu
msgid "Close"
msgstr "Fermer"

#. js-lingui-id: z1U/Fh
msgid "Rating"
msgstr "Évaluation"

#. js-lingui-id: z2TQ0s
msgid "Smoking"
msgstr "Fumeur"

#. js-lingui-id: z2W2h2
msgid "Credit Check"
msgstr "Vérification de crédit"

#. js-lingui-id: z4+VzX
msgid "Contact History"
msgstr "Historique des contacts"

#. js-lingui-id: z6hOBH
msgid "All requested documents have been uploaded."
msgstr "Tous les documents demandés ont été téléchargés."

#. js-lingui-id: z8LWu2
msgid "Project data is not available"
msgstr "Les données du projet ne sont pas disponibles"

#. js-lingui-id: z8vnmb
msgid "<0>months</0> of payment in advance"
msgstr "<0>mois</0> de paiement à l'avance"

#. js-lingui-id: zDJYZ5
msgid "Calculated Monthly Income"
msgstr "Revenu mensuel calculé"

#. js-lingui-id: zDivex
msgid "Enter reason for cancellation"
msgstr "Entrez la raison de l'annulation"

#. js-lingui-id: zE9Yd+
msgid "Traditional banks with competitive rates"
msgstr "Banques traditionnelles avec des taux compétitifs"

#. js-lingui-id: zFaTAT
msgid "Listing Status"
msgstr "Statut de l'annonce"

#. js-lingui-id: zFrh3M
msgid "Invite Tenant"
msgstr "Inviter un locataire"

#. js-lingui-id: zKHn6T
msgid "Send your accommodation request easily and securely online with our web application form"
msgstr "Envoyez facilement et en toute sécurité votre demande de logement en ligne avec notre formulaire de demande en ligne"

#. js-lingui-id: zR3Uwj
msgid "Run this check to verify income, debts and payment history."
msgstr "Exécutez cette vérification pour vérifier les revenus, les dettes et l'historique des paiements."

#. js-lingui-id: zRH+YV
msgid "To proceed with the application process, a security deposit equivalent to {prepaidRentMonths} months' rent will be required as a condition of approval."
msgstr "Pour poursuivre le processus de candidature, un dépôt de garantie équivalent à {prepaidRentMonths} mois de loyer sera exigé comme condition d'approbation."

#. js-lingui-id: zTNjrI
msgid "Update Prices"
msgstr "Mettre à jour les prix"

#. js-lingui-id: zU+Ro7
msgid "Signed in as"
msgstr "Connecté en tant que"

#. js-lingui-id: zYD7lE
msgid "TAL Check"
msgstr "Vérification TAL"

#. js-lingui-id: zYU3sk
msgid "Below Required Ratio"
msgstr "En dessous du ratio requis"

#. js-lingui-id: zYV2Bg
msgid "Buildings"
msgstr "Immeubles"

#. js-lingui-id: zZ3dVu
#. placeholder {0}: amenities.length - MAX_AMENITIES
#. placeholder {1}: amenities.length - MAX_AMENITIES
msgid "{0, plural, other {+ {1} amenities} one {one amenity} two {two amenities}}"
msgstr "{0, plural, other {+ {1} commodités} one {une commodité} two {deux commodités}}"

#. js-lingui-id: zaJYvc
msgid "Enter an address..."
msgstr "Entrez une adresse..."

#. js-lingui-id: zb77GC
msgid "Rent"
msgstr "Loyer"

#. js-lingui-id: zbfHPr
msgid "We maintain strict data retention policies and only keep your information for as long as necessary to process your application. After the required retention period, your data is securely deleted from our systems."
msgstr "Nous maintenons des politiques de rétention de données strictes et ne conservons vos informations que le temps nécessaire pour traiter votre candidature. Après la période de rétention requise, vos données sont supprimées de manière sécurisée de nos systèmes."

#. js-lingui-id: zirCsS
msgid "Industry standard is 3.0x (tenant's income should be at least 3 times their monthly debt)"
msgstr "La norme de l'industrie est de 3,0x (le revenu du locataire devrait être au moins 3 fois supérieur à sa dette mensuelle)"

#. js-lingui-id: zkWmBh
msgid "Yearly"
msgstr "Annuel"

#. js-lingui-id: zl80jE
msgid "Edit Tenant Information"
msgstr "Modifier les informations du locataire"

#. js-lingui-id: zmXrJg
msgid "Create a new building"
msgstr "Créer un nouveau bâtiment"

#. js-lingui-id: zmwvG2
msgid "Phone"
msgstr "Téléphone"

#. js-lingui-id: zp88zI
msgid "Missing data"
msgstr "Données manquantes"

#. js-lingui-id: zujYom
msgid "Please enter a positive number or zero for years at your job"
msgstr "Veuillez entrer un nombre positif ou zéro pour les années de travail"

#. js-lingui-id: zy7MBs
msgid "The user will not be able to access the app."
msgstr "L'utilisateur ne pourra pas accéder à l'application."

#. js-lingui-id: zzDlyQ
msgid "Success"
msgstr "Succès"
